/*
* 전자책 뷰어 페이지
*
* 전자책 뷰어 페이지는 전자책 목록 페이지에서 전자책을 클릭하면 해당 전자책의 뷰어 페이지로 이동합니다.
* 전자책 뷰어 페이지에서는 전자책을 조회할 수 있습니다.
*/


import React, { useEffect, useLayoutEffect, useState, useRef, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import { useFontSettings } from '../../contexts/FontSettingsContext';
import { ApiPageData, ApiPageComponent, bookService } from '../../services/bookService';
import { annotationService, CreateAnnotationRequest } from '../../services/annotationService';
import { Annotation, TextRange } from '../../types/book';
import { useFrontAuthStore } from '../../auth/store/authStore';
import LearningRecordsPanel from '../../components/learning/LearningRecordsPanel';
import AILearningPanel, { ChatMessage } from '../../components/learning/AILearningPanel';
import { aiLearningService } from '../../services/aiLearningService';
import { useSyncSocketContext } from '../../contexts/SyncSocketContext';
import { useLearningRecordsCache, dispatchLearningRecordsInvalidate } from '../../contexts/LearningRecordsCacheContext';
import { LearningRecordData } from '../../services/learningRecordService';
import { sharedFolderService, FolderItem, FolderItemAnnotation, SharedFolderData } from '../../services/sharedFolderService';
import { 
  setSharedFolderAnnotationVisibility, 
  getSharedFolderAnnotationVisibility 
} from '../../utils/sharedFolderAnnotationStorage';
import apiClient from '../../../core/http/axios';
import { viewSessionService } from '../../services/viewSessionService';
import {
  NOTE_BACKGROUND_COLORS,
  NoteColorType,
  STUDENT_MARKER_COLORS,
  StudentMarkerColorType,
} from '../../constants/colors';
import {
  Container, ViewerContainer, BookViewerSplit, BookContentPanel, DropOverlayContainer, DropZoneHalf, AttachmentPanelWrapper,
  PagesContainer, PageContainer, PageDivider,
  ContentWrapper, ColumnContentWrapper, ComponentContainer, LoadingContainer, PageLoadingOverlay, LoadingSpinner, ErrorContainer,
  PageNumberMarker, PageNumberMarkerText, PageNumberWrapper,
  Navigation, NavButtonGroup, NavButton, Button, PageInfo, PageInfoInput,
  ResizablePanelsOuter, ResizablePanelsWrapper, ResizeHandleVertical, ResizeHandleHorizontal,
  FixedLearningRecordsContainer, PanelWrapper, CollapsedButton, FixedAIPanelContainer,
  SyncLocationButton, SyncLocationContent, SyncLocationIcon, SyncLocationText,
  GoBackButtonWrapper, GoBackAction, GoBackClose,
  Subtitle, Title, ParagraphText, TextContentWrapper,
  HighlightedText, UnderlinedText, HighlightMarker,
  SelectionToolbar, ToolbarRegion, ToolbarButton, DropdownMenuOverlay, DropdownMenuContainer, CopyToast,
  Overlay, StickyNoteModal, NoteModalHeader, NoteModalTitle, NoteModalHeaderActions,
  NoteModalIconButton, NoteModalContent, NoteModalTextarea, NoteModalText,
  NoteModalAttachments, AttachmentList, AttachmentItem, AttachmentName,
  AttachmentDeleteButton, AddAttachmentButton, NoteMenuDropdown, NoteMenuItem,
  NoteColorPickerDropdown, NoteColorOption, NoteModalFooter,
  Figure, FigureImagesWrapper, FigureCaption, MatrixContainer, MatrixOuterWrapper,
  MatrixRowLabel, MatrixCell, MatrixCellNumber, MatrixColumnLabelSpacer,
  MatrixColumnLabel, FigureDescription, FigureTitle, FigureNote,
  TableComponentContainer, TableContainer, StyledTable, TableCaption, Footnote, FigureSource,
  // [주석처리] 표 내용 보기 기능 비활성화
  // TableViewButton, TableModalOverlay, TableModalContainer, TableModalHeader,
  // TableModalTitle, TableModalCloseButton, TableModalContent, ModalTable,
} from './styles';
import Modal from '../../components/ui/Modal';
import AttachmentPanel from '../../components/attachment/AttachmentPanel';
import { Attachment } from '../../services/attachmentService';
import { useAttachmentContext } from '../../contexts/AttachmentContext';
import { getSettings } from '../../services/settingsService';
import { InlineStickyNoteWrapper, AreaSelectionOverlayComponent, RecordingModalComponent, ExpandableFigureImage } from './components';
import { parseTextWithLinks } from './components/InlineStickyNoteWrapper';
import { useRecording, usePageNavigation, useGestures, usePageData } from './hooks';
import { bookUidToId, mapAnnotationsParagraphId, formatRecordingTime, parseFigureMatrix } from './utils';
import {
  getStoredPanelHeight, setStoredPanelHeight,
  getStoredPanelBottom, setStoredPanelBottom,
  getStoredLearningRecordsWidth, setStoredLearningRecordsWidth,
  getStoredLearningRecordsLeft, setStoredLearningRecordsLeft,
  getStoredAIPanelWidth, setStoredAIPanelWidth,
  getStoredAIPanelRight, setStoredAIPanelRight,
  getStoredAttachmentPanelOnLeft, setStoredAttachmentPanelOnLeft,
  getPanelSizeLimits,
} from '../../utils/panelSizeStorage';

// Optimistic update를 위한 Annotation 확장 타입
interface OptimisticAnnotation extends Annotation {
  _isOptimistic?: boolean;
  _tempId?: string;
}

// [주석처리] 표 내용 보기 기능 비활성화
// const TableModalWrapper: React.FC<{ componentId: string; pageNoDb: number; tableHeader: string[]; tableBody: string[][]; mediaNote?: string }> = ({ componentId, pageNoDb, tableHeader, tableBody, mediaNote }) => {
//   const [isOpen, setIsOpen] = React.useState(false);
//   const modalRef = React.useRef<HTMLDivElement>(null);
//   const isOpeningRef = React.useRef(false);
//   const isMountedRef = React.useRef(true);
//   const openTimeoutRef = React.useRef<NodeJS.Timeout | null>(null);
//   const pageNoDbRef = React.useRef(pageNoDb);
//   React.useEffect(() => {
//     if (pageNoDbRef.current !== pageNoDb) {
//       pageNoDbRef.current = pageNoDb;
//       setIsOpen(false);
//       isOpeningRef.current = false;
//       if (openTimeoutRef.current) {
//         clearTimeout(openTimeoutRef.current);
//         openTimeoutRef.current = null;
//       }
//     }
//   }, [pageNoDb]);
//   const handleOpen = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
//     e.stopPropagation();
//     e.preventDefault();
//     e.nativeEvent.stopImmediatePropagation();
//     if (!isMountedRef.current) return;
//     if (isOpeningRef.current) return;
//     if (openTimeoutRef.current) clearTimeout(openTimeoutRef.current);
//     isOpeningRef.current = true;
//     openTimeoutRef.current = setTimeout(() => {
//       if (isMountedRef.current) {
//         setIsOpen(prevIsOpen => {
//           if (!prevIsOpen) return true;
//           return prevIsOpen;
//         });
//       }
//       isOpeningRef.current = false;
//       openTimeoutRef.current = null;
//     }, 0);
//   }, []);
//   const handleClose = React.useCallback((source?: string) => {
//     if (!isMountedRef.current) return;
//     if (isOpeningRef.current) return;
//     if (openTimeoutRef.current) {
//       clearTimeout(openTimeoutRef.current);
//       openTimeoutRef.current = null;
//     }
//     isOpeningRef.current = false;
//     setIsOpen(false);
//   }, []);
//   const handleOverlayClick = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
//     if (e.target === e.currentTarget && isMountedRef.current) {
//       handleClose('overlay-click');
//     }
//   }, [handleClose]);
//   React.useEffect(() => {
//     if (!isOpen || !isMountedRef.current) return;
//     const handleEscape = (e: KeyboardEvent) => {
//       if (e.key === 'Escape' && isMountedRef.current) handleClose('escape-key');
//     };
//     window.addEventListener('keydown', handleEscape);
//     return () => window.removeEventListener('keydown', handleEscape);
//   }, [isOpen, handleClose]);
//   React.useEffect(() => {
//     if (!isOpen) { document.body.style.overflow = ''; return; }
//     if (!isMountedRef.current) return;
//     const previousOverflow = document.body.style.overflow;
//     document.body.style.overflow = 'hidden';
//     return () => {
//       if (isMountedRef.current) document.body.style.overflow = previousOverflow;
//     };
//   }, [isOpen]);
//   React.useEffect(() => {
//     isMountedRef.current = true;
//     return () => {
//       isMountedRef.current = false;
//       setIsOpen(false);
//       isOpeningRef.current = false;
//       if (openTimeoutRef.current) { clearTimeout(openTimeoutRef.current); openTimeoutRef.current = null; }
//     };
//   }, [pageNoDb]);
//   return (
//     <>
//       <TableComponentContainer key={componentId} data-page-no={pageNoDb}>
//         <TableViewButton
//           onClick={handleOpen}
//           onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); e.nativeEvent.stopImmediatePropagation(); isOpeningRef.current = true; }}
//           onMouseUp={(e) => { e.stopPropagation(); e.preventDefault(); e.nativeEvent.stopImmediatePropagation(); }}
//           onPointerDown={(e) => { e.stopPropagation(); e.preventDefault(); }}
//           data-table-view-button="true"
//         >
//           표 내용 보기
//         </TableViewButton>
//         {mediaNote && <TableCaption>{mediaNote}</TableCaption>}
//       </TableComponentContainer>
//       {isOpen && createPortal(
//         <TableModalOverlay ref={modalRef} data-table-modal-overlay="true" $isOpen={isOpen} onClick={handleOverlayClick}
//           onMouseDown={(e) => e.stopPropagation()}
//           style={{ zIndex: 10005, position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', visibility: 'visible', opacity: 1 }}>
//           <TableModalContainer onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}
//             style={{ zIndex: 10006, position: 'relative', visibility: 'visible', opacity: 1 }}>
//             <TableModalHeader>
//               <TableModalTitle>{mediaNote || '표 내용'}</TableModalTitle>
//               <TableModalCloseButton onClick={() => handleClose('close-button')}>×</TableModalCloseButton>
//             </TableModalHeader>
//             <TableModalContent>
//               <ModalTable>
//                 {tableHeader.length > 0 && (<thead><tr>{tableHeader.map((cell, i) => (<th key={i}>{cell}</th>))}</tr></thead>)}
//                 <tbody>{tableBody.map((row, rowIdx) => (<tr key={rowIdx}>{row.map((cell, cellIdx) => (<td key={cellIdx}>{cell}</td>))}</tr>))}</tbody>
//               </ModalTable>
//             </TableModalContent>
//           </TableModalContainer>
//         </TableModalOverlay>,
//         document.body
//       )}
//     </>
//   );
// };

const COLUMN_HEIGHT_SAFETY_FACTOR = 0.90;
const MIN_TEXT_CONSTRAINED_HEIGHT = 50;

const TEXT_KINDS = new Set(['paragraph', 'title', 'subtitle', 'header_page_number', 'footnote']);
const IMAGE_KINDS = new Set(['figure']);

const BookViewer: React.FC = () => {
  const { bookUid, pageIndex } = useParams<{ bookUid: string; pageIndex: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useFrontAuthStore();
  const isProfessor = user?.role === 'professor';
  const isStudent = user?.role === 'student';
  const { fontSettings } = useFontSettings();
  // Custom Event로 동기화 버튼 상태 관리
  const [showSyncLocationButton, setShowSyncLocationButton] = React.useState(false);
  const [syncPendingPageNo, setSyncPendingPageNo] = React.useState<number | null>(null);

  // 학습 기록 카드 클릭 후 되돌아가기 버튼 상태 (확대/축소 재로드 시 state에서 복원)
  const locationState = location.state as { forceReload?: number; forceNavigate?: number; pendingHighlightAnnotationId?: string; showGoBackButton?: boolean; goBackPageNo?: number | null; pendingComponentNo?: number | null } | null;
  const [showGoBackButton, setShowGoBackButton] = React.useState(locationState?.showGoBackButton ?? false);
  const [goBackPageNo, setGoBackPageNo] = React.useState<number | null>(locationState?.goBackPageNo ?? null);
  // 되돌아가기 시 공유폴더 모달 복원용
  const [goBackFolderUuid, setGoBackFolderUuid] = React.useState<string | null>(null);
  const [restoreFolderUuid, setRestoreFolderUuid] = React.useState<string | null>(null);
  // 강조 표시 마커 근처에 되돌아가기 버튼 배치용 (viewport 기준 top, left)
  const [highlightMarkerPosition, setHighlightMarkerPosition] = React.useState<{ top: number; left: number } | null>(null);
  
  // Context에서 onSyncLocationClick, 학습 기록 preload 가져오기
  const { onSyncLocationClick } = useSyncSocketContext();
  const cacheContext = useLearningRecordsCache();

  const preloadTriggeredRef = React.useRef<Set<string>>(new Set());
  React.useEffect(() => {
    if (!bookUid || (!isProfessor && !isStudent) || !cacheContext?.preload) return;
    if (preloadTriggeredRef.current.has(bookUid)) return;
    preloadTriggeredRef.current.add(bookUid);
    cacheContext.preload(bookUid);
  }, [bookUid, isProfessor, isStudent, cacheContext]);

  // 뷰 세션: /api-book/viewer/ 진입 시 start, 이탈 시 stop
  // React Strict Mode 이중 마운트 시 start=>stop=>start 방지: 짧은 지연 후 start 호출
  const viewSessionStartedForRef = React.useRef<string | null>(null);
  const viewSessionDidStartRef = React.useRef(false);
  React.useEffect(() => {
    if (!bookUid) return;
    if (viewSessionStartedForRef.current === bookUid) return;
    viewSessionDidStartRef.current = false;
    const timeoutId = setTimeout(() => {
      if (viewSessionStartedForRef.current === bookUid) return;
      viewSessionStartedForRef.current = bookUid;
      viewSessionDidStartRef.current = true;
      viewSessionService.start(bookUid).catch((err) => {
        // console.warn('[BookViewer] view-session start 실패:', err);
      });
    }, 50);
    return () => {
      clearTimeout(timeoutId);
      if (viewSessionDidStartRef.current) {
        const uidToStop = viewSessionStartedForRef.current;
        viewSessionStartedForRef.current = null;
        viewSessionDidStartRef.current = false;
        if (uidToStop) {
          viewSessionService.stop(uidToStop, 'USER').catch((err) => {
            // console.warn('[BookViewer] view-session stop 실패:', err);
          });
        }
      }
    };
  }, [bookUid]);

  // Custom Event 리스너 등록
  React.useEffect(() => {
    const handleSyncLocationButtonShow = (event: CustomEvent) => {
      // console.log('[BookViewer] Custom Event 수신:', event.detail);
      setShowSyncLocationButton(event.detail.showSyncLocationButton);
      setSyncPendingPageNo(event.detail.syncPendingPageNo);
    };
    
    // 공유 폴더 선택 이벤트 리스너
    const handleSharedFolderSelected = (event: CustomEvent) => {
      const folder: SharedFolderData | null = event.detail.folder || null;
      setCurrentSharedFolder(folder);
      if (folder) {
        // localStorage에서 표시 여부 로드
        const isVisible = getSharedFolderAnnotationVisibility(folder.folder_uuid);
        setSharedFolderVisibilityMap(prev => {
          const newMap = new Map(prev);
          newMap.set(folder.folder_uuid, isVisible);
          return newMap;
        });
      }
    };

    window.addEventListener('syncLocationButtonShow', handleSyncLocationButtonShow as EventListener);
    window.addEventListener('sharedFolderSelected', handleSharedFolderSelected as EventListener);
    
    return () => {
      window.removeEventListener('syncLocationButtonShow', handleSyncLocationButtonShow as EventListener);
      window.removeEventListener('sharedFolderSelected', handleSharedFolderSelected as EventListener);
    };
  }, []);
  
  // console.log('[BookViewer] 현재 상태:', {
  //   showSyncLocationButton,
  //   syncPendingPageNo,
  //   onSyncLocationClick: !!onSyncLocationClick,
  // });
  
  // 페이지 데이터 훅 사용
  const {
    pageData,
    nextPageData,
    loading,
    error,
    lastPageIndex,
    pageCacheRef,
    initialLoadedRangeRef,
    maxKnownPageRef,
    loadAdditionalPage,
    addToCache,
  } = usePageData({
    bookUid,
    pageIndex,
    isProgressLoading: false, // usePageNavigation에서 관리
    mapAnnotationsParagraphId,
    onAnnotationsLoaded: (annotations: Annotation[]) => {
      // console.log(`[onAnnotationsLoaded] 캐시/API에서 어노테이션 ${annotations.length}개 로드`);
      setAnnotations(annotations);
    },
  });
  
  // 동적 콘텐츠 로딩을 위한 ref
  const leftPageContainerRef = useRef<HTMLDivElement>(null);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  
  // 측정용 컨테이너 ref
  const measureContainerRef = useRef<HTMLDivElement>(null);
  
  // 평탄화된 컴포넌트 시스템 (왼쪽→오른쪽 순차 채우기용)
  interface FlatComponent {
    pageNo: number;           // 실제 페이지 번호 (idx) - 표시 및 네비게이션용
    pageNoDb: number;         // DB 인덱스 (page_no) - API 호출 및 data-page-no 속성용
    displayNumber: number;    // 표시용 페이지 번호 (display_number) - UI 표시용
    componentIdx: number;     // 해당 페이지 내 인덱스
    data: ApiPageComponent;   // 컴포넌트 데이터
    measuredHeight?: number;  // 측정된 높이
    constrainedHeight?: number; // 남은 공간에 맞춰 제한된 높이 (오버플로우 처리용)
  }
  // === 8페이지 단위 그룹 기반 페이지네이션 ===
  // 현재 페이지 그룹 (8페이지 단위)
  const [currentPageGroup, setCurrentPageGroup] = useState<{ start: number; end: number } | null>(null);
  // 이전 그룹으로 이동하는지 표시하는 ref (measureAndSetup에서 사용)
  const isMovingToPrevGroupRef = useRef<boolean>(false);
  // 이전 그룹으로 이동할 때 목표 페이지 번호 (현재 페이지 - 1까지 표시하기 위함)
  const targetPageForPrevGroupRef = useRef<number | null>(null);
  // 화면 분할 정보 저장 (이전 그룹 이동 시 화면 단위 이동을 위해)
  const screenGroupsRef = useRef<{ startIdx: number; endIdx: number; pages: number[] }[]>([]);
  // 현재 표시 중인 화면 인덱스 (screenGroupsRef 기준)
  const currentScreenIndexRef = useRef<number>(0);
  // 마지막으로 완료된 measureAndSetup의 키 (중복 실행 방지용)
  const lastCompletedSetupKeyRef = useRef<string | null>(null);
  // 뷰포트/줌 변경에 의한 강제 재측정 플래그 (중복 스킵 우회용)
  const isForceRemeasureRef = useRef<boolean>(false);
  // 그룹 전환 중 플래그 (다음/이전 그룹으로 이동하는 동안 중복 네비게이션 방지)
  const isGroupTransitioningRef = useRef<boolean>(false);
  
  // 로드된 모든 컴포넌트 (측정된 높이 포함)
  const [allLoadedComponents, setAllLoadedComponents] = useState<FlatComponent[]>([]);
  // allLoadedComponents의 최신 값을 항상 참조하기 위한 ref (클로저 문제 해결)
  const allLoadedComponentsRef = useRef<FlatComponent[]>([]);
  // allLoadedComponents 변경 시 ref 동기화
  useEffect(() => {
    allLoadedComponentsRef.current = allLoadedComponents;
  }, [allLoadedComponents]);
  
  // 현재 표시 시작 인덱스
  const [displayStartIndex, setDisplayStartIndex] = useState(0);
  // 현재 화면에 표시할 컴포넌트 (allLoadedComponents의 일부)
  const [displayComponents, setDisplayComponents] = useState<FlatComponent[]>([]);
  // displayComponents의 최신 값을 항상 참조하기 위한 ref (클로저 문제 해결)
  const displayComponentsRef = useRef<FlatComponent[]>([]);
  // displayComponents 변경 시 ref 동기화
  useEffect(() => {
    displayComponentsRef.current = displayComponents;
  }, [displayComponents]);
  // contentRef 선언 (렌더링 전 필요)
  const contentRef = useRef<HTMLDivElement>(null);
  // effectivePagesPerView를 참조하기 위한 ref (선언 순서 문제 해결)
  const effectivePagesPerViewRef = useRef<1 | 2>(1);

  // 현재 표시 끝 인덱스 (다음 페이지 시작점)
  const displayEndIndexRef = useRef<number>(0);
  const [loadedPageNumbers, setLoadedPageNumbers] = useState<number[]>([]); // 로드된 페이지 번호 목록
  const lastVisiblePageRef = useRef<number>(0); // 마지막으로 "완전히" 표시된 페이지 번호
  const firstVisiblePageRef = useRef<number>(0); // 첫 번째로 표시된 페이지 번호
  const [isContentReady, setIsContentReady] = useState(false); // 콘텐츠 표시 준비 완료
  // 페이지 범위별 컴포넌트 캐시 (키: "182-185", 값: FlatComponent[])
  const pageRangeCacheRef = useRef<Map<string, FlatComponent[]>>(new Map());
  // 사전 계산된 화면(screen) 배열: 측정 후 한 번에 모든 화면 경계를 계산하여 캐싱
  // 이전/다음 이동 시 이 배열의 인덱스만 변경하여 항상 동일한 페이지 분할 보장
  const precomputedScreensRef = useRef<{ startIndex: number; endIndex: number; components: FlatComponent[] }[]>([]);
  // 현재 사전 계산된 화면 중 표시 중인 인덱스
  const activeScreenIndexRef = useRef<number>(0);
  // annotation 로드 트리거 (무한 루프 방지)
  const annotationLoadTriggerRef = useRef<string>('');
  // 폰트 설정 변경 추적 (무한 루프 방지)
  const prevFontSettingsRef = useRef<{
    fontSize: number;
    fontWeight: number;
    letterSpacing: number;
    lineHeight: number;
    fontFamily: string;
  } | null>(null);
  
  // 측정 대기 중인 컴포넌트들
  const [componentsToMeasure, setComponentsToMeasure] = useState<FlatComponent[]>([]);
  const [isMeasuring, setIsMeasuring] = useState(false);
  
  // 주석 상태
  const [annotations, setAnnotations] = useState<Annotation[]>([]);
  const [selectedRange, setSelectedRange] = useState<TextRange | null>(null);
  const [selectedPageNumber, setSelectedPageNumber] = useState<number | null>(null);
  const [toolbarPosition, setToolbarPosition] = useState<{ x: number; y: number } | null>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);
  const [clickedAnnotation, setClickedAnnotation] = useState<Annotation | null>(null);
  const [editingAnnotation, setEditingAnnotation] = useState<Annotation | null>(null);
  // highlightColor는 더 이상 사용하지 않음 - STUDENT_MARKER_COLORS 사용
  const [hideAnnotations] = useState(false);
  // 학습 기록에서 클릭한 어노테이션 ID (강조 표시용)
  const [highlightedAnnotationId, setHighlightedAnnotationId] = useState<string | null>(null);
  // 학습 기록에서 클릭한 어노테이션 ID를 저장 (페이지 이동 후 어노테이션 로드 완료 시 강조 표시용)
  // 확대/축소 재로드 시 state에서 복원
  const [pendingHighlightAnnotationId, setPendingHighlightAnnotationId] = useState<string | null>(locationState?.pendingHighlightAnnotationId ?? null);
  // 학습 기록에서 클릭한 어노테이션의 component_no (화면 선택 시 해당 컴포넌트가 포함된 화면 선택용)
  const [pendingComponentNo, setPendingComponentNo] = useState<number | null>(locationState?.pendingComponentNo ?? null);
  // 학습 기록에서 메모 클릭 시 전달된 fallback (어노테이션 note가 불완전할 때 내용 보완용)
  const [pendingMemoFallback, setPendingMemoFallback] = useState<{ title: string; subject: string } | null>(null);
  // 학습 기록에서 공유 어노테이션 클릭 시 전달된 어노테이션 데이터 (annotations 배열에 없을 때 사용)
  const [pendingSharedAnnotationData, setPendingSharedAnnotationData] = useState<{ startOffset: number; endOffset: number; selectedText?: string; color?: string; type?: string } | null>(null);
  // 강조 표시 타이머 ref (cleanup을 위해)
  const highlightTimerRef = useRef<NodeJS.Timeout | null>(null);
  const hasScrolledToHighlightRef = useRef<string | null>(null);
  // 현재 선택된 공유 폴더 (헤더 토글 버튼 표시용)
  const [currentSharedFolder, setCurrentSharedFolder] = useState<SharedFolderData | null>(null);
  // 공유 폴더 어노테이션 표시 여부 Map (folder_uuid -> boolean)
  const [sharedFolderVisibilityMap, setSharedFolderVisibilityMap] = useState<Map<string, boolean>>(new Map());
  
  // 여러 문단 선택 지원
  interface MultiParagraphRange {
    pageNo: number;
    paragraphId: string;
    startOffset: number;
    endOffset: number;
    selectedText: string;
    componentIndex: number;
  }
  const [selectedRanges, setSelectedRanges] = useState<MultiParagraphRange[]>([]);
  
  // 하이라이트 드롭다운 상태
  const [showHighlightDropdown, setShowHighlightDropdown] = useState(false);
  const [highlightDropdownPosition, setHighlightDropdownPosition] = useState<{ x: number; y: number } | null>(null);
  const [showHighlightColorPicker, setShowHighlightColorPicker] = useState(false);
  const [showUnderlineColorPicker, setShowUnderlineColorPicker] = useState(false);
  const [selectedMarkerColor, setSelectedMarkerColor] = useState<StudentMarkerColorType>('pink');
  
  // 녹음 훅 사용 (일시중지, 듣기, 3시간 녹음 지원)
  const {
    isRecordingModalOpen,
    micErrorModal,
    closeMicErrorModal,
    isPermissionRequestModalOpen,
    openPermissionRequestModal,
    closePermissionRequestModal,
    confirmPermissionAndStartRecording,
    isRecording,
    isPaused,
    recordingTime,
    isUploading,
    isPlaying,
    audioChunksRef,
    fileName,
    setFileName,
    baseFileName,
    closeRecordingModal,
    closeRecordingModalOnly,
    openRecordingModal,
    startRecordingWithModal,
    pauseRecording,
    resumeRecording,
    stopRecording,
    cancelRecording,
    uploadRecording,
    resetRecording,
    playPreview,
    stopPreview,
    formatTime,
    getProgressPercent,
  } = useRecording(bookUid, pageIndex);

  // 녹음 업로드 후 학습기록 반영 전까지 보여줄 임시 카드
  interface PendingRecordingCard {
    title: string;
    audioBlobUrl: string;
    createdAt: string;
  }
  const [pendingRecordingCard, setPendingRecordingCard] = useState<PendingRecordingCard | null>(null);
  const pendingAudioBlobUrlRef = useRef<string | null>(null);

  const handleClearPendingCard = useCallback(() => {
    if (pendingAudioBlobUrlRef.current) {
      URL.revokeObjectURL(pendingAudioBlobUrlRef.current);
      pendingAudioBlobUrlRef.current = null;
    }
    setPendingRecordingCard(null);
  }, []);

  const handleUploadWithOptimistic = useCallback(async () => {
    if (audioChunksRef.current.length > 0) {
      const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
      const audioBlobUrl = URL.createObjectURL(audioBlob);
      if (pendingAudioBlobUrlRef.current) {
        URL.revokeObjectURL(pendingAudioBlobUrlRef.current);
      }
      pendingAudioBlobUrlRef.current = audioBlobUrl;
      const baseTitle = baseFileName || '';
      const userTitle = fileName && fileName.startsWith(baseTitle) ? fileName : (baseTitle + (fileName || ''));
      setPendingRecordingCard({
        title: userTitle || '녹음',
        audioBlobUrl,
        createdAt: new Date().toISOString(),
      });
    }
    await uploadRecording();
  }, [audioChunksRef, fileName, baseFileName, uploadRecording]);

  // pending card 존재 시 주기적으로 학습기록 캐시 갱신 (서버 처리 완료 감지)
  useEffect(() => {
    if (!pendingRecordingCard || !bookUid) return;
    const interval = setInterval(() => {
      dispatchLearningRecordsInvalidate(bookUid);
    }, 5000);
    return () => clearInterval(interval);
  }, [pendingRecordingCard, bookUid]);

  // 메모 모달 상태 - 여러개 열 수 있도록 Map으로 관리
  interface NoteModalData {
    noteTitle: string;
    noteText: string;
    noteColor: NoteColorType;
    noteAttachments: Array<{ id: string; name: string; file?: File }>;
    showNoteMenu: boolean;
    showColorPicker: boolean;
    isNoteEditMode: boolean;
    editingAnnotation: Annotation | null;
    position?: { x: number; y: number }; // 모달 위치 (optional - undefined면 중앙에 큰 크기로 표시)
    selectedRange?: TextRange | null; // 새 메모 생성 시 선택된 범위
    selectedPageNumber?: number | null; // 새 메모 생성 시 선택된 페이지 번호
    selectedRanges?: MultiParagraphRange[]; // 새 메모 생성 시 선택된 여러 범위
    originalNoteTitle?: string; // 원본 제목 (변경사항 추적용)
    originalNoteText?: string; // 원본 내용 (변경사항 추적용)
    canEdit?: boolean; // 수정/삭제 권한 (본인이 작성한 메모인 경우에만 true)
  }
  const [openModals, setOpenModals] = useState<Map<string, NoteModalData>>(new Map());
  const noteFileInputRef = useRef<HTMLInputElement>(null);
  
  // 기존 코드 호환성을 위한 헬퍼 함수들
  const getCurrentModalData = (annotationId: string | null): NoteModalData | null => {
    if (!annotationId) return null;
    return openModals.get(annotationId) || null;
  };
  
  const setCurrentModalData = (annotationId: string | null, data: Partial<NoteModalData>) => {
    if (!annotationId) return;
    setOpenModals(prev => {
      const newMap = new Map(prev);
      const existing = newMap.get(annotationId) || {
        noteTitle: '',
        noteText: '',
        noteColor: 'yellow' as NoteColorType,
        noteAttachments: [],
        showNoteMenu: false,
        showColorPicker: false,
        isNoteEditMode: false, // 기본적으로 읽기 모드
        editingAnnotation: null,
        position: undefined, // 중앙에 큰 크기로 표시
      };
      newMap.set(annotationId, { ...existing, ...data });
      return newMap;
    });
  };
  
  // 기존 코드 호환성을 위한 단일 모달 상태 (새 메모 생성용 - openModals로 통합)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newNoteModalId, setNewNoteModalId] = useState<string | null>(null);
  const [noteTitle, setNoteTitle] = useState('');
  const [noteText, setNoteText] = useState('');
  const [noteColor, setNoteColor] = useState<NoteColorType>('yellow');
  const [noteAttachments, setNoteAttachments] = useState<Array<{ id: string; name: string; file?: File }>>([]);
  const [showNoteMenu, setShowNoteMenu] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [isNoteEditMode, setIsNoteEditMode] = useState(true);
  
  // 레이아웃 상태
  const [contentHeight, setContentHeight] = useState<number | undefined>(undefined);
  const [contentTop, setContentTop] = useState<number | undefined>(undefined);
  
  // 패널 상태
  const learningRecordsScrollTopRef = React.useRef(0);
  const [learningRecordsScrollTopSnapshot, setLearningRecordsScrollTopSnapshot] = useState(0);
  const [showLearningRecords, setShowLearningRecords] = useState(false);
  const [showAIPanel, setShowAIPanel] = useState(false);
  const [panelHeight, setPanelHeight] = useState(() => {
    const limits = getPanelSizeLimits();
    const stored = getStoredPanelHeight();
    const clamped = Math.max(limits.minHeight, Math.min(limits.maxHeight, stored));
    if (clamped !== stored) setStoredPanelHeight(clamped);
    return clamped;
  });
  const [panelBottom, setPanelBottom] = useState(() => {
    const limits = getPanelSizeLimits();
    const stored = getStoredPanelBottom();
    const clamped = Math.max(limits.minBottom, Math.min(limits.maxBottom, stored));
    if (clamped !== stored) setStoredPanelBottom(clamped);
    return clamped;
  });
  const panelHeightRef = useRef(panelHeight);
  const panelBottomRef = useRef(panelBottom);
  panelHeightRef.current = panelHeight;
  panelBottomRef.current = panelBottom;

  // 뷰포트 변경 시 패널 높이/하단 위치를 화면에 맞게 클램프 (panelBottom + panelHeight <= vh - margin, 헤더 영역 침범 방지)
  useEffect(() => {
    const clampToViewport = () => {
      const limits = getPanelSizeLimits();
      const vh = window.innerHeight;
      const vw = window.innerWidth;
      const margin = 92;
      const maxTotal = Math.max(limits.minHeight + limits.minBottom, vh - margin);

      // 높이/하단 클램프
      let newH = panelHeightRef.current;
      let newB = panelBottomRef.current;
      if (newB + newH > maxTotal) {
        newH = Math.max(limits.minHeight, Math.min(limits.maxHeight, maxTotal - newB));
        newB = Math.max(limits.minBottom, Math.min(limits.maxBottom, maxTotal - newH));
      }
      newH = Math.max(limits.minHeight, Math.min(limits.maxHeight, newH));
      newB = Math.max(limits.minBottom, Math.min(limits.maxBottom, newB));
      if (newB + newH > maxTotal) newH = maxTotal - newB;
      if (newB !== panelBottomRef.current) {
        setPanelBottom(newB);
        setStoredPanelBottom(newB);
      }
      if (newH !== panelHeightRef.current) {
        setPanelHeight(newH);
        setStoredPanelHeight(newH);
      }

      // 학습기록 패널 너비/위치 클램프
      let newLrW = Math.max(limits.minLearningRecordsWidth, Math.min(limits.maxLearningRecordsWidth, learningRecordsWidthRef.current));
      let newLrL = Math.max(limits.minLearningRecordsLeft, Math.min(limits.maxLearningRecordsLeft, learningRecordsLeftRef.current));
      // 화면 밖으로 나가지 않도록 보정
      if (newLrL + newLrW > vw) {
        newLrW = Math.max(limits.minLearningRecordsWidth, vw - newLrL - 10);
        if (newLrW < limits.minLearningRecordsWidth) {
          newLrL = Math.max(limits.minLearningRecordsLeft, vw - limits.minLearningRecordsWidth - 10);
          newLrW = limits.minLearningRecordsWidth;
        }
      }
      if (newLrW !== learningRecordsWidthRef.current) {
        setLearningRecordsWidth(newLrW);
        setStoredLearningRecordsWidth(newLrW);
      }
      if (newLrL !== learningRecordsLeftRef.current) {
        setLearningRecordsLeft(newLrL);
        setStoredLearningRecordsLeft(newLrL);
      }

      // AI 패널 너비/위치 클램프
      let newAiW = Math.max(limits.minAIPanelWidth, Math.min(limits.maxAIPanelWidth, aiPanelWidthRef.current));
      let newAiR = Math.max(limits.minAIPanelRight, Math.min(limits.maxAIPanelRight, aiPanelRightRef.current));
      // 화면 밖으로 나가지 않도록 보정
      if (newAiR + newAiW > vw) {
        newAiW = Math.max(limits.minAIPanelWidth, vw - newAiR - 10);
        if (newAiW < limits.minAIPanelWidth) {
          newAiR = Math.max(limits.minAIPanelRight, vw - limits.minAIPanelWidth - 10);
          newAiW = limits.minAIPanelWidth;
        }
      }
      if (newAiW !== aiPanelWidthRef.current) {
        setAiPanelWidth(newAiW);
        setStoredAIPanelWidth(newAiW);
      }
      if (newAiR !== aiPanelRightRef.current) {
        setAiPanelRight(newAiR);
        setStoredAIPanelRight(newAiR);
      }
    };
    clampToViewport();
    const handleResize = () => clampToViewport();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const [learningRecordsWidth, setLearningRecordsWidth] = useState(() => getStoredLearningRecordsWidth());
  const [learningRecordsLeft, setLearningRecordsLeft] = useState(() => getStoredLearningRecordsLeft());
  const [aiPanelWidth, setAiPanelWidth] = useState(() => getStoredAIPanelWidth());
  const [aiPanelRight, setAiPanelRight] = useState(() => getStoredAIPanelRight());
  const learningRecordsWidthRef = useRef(learningRecordsWidth);
  const learningRecordsLeftRef = useRef(learningRecordsLeft);
  const aiPanelWidthRef = useRef(aiPanelWidth);
  const aiPanelRightRef = useRef(aiPanelRight);
  learningRecordsWidthRef.current = learningRecordsWidth;
  learningRecordsLeftRef.current = learningRecordsLeft;
  aiPanelWidthRef.current = aiPanelWidth;
  aiPanelRightRef.current = aiPanelRight;
  const [learningRecordsPosition] = useState<'left' | 'right'>('left');
  const [aiPanelPosition] = useState<'left' | 'right'>('right');
  const [aiSelectedText, setAiSelectedText] = useState<string>('');
  const [isSyncLocationExpanded, setIsSyncLocationExpanded] = useState(false);

  // 교수의 노트 모달에서 "N개의 학습 기록" 클릭 시 학습 기록 패널 열기
  React.useEffect(() => {
    const handleProfessorNotesOpenLearningRecords = () => {
      setShowLearningRecords(true);
    };
    window.addEventListener('professorNotesOpenLearningRecords', handleProfessorNotesOpenLearningRecords as EventListener);
    return () => {
      window.removeEventListener('professorNotesOpenLearningRecords', handleProfessorNotesOpenLearningRecords as EventListener);
    };
  }, []);

  React.useEffect(() => {
    learningRecordsScrollTopRef.current = 0;
    setLearningRecordsScrollTopSnapshot(0);
  }, [bookUid]);

  // 학습 기록 패널의 폴더 상세 모달 열림 여부 (삭제 툴바 표시 시 모달이 열려있으면 숨김)
  const [hasFolderDetailModalOpen, setHasFolderDetailModalOpen] = useState(false);
  React.useEffect(() => {
    const handler = (e: CustomEvent<{ open: boolean }>) => {
      setHasFolderDetailModalOpen(!!e.detail?.open);
    };
    window.addEventListener('folderDetailModalChanged', handler as EventListener);
    return () => window.removeEventListener('folderDetailModalChanged', handler as EventListener);
  }, []);
  React.useEffect(() => {
    if (!showLearningRecords) setHasFolderDetailModalOpen(false);
  }, [showLearningRecords]);
  
  
  // 채팅과 퀴즈 히스토리 분리
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
  const [chatTitle, setChatTitle] = useState<string | null>(null);
  const [chatDialogNo, setChatDialogNo] = useState<number>(0);
  const [chatDialogUuid, setChatDialogUuid] = useState<string | null>(null);
  const [chatNextCursor, setChatNextCursor] = useState<string | null>(null);
  const [chatHasMore, setChatHasMore] = useState(false);
  const [quizMessages, setQuizMessages] = useState<ChatMessage[]>([]);
  const [quizDialogNo, setQuizDialogNo] = useState<number>(0);
  
  const [aiPanelMode, setAiPanelMode] = useState<'chat' | 'quiz'>('chat');
  const [showTextTooLongModal, setShowTextTooLongModal] = useState(false);
  const [showCopyToast, setShowCopyToast] = useState(false);


  // 채팅 추가 로드 핸들러 (무한 스크롤)
  const handleLoadMoreChats = useCallback(async () => {
    if (!chatDialogUuid || !chatHasMore || !chatNextCursor) {
      return;
    }

    try {
      const response = await aiLearningService.getDialogChats(chatDialogUuid, 50, chatNextCursor);
      const chats = response.chats;
      
      if (chats.length === 0) {
        setChatHasMore(false);
        return;
      }
      
      // 채팅을 시간순으로 정렬 (created_at 기준)
      const sortedChats = [...chats].sort((a, b) => 
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
      
      // ChatMessage 형식으로 변환
      const newMessages: ChatMessage[] = sortedChats.map((chat) => {
        return {
          id: `chat-${chat.chat_no}`,
          type: chat.type === 'U' ? 'user' : 'ai',
          content: chat.message,
          timestamp: new Date(chat.created_at),
        };
      });
      
      // 기존 메시지 앞에 추가 (이전 메시지이므로)
      setChatMessages(prev => {
        const existingIds = new Set(prev.map(m => m.id));
        const uniqueNewMessages = newMessages.filter(m => !existingIds.has(m.id));
        // 시간순으로 정렬하여 합치기
        const merged = [...uniqueNewMessages, ...prev];
        return merged.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
      });
      
      setChatNextCursor(response.nextCursor);
      setChatHasMore(response.hasMore);
    } catch (error) {
      // console.error('이전 채팅 불러오기 실패:', error);
    }
  }, [chatDialogUuid, chatHasMore, chatNextCursor]);

  // 패널 크기 조절 핸들러 (상단 - 높이)
  const handleTopResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const getClientY = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientY ?? ev.changedTouches[0]?.clientY ?? 0) : ev.clientY;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const h = window.innerHeight - getClientY(ev) - panelBottom;
      const nh = Math.max(limits.minHeight, Math.min(limits.maxHeight, h));
      setPanelHeight(nh);
      setStoredPanelHeight(nh);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'row-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [panelBottom]);

  // 패널 크기 조절 핸들러 (하단)
  const handleBottomResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const startBottom = panelBottom;
    const startHeight = panelHeight;
    const getClientY = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientY ?? ev.changedTouches[0]?.clientY ?? 0) : ev.clientY;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const b = window.innerHeight - getClientY(ev);
      const nb = Math.max(limits.minBottom, Math.min(limits.maxBottom, b));
      const nh = Math.max(limits.minHeight, startBottom + startHeight - nb);
      setPanelBottom(nb);
      setStoredPanelBottom(nb);
      setPanelHeight(nh);
      setStoredPanelHeight(nh);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'row-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [panelBottom, panelHeight]);

  // 패널 크기 조절 핸들러 (학습기록-채팅 너비, 둘 다 열렸을 때)
  const handleWidthResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const getClientX = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientX ?? ev.changedTouches[0]?.clientX ?? 0) : ev.clientX;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const lw = getClientX(ev) - learningRecordsLeft;
      const nlw = Math.max(limits.minLearningRecordsWidth, Math.min(limits.maxLearningRecordsWidth, lw));
      setLearningRecordsWidth(nlw);
      setStoredLearningRecordsWidth(nlw);
      const total = window.innerWidth - learningRecordsLeft - aiPanelRight - 8;
      const naw = Math.max(limits.minAIPanelWidth, Math.min(limits.maxAIPanelWidth, total - nlw));
      setAiPanelWidth(naw);
      setStoredAIPanelWidth(naw);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [learningRecordsLeft, aiPanelRight]);

  // 학습 기록 패널만 - 오른쪽 가장자리 너비 조절
  const handleLearningRecordsRightResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const getClientX = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientX ?? ev.changedTouches[0]?.clientX ?? 0) : ev.clientX;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const w = getClientX(ev) - learningRecordsLeft;
      const lw = Math.max(limits.minLearningRecordsWidth, Math.min(limits.maxLearningRecordsWidth, w));
      setLearningRecordsWidth(lw);
      setStoredLearningRecordsWidth(lw);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [learningRecordsLeft]);

  // 학습 기록 패널만 - 왼쪽 가장자리 위치/너비 조절
  const handleLearningRecordsLeftResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const startRight = learningRecordsLeft + learningRecordsWidth;
    const getClientX = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientX ?? ev.changedTouches[0]?.clientX ?? 0) : ev.clientX;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const left = Math.max(limits.minLearningRecordsLeft, Math.min(limits.maxLearningRecordsLeft, getClientX(ev)));
      const w = Math.max(limits.minLearningRecordsWidth, startRight - left);
      setLearningRecordsLeft(left);
      setStoredLearningRecordsLeft(left);
      setLearningRecordsWidth(w);
      setStoredLearningRecordsWidth(w);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [learningRecordsLeft, learningRecordsWidth]);

  // AI 패널만 - 왼쪽 가장자리 너비 조절 (오른쪽 고정)
  const handleAIPanelLeftResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const getClientX = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientX ?? ev.changedTouches[0]?.clientX ?? 0) : ev.clientX;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const w = window.innerWidth - aiPanelRight - getClientX(ev);
      const aw = Math.max(limits.minAIPanelWidth, Math.min(limits.maxAIPanelWidth, w));
      setAiPanelWidth(aw);
      setStoredAIPanelWidth(aw);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [aiPanelRight]);

  // AI 패널만 - 오른쪽 가장자리 (뷰포트와 맞닿은 쪽) 너비/위치 조절
  const handleAIPanelRightResizeStart = useCallback((e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault();
    const panelLeft = window.innerWidth - aiPanelRight - aiPanelWidth;
    const getClientX = (ev: MouseEvent | TouchEvent) =>
      'touches' in ev ? (ev.touches[0]?.clientX ?? ev.changedTouches[0]?.clientX ?? 0) : ev.clientX;
    const onMove = (ev: MouseEvent | TouchEvent) => {
      const limits = getPanelSizeLimits();
      const newAw = getClientX(ev) - panelLeft;
      const aw = Math.max(limits.minAIPanelWidth, Math.min(limits.maxAIPanelWidth, newAw));
      const nr = window.innerWidth - getClientX(ev);
      const maxRight = limits.maxAIPanelRight ?? (window.innerWidth - limits.minAIPanelWidth - 20);
      const clampedRight = Math.max(limits.minAIPanelRight, Math.min(maxRight, nr));
      setAiPanelRight(clampedRight);
      setStoredAIPanelRight(clampedRight);
      setAiPanelWidth(aw);
      setStoredAIPanelWidth(aw);
    };
    const onUp = () => {
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('touchend', onUp);
      window.removeEventListener('touchcancel', onUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
    window.addEventListener('touchcancel', onUp);
  }, [aiPanelRight, aiPanelWidth]);

  // 학습 기록 클릭 핸들러
  const handleLearningRecordClick = useCallback(async (record: LearningRecordData) => {
    // DIALOG 타입인 경우에만 처리
    if (record.record_type === 'DIALOG' && bookUid) {
      try {
        // 채팅 모드로 전환
        setAiPanelMode('chat');
        setChatTitle(record.title || null);
        
        let messages: ChatMessage[] = [];
        let dialogNo = record.dialog_no || 0;
        
        // dialog_uuid가 있으면 새로운 API 사용
        if (record.dialog_uuid) {
          const response = await aiLearningService.getDialogChats(record.dialog_uuid);
          const chats = response.chats;
          
          // 채팅을 시간순으로 정렬 (created_at 기준)
          const sortedChats = [...chats].sort((a, b) => 
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
          );
          
          // ChatMessage 형식으로 변환
          messages = sortedChats.map((chat) => {
            return {
              id: `chat-${chat.chat_no}`,
              type: chat.type === 'U' ? 'user' : 'ai',
              content: chat.message,
              timestamp: new Date(chat.created_at),
            };
          });
          
          // 무한 스크롤을 위한 상태 설정
          setChatDialogUuid(record.dialog_uuid);
          setChatNextCursor(response.nextCursor);
          setChatHasMore(response.hasMore);
        } 
        // dialog_uuid가 없으면 기존 API 사용 (하위 호환성)
        else if (record.dialog_no) {
          const history = await aiLearningService.getDialogHistory(bookUid, record.dialog_no);
          
          // 히스토리를 ChatMessage 형식으로 변환
          messages = history.messages.map((msg) => {
            const userMessage: ChatMessage = {
              id: `user-${msg.chat_no}`,
              type: 'user',
              content: msg.query,
              timestamp: new Date(msg.created_at),
            };
            
            const aiMessage: ChatMessage = {
              id: `ai-${msg.chat_no}`,
              type: 'ai',
              content: msg.message,
              timestamp: new Date(msg.created_at),
            };
            
            return [userMessage, aiMessage];
          }).flat();
          
          dialogNo = history.dialogNo;
        }
        
        // 메시지와 다이얼로그 번호 설정
        setChatMessages(messages);
        setChatDialogNo(dialogNo);
        
        // dialog_uuid가 없으면 무한 스크롤 관련 상태 초기화
        if (!record.dialog_uuid) {
          setChatDialogUuid(null);
          setChatNextCursor(null);
          setChatHasMore(false);
        }
        
        // 채팅창 열기
        setShowAIPanel(true);
      } catch (error) {
        // console.error('대화 히스토리 불러오기 실패:', error);
        // 에러가 발생해도 채팅창은 열기
        setAiPanelMode('chat');
        setChatMessages([]);
        setChatDialogNo(record.dialog_no || 0);
        setShowAIPanel(true);
      }
    }
  }, [bookUid]);
  
  const contentRef2 = useRef<HTMLDivElement>(null);
  const viewerContainerRef = useRef<HTMLDivElement>(null);
  const [viewerContainerNode, setViewerContainerNode] = useState<HTMLDivElement | null>(null);
  const viewerContainerCallbackRef = useCallback((node: HTMLDivElement | null) => {
    viewerContainerRef.current = node;
    setViewerContainerNode(node);
  }, []);
  const attachmentFloatingRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // 1쪽/2쪽 보기 상태
  const [userPagesPerView, setUserPagesPerView] = useState<1 | 2>(() => getSettings().pagesPerView);

  // PDF 첨부파일 패널 상태 (단일 패널)
  const [openPdf, setOpenPdf] = useState<Attachment | null>(null);
  const [attachmentPanelOnLeft, setAttachmentPanelOnLeft] = useState(getStoredAttachmentPanelOnLeft);
  const [isDraggingPdf, setIsDraggingPdf] = useState(false);
  const [isLeftZoneDragOver, setIsLeftZoneDragOver] = useState(false);
  const [isRightZoneDragOver, setIsRightZoneDragOver] = useState(false);

  // 플로팅 폴더 상태 (BookViewer 레벨)
  // openedPdfHistory: 모달 "열기" 버튼으로 연 PDF만 저장, 폴더 아이콘/목록은 이 기준
  const [openedPdfHistory, setOpenedPdfHistory] = useState<Attachment[]>([]);
  const [isFolderOpen, setIsFolderOpen] = useState(false);
  const [folderPosition, setFolderPosition] = useState<{ x: number; y: number } | null>(null);
  const [viewerContainerWidth, setViewerContainerWidth] = useState(0);
  const folderDragStart = useRef({ x: 0, y: 0 });
  const folderDragJustEndedRef = useRef(false);
  const FOLDER_POSITION_STORAGE_KEY = 'attachment-folder-position';
  const FOLDER_DRAG_THRESHOLD = 5;
  const FOLDER_BUTTON_SIZE = 56;
  const FOLDER_MARGIN = 20;

  const attachmentContext = useAttachmentContext();
  const pdfToOpenFromModal = attachmentContext?.pdfToOpenFromModal ?? null;
  const setPdfToOpenFromModal = attachmentContext?.setPdfToOpenFromModal;

  // 모달 "열기" 버튼으로 PDF 열기 → openPdf 설정 + openedPdfHistory에 추가
  useEffect(() => {
    if (pdfToOpenFromModal) {
      setOpenPdf(pdfToOpenFromModal);
      setOpenedPdfHistory((prev) => {
        const exists = prev.some((a) => a.file_uuid === pdfToOpenFromModal.file_uuid);
        if (exists) return prev;
        return [...prev, pdfToOpenFromModal];
      });
      setPdfToOpenFromModal?.(null);
    }
  }, [pdfToOpenFromModal, setPdfToOpenFromModal]);

  // isDraggingPdf 안전장치: window dragend로 항상 리셋
  useEffect(() => {
    if (!isDraggingPdf) return;
    const resetDrag = () => setIsDraggingPdf(false);
    window.addEventListener('dragend', resetDrag);
    const timer = setTimeout(resetDrag, 5000);
    return () => {
      window.removeEventListener('dragend', resetDrag);
      clearTimeout(timer);
    };
  }, [isDraggingPdf]);

  // 플로팅 폴더 위치 초기화 + 리사이즈 시 clamp
  // viewerContainerNode 의존: ViewerContainer가 DOM에 마운트될 때 트리거
  useEffect(() => {
    if (!viewerContainerNode) return;
    const applyPosition = () => {
      const rect = viewerContainerNode.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return;
      setViewerContainerWidth(rect.width);
      setFolderPosition((prev) => {
        if (prev !== null) {
          const x = Math.max(0, Math.min(rect.width - FOLDER_BUTTON_SIZE, prev.x));
          const y = Math.max(0, Math.min(rect.height - FOLDER_BUTTON_SIZE, prev.y));
          return { x, y };
        }
        try {
          const stored = localStorage.getItem(FOLDER_POSITION_STORAGE_KEY);
          if (stored) {
            const parsed = JSON.parse(stored) as { x: number; y: number };
            if (typeof parsed.x === 'number' && typeof parsed.y === 'number') {
              return {
                x: Math.max(0, Math.min(rect.width - FOLDER_BUTTON_SIZE, parsed.x)),
                y: Math.max(0, Math.min(rect.height - FOLDER_BUTTON_SIZE, parsed.y)),
              };
            }
          }
        } catch { /* ignore */ }
        return {
          x: Math.max(0, rect.width - FOLDER_BUTTON_SIZE - FOLDER_MARGIN),
          y: FOLDER_MARGIN,
        };
      });
    };
    applyPosition();
    const ro = new ResizeObserver(applyPosition);
    ro.observe(viewerContainerNode);
    return () => ro.disconnect();
  }, [viewerContainerNode]);

  // 플로팅 폴더 위치 localStorage 저장
  useEffect(() => {
    if (folderPosition === null) return;
    try { localStorage.setItem(FOLDER_POSITION_STORAGE_KEY, JSON.stringify(folderPosition)); } catch { /* ignore */ }
  }, [folderPosition]);

  // attachmentOpenRequest 이벤트 (외부에서 폴더 열기)
  useEffect(() => {
    const handler = () => setIsFolderOpen(true);
    window.addEventListener('attachmentOpenRequest', handler);
    return () => window.removeEventListener('attachmentOpenRequest', handler);
  }, []);

  // pagesPerViewChange 이벤트 (설정 모달에서 변경)
  useEffect(() => {
    const handler = (e: Event) => {
      const value = (e as CustomEvent).detail as 1 | 2;
      if (value === 1 || value === 2) setUserPagesPerView(value);
    };
    window.addEventListener('pagesPerViewChange', handler);
    return () => window.removeEventListener('pagesPerViewChange', handler);
  }, []);

  const handleAttachmentPanelPositionToggle = useCallback(() => {
    setAttachmentPanelOnLeft((prev) => {
      const next = !prev;
      setStoredAttachmentPanelOnLeft(next);
      return next;
    });
  }, []);

  const handleMinimizePdf = useCallback(() => {
    setOpenPdf(null);
  }, []);

  const handleClosePdf = useCallback((attachment: Attachment) => {
    setOpenPdf(null);
    setOpenedPdfHistory((prev) => prev.filter((a) => a.file_uuid !== attachment.file_uuid));
  }, []);

  // 폴더에서 PDF 클릭으로 열기
  const handleOpenPdfFromFolder = useCallback((attachment: Attachment) => {
    setOpenPdf(attachment);
  }, []);

  // 폴더 목록에서 제거 (openedPdfHistory에서 삭제)
  const handleRemoveFromFolder = useCallback((e: React.MouseEvent, fileUuid: string) => {
    e.stopPropagation();
    setOpenedPdfHistory((prev) => prev.filter((a) => a.file_uuid !== fileUuid));
  }, []);

  // 폴더 버튼 드래그 시작 (PDF를 드래그해서 좌/우에 놓기)
  const handleFolderPdfDragStart = useCallback((e: React.DragEvent, attachment: Attachment) => {
    e.dataTransfer.setData('application/x-attachment', JSON.stringify(attachment));
    e.dataTransfer.effectAllowed = 'copy';
    setIsDraggingPdf(true);
  }, []);

  const handleFolderPdfDragEnd = useCallback(() => {
    setIsDraggingPdf(false);
  }, []);

  const getContainerRect = useCallback(() => {
    const c = viewerContainerRef.current;
    if (c) return c.getBoundingClientRect();
    return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
  }, []);

  // 클릭 vs 드래그 구분 + 드래그 이동을 네이티브 이벤트로 직접 처리 (React 상태 비동기 타이밍 문제 회피)
  const handleFolderMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button !== 0 || !folderPosition) return;
    const startX = e.clientX;
    const startY = e.clientY;
    let dragging = false;
    const onMove = (me: MouseEvent) => {
      const dx = me.clientX - startX;
      const dy = me.clientY - startY;
      if (!dragging && Math.sqrt(dx * dx + dy * dy) > FOLDER_DRAG_THRESHOLD) {
        dragging = true;
        folderDragStart.current = { x: me.clientX - folderPosition!.x, y: me.clientY - folderPosition!.y };
      }
      if (dragging) {
        const rect = getContainerRect();
        const x = Math.max(0, Math.min(rect.width - FOLDER_BUTTON_SIZE, me.clientX - rect.left - folderDragStart.current.x));
        const y = Math.max(0, Math.min(rect.height - FOLDER_BUTTON_SIZE, me.clientY - rect.top - folderDragStart.current.y));
        setFolderPosition({ x, y });
      }
    };
    const onEnd = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onEnd);
      if (dragging) {
        folderDragJustEndedRef.current = true;
      }
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);
  }, [folderPosition, getContainerRect]);

  const handleFolderTouchStart = useCallback((e: React.TouchEvent) => {
    if (!folderPosition) return;
    const t = e.touches[0];
    const startX = t.clientX;
    const startY = t.clientY;
    let dragging = false;
    const onMove = (te: TouchEvent) => {
      const touch = te.touches[0];
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (!dragging && Math.sqrt(dx * dx + dy * dy) > FOLDER_DRAG_THRESHOLD) {
        dragging = true;
        folderDragStart.current = { x: touch.clientX - folderPosition!.x, y: touch.clientY - folderPosition!.y };
      }
      if (dragging) {
        te.preventDefault();
        const rect = getContainerRect();
        const x = Math.max(0, Math.min(rect.width - FOLDER_BUTTON_SIZE, touch.clientX - rect.left - folderDragStart.current.x));
        const y = Math.max(0, Math.min(rect.height - FOLDER_BUTTON_SIZE, touch.clientY - rect.top - folderDragStart.current.y));
        setFolderPosition({ x, y });
      }
    };
    const onEnd = () => {
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onEnd);
      if (dragging) {
        folderDragJustEndedRef.current = true;
      }
    };
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
  }, [folderPosition, getContainerRect]);

  const visibleFolderAttachments = openedPdfHistory;

  // PDF 뷰어가 열려있으면 자동으로 1쪽 보기, 닫혀있으면 사용자 설정값
  const effectivePagesPerView: 1 | 2 = openPdf ? 1 : userPagesPerView;
  effectivePagesPerViewRef.current = effectivePagesPerView;
  const isFolderOnLeft = folderPosition && viewerContainerWidth > 0
    ? (folderPosition.x + FOLDER_BUTTON_SIZE / 2) < viewerContainerWidth / 2
    : true;

  // 드롭 핸들러 (DropOverlay 좌/우 영역)
  const createDropHandler = useCallback(
    (dropOnLeft: boolean) => (e: React.DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setIsLeftZoneDragOver(false);
      setIsRightZoneDragOver(false);
      setIsDraggingPdf(false);
      const parseAttachment = (): Attachment | null => {
        const raw = e.dataTransfer.getData('application/x-attachment');
        if (raw) { try { return JSON.parse(raw) as Attachment; } catch { return null; } }
        const file = e.dataTransfer.files?.[0];
        if (file?.type.includes('pdf')) {
          return {
            attachment_id: 0, file_uuid: URL.createObjectURL(file),
            file_name: file.name, file_size: file.size, file_type: file.type,
            created_at: '', purpose: '', professor_name: '',
          };
        }
        return null;
      };
      const att = parseAttachment();
      if (!att) return;
      setOpenPdf(att);
      const newOnLeft = dropOnLeft;
      setAttachmentPanelOnLeft(newOnLeft);
      setStoredAttachmentPanelOnLeft(newOnLeft);
    },
    []
  );

  const handleLeftZoneDrop = useMemo(() => createDropHandler(true), [createDropHandler]);
  const handleRightZoneDrop = useMemo(() => createDropHandler(false), [createDropHandler]);

  const handleLeftZoneDragOver = useCallback((e: React.DragEvent) => { e.preventDefault(); e.stopPropagation(); setIsLeftZoneDragOver(true); }, []);
  const handleRightZoneDragOver = useCallback((e: React.DragEvent) => { e.preventDefault(); e.stopPropagation(); setIsRightZoneDragOver(true); }, []);
  const handleLeftZoneDragLeave = useCallback((e: React.DragEvent) => { e.preventDefault(); if (!e.currentTarget.contains(e.relatedTarget as Node)) setIsLeftZoneDragOver(false); }, []);
  const handleRightZoneDragLeave = useCallback((e: React.DragEvent) => { e.preventDefault(); if (!e.currentTarget.contains(e.relatedTarget as Node)) setIsRightZoneDragOver(false); }, []);

  const dropZoneContent = (
    <>
      <div style={{ width: 64, height: 64, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      </div>
      <div style={{ padding: '12px 24px', background: 'var(--primary-color, #3b82f6)', color: 'white', borderRadius: 8, fontSize: 14, fontWeight: 500, marginBottom: 8 }}>이 영역에서 PDF 열기</div>
      <p style={{ fontSize: 13, color: 'var(--text-secondary, #666)', margin: 0 }}>열어올 파일을 드래그하여 올리세요</p>
    </>
  );

  const bookId = bookUid ? bookUidToId(bookUid) : 0;
  
  // 페이지 네비게이션 훅 사용
  const {
    currentPageNumber,
    isPageNumberExpanded,
    pageNumberInput,
    pageNumberInputRef,
    isProgressLoading,
    handlePrevPage,
    handleNextPage,
    handleNavigateToPage,
    handlePageClick,
    handlePageNumberClick,
    handlePageNumberInputChange,
    handlePageNumberInputKeyDown,
  } = usePageNavigation({
    bookUid,
    pageIndex,
    lastPageIndex: lastPageIndex || 0,
    firstVisiblePageRef,
    lastVisiblePageRef,
  });

  // 학습 기록에서 페이지 클릭 핸들러 (annotation_uuid, componentNo, sharedAnnotationData 포함)
  const handleLearningRecordPageClick = useCallback((pageNo: number, annotationUuid?: string, memoFallback?: { title: string; subject: string }, componentNo?: number, sharedAnnotationData?: { startOffset: number; endOffset: number; selectedText?: string; color?: string; type?: string }) => {
    // console.log('[학습 기록 클릭] 페이지 이동:', {
    //   targetPageNo: pageNo,
    //   currentPageNumber,
    //   annotationUuid,
    //   componentNo,
    //   sharedAnnotationData,
    //   allLoadedComponentsCount: allLoadedComponents.length,
    //   displayComponentsCount: displayComponents.length
    // });
    
    const isSamePage = currentPageNumber === pageNo;
    
    // 같은 페이지로 이동할 때는 이전 강조 표시 초기화 (새로운 어노테이션 강조를 위해)
    if (isSamePage) {
      setHighlightedAnnotationId(null);
    }
    
    if (annotationUuid) {
      // console.log('[학습 기록 클릭] pendingHighlightAnnotationId 설정 (페이지 이동 전):', annotationUuid);
      setPendingHighlightAnnotationId(annotationUuid);
    }
    // componentNo가 있으면 해당 컴포넌트가 포함된 화면을 선택하기 위해 저장
    setPendingComponentNo(componentNo ?? null);
    setPendingMemoFallback(memoFallback ?? null);
    // 공유 어노테이션 데이터 저장 (annotations 배열에서 못 찾을 경우 사용)
    setPendingSharedAnnotationData(sharedAnnotationData ?? null);
    
    // 현재 로드된 페이지 범위 확인
    const loadedPageNumbers = allLoadedComponents.length > 0 
      ? Array.from(new Set(allLoadedComponents.map(c => c.pageNo))).sort((a, b) => a - b)
      : [];
    const minLoadedPage = loadedPageNumbers[0];
    const maxLoadedPage = loadedPageNumbers[loadedPageNumbers.length - 1];
    
    // 현재 표시된 페이지 범위 확인
    const displayedPageNumbers = displayComponents.length > 0
      ? Array.from(new Set(displayComponents.map(c => c.pageNo))).sort((a, b) => a - b)
      : [];
    const minDisplayedPage = displayedPageNumbers[0];
    const maxDisplayedPage = displayedPageNumbers[displayedPageNumbers.length - 1];
    
    // console.log('[학습 기록 클릭] 페이지 범위 확인:', {
    //   loadedRange: minLoadedPage && maxLoadedPage ? `${minLoadedPage}~${maxLoadedPage}` : '없음',
    //   displayedRange: minDisplayedPage && maxDisplayedPage ? `${minDisplayedPage}~${maxDisplayedPage}` : '없음',
    //   targetPage: pageNo,
    //   isInLoadedRange: minLoadedPage && maxLoadedPage && pageNo >= minLoadedPage && pageNo <= maxLoadedPage,
    //   isInDisplayedRange: minDisplayedPage && maxDisplayedPage && pageNo >= minDisplayedPage && pageNo <= maxDisplayedPage
    // });
    
    // 이동 전 현재 페이지를 저장 (되돌아가기 용) - 같은 페이지여도 학습기록 패널로 돌아갈 수 있도록 설정
    if (currentPageNumber > 0) {
      setGoBackPageNo(currentPageNumber);
      setShowGoBackButton(true);
    }

    // 되돌아가기 시 공유폴더 모달 복원을 위해 현재 열린 폴더 UUID 저장
    setGoBackFolderUuid(currentSharedFolder?.folder_uuid ?? null);

    // 학습기록 패널 닫기 (페이지 이동 시) — 스크롤 위치는 되돌아올 때 복원
    setLearningRecordsScrollTopSnapshot(learningRecordsScrollTopRef.current);
    setShowLearningRecords(false);

    // 페이지 네비게이터(P 버튼)와 동일하게 handleNavigateToPage만 사용 - 항상 8페이지 그룹으로 표시
    handleNavigateToPage(pageNo);
  }, [handleNavigateToPage, currentPageNumber, currentSharedFolder]);

  // 공유 폴더 어노테이션을 Annotation 타입으로 변환하는 헬퍼 함수
  const convertSharedFolderAnnotationToAnnotation = useCallback((
    folderAnnotation: FolderItemAnnotation,
    components: ApiPageComponent[]
  ): Annotation | null => {
    try {
      // component_no로 컴포넌트 찾기 (component_no 우선, index 폴백)
      const component =
        components.find(c => c.component_no === folderAnnotation.component_no) ||
        components.find(c => c.index === folderAnnotation.component_no);
      if (!component) {
        // console.warn('[공유 폴더 어노테이션] 컴포넌트를 찾을 수 없음:', {
        //   component_no: folderAnnotation.component_no,
        //   annotation_uuid: folderAnnotation.annotation_uuid
        // });
        return null;
      }

      // 타입 변환 (API 타입 -> 내부 타입)
      const typeMap: Record<string, 'highlight' | 'note' | 'underline' | 'box'> = {
        'HIGHLIGHT': 'highlight',
        'MEMO': 'note',
        'UNDERLINE': 'underline',
        'BOX': 'box',
      };

      const annotationType = typeMap[folderAnnotation.type] || 'highlight';

      // 공유 폴더 어노테이션 색상: #4169E1
      const sharedFolderColor = '#4169E1';

      return {
        id: folderAnnotation.annotation_uuid,
        userId: folderAnnotation.user_no,
        bookId: folderAnnotation.book_no,
        pageNumber: folderAnnotation.page_no,
        type: annotationType,
        color: folderAnnotation.data?.color || sharedFolderColor,
        note: folderAnnotation.data?.title || folderAnnotation.data?.subject || undefined,
        componentNo: folderAnnotation.component_no,
        range: {
          paragraphId: component.id,
          startOffset: folderAnnotation.start_offset,
          endOffset: folderAnnotation.end_offset,
          selectedText: '',
        },
        createdAt: folderAnnotation.created_at,
        updatedAt: folderAnnotation.updated_at,
        _isSharedFolder: true, // 공유 폴더 어노테이션 표시
      } as Annotation & { _isSharedFolder?: boolean };
    } catch (error) {
      // console.error('[공유 폴더 어노테이션 변환 오류]:', error);
      return null;
    }
  }, []);

  // 두 페이지의 주석을 한 번에 다시 불러오기 (최적화)
  const reloadAllAnnotations = useCallback(async () => {
    if (!bookUid || !pageData) return;
    
    try {
      // 실제로 화면에 표시되는 페이지 범위를 displayComponents에서 직접 계산
      const allDisplayedComponents = displayComponents;
      if (allDisplayedComponents.length === 0) {
        // console.log('[Annotation] 표시된 컴포넌트가 없어 어노테이션 로드 스킵');
        return;
      }
      
      const displayedPageNumbers = new Set<number>();
      allDisplayedComponents.forEach(comp => {
        displayedPageNumbers.add(comp.pageNo);
      });
      
      const sortedPageNumbers = Array.from(displayedPageNumbers).sort((a, b) => a - b);
      const startPageIdx = sortedPageNumbers[0] || currentPageNumber;
      const endPageIdx = sortedPageNumbers[sortedPageNumbers.length - 1] || currentPageNumber;
      
      // idx에서 page_no로 변환 (displayComponents에서 직접 찾기)
      const findPageNoFromIdxLocal = (pageIdx: number): number | null => {
        const flatComponent = displayComponents.find(fc => fc.pageNo === pageIdx);
        if (flatComponent) {
          return flatComponent.pageNoDb;
        }
        const flatComponent2 = allLoadedComponents.find(fc => fc.pageNo === pageIdx);
        if (flatComponent2) {
          return flatComponent2.pageNoDb;
        }
        // 캐시에서 찾기
        const cachedPage = pageCacheRef.current.get(pageIdx);
        if (cachedPage) {
          return cachedPage.page.page_no;
        }
        return null;
      };
      
      const startPageNo = findPageNoFromIdxLocal(startPageIdx);
      const endPageNo = findPageNoFromIdxLocal(endPageIdx);
      
      if (startPageNo === null || endPageNo === null) {
        // console.warn('[Annotation] page_no 변환 실패:', { startPageIdx, endPageIdx });
        return;
      }
      
      // console.log(`[Annotation] 표시 범위: ${startPageIdx} ~ ${endPageIdx} (idx) -> ${startPageNo} ~ ${endPageNo} (page_no)`);

      // 일반 어노테이션 로드
      const { annotations: allAnnotations } = await annotationService.getAnnotationsByPageRange(
        bookUid,
        startPageNo,
        endPageNo
      );
      // console.log(`[Annotation] API 응답 - 어노테이션 ${allAnnotations.length}개, 페이지별:`,
      //   Array.from(new Set(allAnnotations.map(a => a.pageNumber))).sort((a,b) => a-b));

      // 공유 폴더 어노테이션 로드
      let sharedFolderAnnotations: Annotation[] = [];
      try {
        // 현재 책의 모든 공유 폴더 가져오기
        const sharedFolders = await sharedFolderService.getSharedFolders(bookUid);
        
        // 각 공유 폴더의 어노테이션 가져오기
        for (const folder of sharedFolders) {
          // 공유 폴더 어노테이션 표시 여부 확인 (localStorage에서 로드)
          const isVisible = getSharedFolderAnnotationVisibility(folder.folder_uuid);
          // console.log(`[공유폴더] ${folder.title} (${folder.folder_uuid}): isVisible=${isVisible}`);

          // 표시 여부가 false이면 스킵
          if (!isVisible) {
            continue;
          }
          
          const folderItems = await sharedFolderService.getFolderItems(folder.folder_uuid);
          
          // ANNOTATION 타입 아이템만 필터링
          const annotationItems = folderItems.items.filter(
            item => item.item_type === 'ANNOTATION' && item.annotation !== null
          );

          // 각 어노테이션을 Annotation 타입으로 변환
          for (const item of annotationItems) {
            if (!item.annotation) continue;

            const annotationPageNo = item.annotation.page_no;
            // 현재 표시된 페이지 범위에 있는 어노테이션만 추가
            if (annotationPageNo >= startPageNo && annotationPageNo <= endPageNo) {
              // 해당 페이지의 컴포넌트 찾기
              const pageComponents = displayComponents
                .filter(c => c.pageNoDb === annotationPageNo)
                .map(c => c.data);

              if (pageComponents.length > 0) {
                const converted = convertSharedFolderAnnotationToAnnotation(
                  item.annotation,
                  pageComponents
                );
                if (converted) {
                  // 공유 폴더 어노테이션 색상을 #4169E1로 강제 설정
                  converted.color = '#4169E1';
                  // mapAnnotationsParagraphId를 통해 paragraphId 매핑 (일관성 유지)
                  const mapped = mapAnnotationsParagraphId([converted], pageComponents);
                  if (mapped.length > 0) {
                    sharedFolderAnnotations.push(mapped[0]);
                  }
                }
              }
            }
          }
        }
      } catch (error) {
        // console.error('[공유 폴더 어노테이션 로드 오류]:', error);
        // 공유 폴더 어노테이션 로드 실패해도 일반 어노테이션은 계속 표시
      }
      
      // console.log('[reloadAllAnnotations] 받은 allAnnotations:', {
      //   count: allAnnotations.length,
      //   items: allAnnotations.map(ann => ({
      //     id: ann.id,
      //     pageNumber: ann.pageNumber,
      //     type: ann.type,
      //   })),
      // });
      
      // 모든 페이지의 annotation을 매핑
      // ann.pageNumber는 DB 인덱스(page_no)이므로, 이를 키로 사용
      const pageAnnotationsMap = new Map<number, Annotation[]>();
      
      // 각 페이지별로 annotation 분리 (page_no를 키로 사용)
      allAnnotations.forEach(ann => {
        const pageNo = ann.pageNumber; // 이것은 DB 인덱스(page_no)
        if (!pageAnnotationsMap.has(pageNo)) {
          pageAnnotationsMap.set(pageNo, []);
        }
        pageAnnotationsMap.get(pageNo)!.push(ann);
      });

      // 공유 폴더 어노테이션도 페이지별로 매핑
      sharedFolderAnnotations.forEach(ann => {
        const pageNo = ann.pageNumber;
        if (!pageAnnotationsMap.has(pageNo)) {
          pageAnnotationsMap.set(pageNo, []);
        }
        pageAnnotationsMap.get(pageNo)!.push(ann);
      });
      
      // console.log('[reloadAllAnnotations] pageAnnotationsMap:', {
      //   keys: Array.from(pageAnnotationsMap.keys()),
      //   pageDataIdx: pageData?.idx,
      //   pageDataPageNo: pageData?.page_no,
      //   nextPageDataIdx: nextPageData?.idx,
      //   nextPageDataPageNo: nextPageData?.page_no,
      // });
      
      // 현재 표시되는 페이지들의 컴포넌트로 매핑
      const mappedAnnotations: Annotation[] = [];
      
      // pageData와 nextPageData가 있는 경우
      // page_no (DB 인덱스)를 사용하여 annotation 찾기
      if (pageData) {
        const page1Annotations = pageAnnotationsMap.get(pageData.page_no) || [];
        // console.log('[reloadAllAnnotations] page1 annotations:', {
        //   pageNo: pageData.page_no,
        //   idx: pageData.idx,
        //   count: page1Annotations.length,
        // });
        const mapped1 = mapAnnotationsParagraphId(page1Annotations, pageData.components);
        mappedAnnotations.push(...mapped1);
      }
      
      if (nextPageData) {
        const page2Annotations = pageAnnotationsMap.get(nextPageData.page_no) || [];
        // console.log('[reloadAllAnnotations] page2 annotations:', {
        //   pageNo: nextPageData.page_no,
        //   idx: nextPageData.idx,
        //   count: page2Annotations.length,
        // });
        const mapped2 = mapAnnotationsParagraphId(page2Annotations, nextPageData.components);
        mappedAnnotations.push(...mapped2);
      }
      
      // 추가로 표시되는 페이지들도 처리
      // displayComponents에서 모든 표시된 페이지의 어노테이션 찾기
      const processedPageNos = new Set<number>();
      if (pageData) processedPageNos.add(pageData.page_no);
      if (nextPageData) processedPageNos.add(nextPageData.page_no);
      
      allDisplayedComponents.forEach(comp => {
        // comp.pageNoDb는 DB 인덱스(page_no)
        const pageNo = comp.pageNoDb;
        if (processedPageNos.has(pageNo)) return; // 이미 처리됨
        
        // pageAnnotationsMap에서 해당 page_no의 어노테이션 찾기
        const pageAnnotations = pageAnnotationsMap.get(pageNo) || [];
        if (pageAnnotations.length > 0) {
          // console.log('[reloadAllAnnotations] 추가 페이지 어노테이션:', {
          //   pageNo,
          //   pageIdx: comp.pageNo,
          //   count: pageAnnotations.length,
          // });
          
          // 해당 페이지의 컴포넌트 찾기 (cachedPage 또는 displayComponents에서)
          const cachedPage = pageCacheRef.current.get(comp.pageNo);
          if (cachedPage) {
            const mapped = mapAnnotationsParagraphId(pageAnnotations, cachedPage.page.components);
            mappedAnnotations.push(...mapped);
          } else {
            // cachedPage가 없으면 같은 페이지의 모든 컴포넌트를 allDisplayedComponents에서 찾기
            const pageComponents = allDisplayedComponents
              .filter(c => c.pageNoDb === pageNo)
              .map(c => c.data);
            
            if (pageComponents.length > 0) {
              const mapped = mapAnnotationsParagraphId(pageAnnotations, pageComponents);
              mappedAnnotations.push(...mapped);
            } else {
              // console.warn('[reloadAllAnnotations] 컴포넌트를 찾을 수 없음:', { pageNo, pageIdx: comp.pageNo });
            }
          }
          processedPageNos.add(pageNo);
        }
      });
      
      const updatedAnnotations = mappedAnnotations.map(a => {
        const ann = { ...a, _updatedAt: Date.now() } as any;
        return ann as Annotation;
      });
      
      // console.log(`[Annotation] 매핑 완료 - total ${updatedAnnotations.length}개 (일반: ${allAnnotations.length}, 공유: ${sharedFolderAnnotations.length})`,
      //   `처리된 페이지(page_no):`, Array.from(processedPageNos).sort((a,b) => a-b),
      //   `pageAnnotationsMap 키:`, Array.from(pageAnnotationsMap.keys()).sort((a,b) => a-b),
      //   `displayComponents 페이지:`, Array.from(new Set(displayComponents.map(c => c.pageNoDb))).sort((a,b) => a-b));
      // Optimistic annotation 보존 (아직 API 응답이 오지 않은 것들)
      setAnnotations(prev => {
        // console.log(`[Annotation] setAnnotations - prev ${prev.length}개, server ${updatedAnnotations.length}개`);
        // 아직 API 응답이 오지 않은 optimistic annotation만 보존
        const optimisticAnnotations = prev.filter(a => {
          const optimisticAnn = a as OptimisticAnnotation;
          return optimisticAnn._isOptimistic === true && optimisticAnn._tempId !== undefined;
        });
        
        // Optimistic annotation과 실제 annotation 병합 (중복 제거)
        // 서버에서 받은 annotation과 기존 annotation을 병합
        const merged: Annotation[] = [];
        
        // 먼저 서버에서 받은 annotation 추가
        updatedAnnotations.forEach(serverAnn => {
          merged.push(serverAnn);
        });
        
        // 그 다음 optimistic annotation 추가 (중복 체크)
        // 단, 이미 실제 annotation으로 교체된 것(_isOptimistic이 false이고 실제 UUID를 가진 것)은 제외
        optimisticAnnotations.forEach(optAnn => {
          const tempId = (optAnn as OptimisticAnnotation)._tempId;
          
          // 이미 실제 annotation으로 교체되었는지 확인 (id가 temp-로 시작하지 않으면 실제 annotation)
          const isAlreadyReplaced = !optAnn.id.startsWith('temp-');
          
          if (isAlreadyReplaced) {
            // 이미 실제 annotation으로 교체되었으면 서버 annotation과 중복 체크
            const exists = merged.some(ann => {
              // 같은 ID이거나 같은 위치인지 확인
              return ann.id === optAnn.id || (
                ann.pageNumber === optAnn.pageNumber &&
                ann.range.paragraphId === optAnn.range.paragraphId &&
                ann.range.startOffset === optAnn.range.startOffset &&
                ann.range.endOffset === optAnn.range.endOffset &&
                ann.type === optAnn.type
              );
            });
            
            if (exists) {
              // 서버에서 받은 annotation이 이미 있으면 optimistic annotation 제외
              // console.log('[reloadAllAnnotations] 이미 교체된 optimistic annotation이 서버 annotation으로 대체됨:', {
              //   tempId,
              //   realId: optAnn.id,
              //   pageNumber: optAnn.pageNumber,
              // });
              return; // 추가하지 않음
            }
          }
          
          // 같은 위치의 annotation이 이미 있는지 확인
          const exists = merged.some(ann => {
            // 같은 위치이고 같은 타입인지 확인
            const sameLocation = 
              ann.pageNumber === optAnn.pageNumber &&
              ann.range.paragraphId === optAnn.range.paragraphId &&
              ann.range.startOffset === optAnn.range.startOffset &&
              ann.range.endOffset === optAnn.range.endOffset &&
              ann.type === optAnn.type;
            
            return sameLocation;
          });
          
          if (!exists) {
            // 중복이 없으면 optimistic annotation 추가
            merged.push(optAnn as Annotation);
            // console.log('[reloadAllAnnotations] optimistic annotation 보존:', {
            //   tempId,
            //   pageNumber: optAnn.pageNumber,
            //   isAlreadyReplaced,
            // });
          } else {
            // 이미 서버에서 받은 annotation이 있으면 optimistic annotation은 제외
            // console.log('[reloadAllAnnotations] optimistic annotation이 서버 annotation으로 교체됨:', {
            //   tempId,
            //   pageNumber: optAnn.pageNumber,
            // });
          }
        });
        
        return merged;
      });
    } catch (err) {
      // console.error('전체 주석 다시 불러오기 중 오류:', err);
    }
  }, [bookUid, currentPageNumber, pageData, nextPageData, displayComponents, convertSharedFolderAnnotationToAnnotation, pageCacheRef, mapAnnotationsParagraphId, sharedFolderVisibilityMap]);

  // 페이지 변경 effect에서 사용할 ref (dependency 순환 방지)
  const reloadAllAnnotationsRef = useRef(reloadAllAnnotations);
  reloadAllAnnotationsRef.current = reloadAllAnnotations;

  // 공유 폴더 어노테이션 표시 여부 변경 이벤트 리스너
  useEffect(() => {
    const handleSharedFolderVisibilityChanged = (event: CustomEvent) => {
      const folderUuid = event.detail.folderUuid;
      const isVisible = event.detail.isVisible;
      // console.log(`[공유폴더 토글] folderUuid=${folderUuid}, isVisible=${isVisible}`);

      // state 업데이트
      setSharedFolderVisibilityMap(prev => {
        const newMap = new Map(prev);
        newMap.set(folderUuid, isVisible);
        return newMap;
      });

      // 공유 폴더 캐시 무효화 (stale 데이터 방지)
      sharedFolderService.invalidateCache(undefined, folderUuid);

      // 렌더 캐시 클리어 (어노테이션 표시/숨김 즉시 반영)
      renderTextWithHighlightsCache.current.clear();

      // 어노테이션 다시 로드하여 변경사항 반영
      reloadAllAnnotations();
    };

    window.addEventListener('sharedFolderVisibilityChanged', handleSharedFolderVisibilityChanged as EventListener);

    return () => {
      window.removeEventListener('sharedFolderVisibilityChanged', handleSharedFolderVisibilityChanged as EventListener);
    };
  }, [reloadAllAnnotations]);

  // idx에서 page_no (DB 인덱스)를 찾는 헬퍼 함수
  const findPageNoFromIdx = useCallback((pageIdx: number): number | null => {
    // displayComponents에서 찾기
    const flatComponent = displayComponents.find(fc => fc.pageNo === pageIdx);
    if (flatComponent) {
      return flatComponent.pageNoDb;
    }
    // allLoadedComponents에서 찾기
    const allComponents = allLoadedComponents;
    const flatComponent2 = allComponents.find(fc => fc.pageNo === pageIdx);
    if (flatComponent2) {
      return flatComponent2.pageNoDb;
    }
    // 캐시에서 찾기
    const cachedPage = pageCacheRef.current.get(pageIdx);
    if (cachedPage) {
      return cachedPage.page.page_no;
    }
    return null;
  }, [displayComponents, allLoadedComponents]);

  // page_no (DB 인덱스)에서 idx (표시용 페이지 번호)를 찾는 헬퍼 함수
  const convertPageNoDbToIdx = useCallback((pageNoDb: number): number | null => {
    const fc = displayComponents.find(c => c.pageNoDb === pageNoDb)
      || allLoadedComponents.find(c => c.pageNoDb === pageNoDb);
    if (fc) return fc.pageNo;
    for (const [idx, cached] of pageCacheRef.current.entries()) {
      if (cached.page.page_no === pageNoDb) return idx;
    }
    return null;
  }, [displayComponents, allLoadedComponents]);

  // Optimistic update: annotation을 즉시 프론트에 추가
  const addAnnotationOptimistically = useCallback((request: CreateAnnotationRequest, tempId: string): OptimisticAnnotation => {
    // 실제 컴포넌트를 찾아서 올바른 paragraphId 설정
    let actualParagraphId = `component-${request.component_no}`;
    
    // 현재 표시되는 페이지에서 컴포넌트 찾기 (component_no 우선, index 폴백)
    const allComponents = displayComponents;
    const flatComponent =
      allComponents.find(fc => fc.pageNo === request.page_index && fc.data.component_no === request.component_no) ||
      allComponents.find(fc => fc.pageNo === request.page_index && fc.data.index === request.component_no);
    
    if (flatComponent) {
      actualParagraphId = flatComponent.data.id;
    } else {
      // 캐시에서 찾기 (component_no 우선, index 폴백)
      const cachedPage = pageCacheRef.current.get(request.page_index);
      if (cachedPage) {
        const component =
          cachedPage.page.components.find((c: ApiPageComponent) => c.component_no === request.component_no) ||
          cachedPage.page.components.find((c: ApiPageComponent) => c.index === request.component_no);
        if (component) {
          actualParagraphId = component.id;
        }
      }
    }

    // pageNumber는 DB 인덱스(page_no)를 사용해야 함 (렌더링 시 pageNoDb와 비교하기 때문)
    const pageNoDb = request.page_no ?? request.page_index; // page_no가 있으면 사용, 없으면 page_index 사용 (하위 호환성)
    
    const tempAnnotation: OptimisticAnnotation = {
      id: tempId,
      userId: user ? parseInt(user.id) || 0 : 0,
      bookId: 0,
      pageNumber: pageNoDb, // DB 인덱스(page_no) 사용
      type: request.type,
      color: request.color || '#E4FFF0',
      note: request.note,
      componentNo: request.component_no,
      range: {
        paragraphId: actualParagraphId,
        startOffset: request.start_offset,
        endOffset: request.end_offset,
        selectedText: request.text || '', // 선택된 텍스트 저장
      },
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      _isOptimistic: true, // optimistic update 플래그
      _tempId: tempId, // 임시 ID
    };

    // 즉시 상태에 추가
    setAnnotations(prev => {
      const existing = prev.find((a: any) => (a as OptimisticAnnotation)._tempId === tempId);
      if (existing) return prev; // 이미 추가됨
      return [...prev, tempAnnotation as Annotation];
    });

    return tempAnnotation;
  }, [user, displayComponents]);

  // API 호출을 백그라운드로 처리하고 재시도 로직 포함
  const createAnnotationWithRetry = useCallback(async (
    bookUid: string,
    request: CreateAnnotationRequest,
    tempId: string,
    maxRetries: number = 3
  ): Promise<Annotation | null> => {
    let lastError: any = null;
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        const createdAnnotation = await annotationService.createAnnotation(bookUid, request);
        
        // 성공 시 optimistic annotation을 실제 annotation으로 교체
        // paragraphId 매핑 필요 (API 응답은 component-{number} 형식일 수 있음)
        
        // mappedAnnotation을 먼저 생성 (기본 버전)
        let mappedAnnotation: Annotation = {
          ...createdAnnotation,
          range: {
            ...createdAnnotation.range,
            paragraphId: createdAnnotation.range.paragraphId,
          },
          _updatedAt: Date.now(),
        } as Annotation;
        
        // setAnnotations에서 optimistic annotation을 찾아 교체
        setAnnotations(prev => {
          // 함수형 업데이트를 사용하여 최신 상태 참조
          const optimisticAnn = prev.find(a => {
            const optAnn = a as OptimisticAnnotation;
            return optAnn._tempId === tempId;
          }) as OptimisticAnnotation | undefined;
          
          if (!optimisticAnn) {
            // console.warn('[createAnnotationWithRetry] optimistic annotation을 찾을 수 없음, 새로 추가:', tempId);
            // optimistic annotation이 없으면 새로 추가
            return [...prev, mappedAnnotation];
          }
          
          // optimistic annotation을 찾았으면 paragraphId 매핑 업데이트
          mappedAnnotation = {
            ...createdAnnotation,
            range: {
              ...createdAnnotation.range,
              paragraphId: optimisticAnn.range.paragraphId || createdAnnotation.range.paragraphId,
            },
            _updatedAt: Date.now(),
          } as Annotation;
          
          // console.log('[createAnnotationWithRetry] optimistic annotation 교체:', {
          //   tempId,
          //   realId: mappedAnnotation.id,
          //   pageNumber: mappedAnnotation.pageNumber,
          //   foundOptimistic: true,
          // });
          
          // optimistic annotation을 실제 annotation으로 교체
          return prev.map(a => {
            const optAnn = a as OptimisticAnnotation;
            if (optAnn._tempId === tempId) {
              return mappedAnnotation;
            }
            return a;
          });
        });
        
        // 모달의 editingAnnotation도 업데이트 (temp- ID를 가진 모달이 있으면 실제 UUID로 업데이트)
        setOpenModals(prev => {
          const newMap = new Map(prev);
          let updated = false;
          for (const [modalId, modalData] of newMap.entries()) {
            const editingAnn = modalData.editingAnnotation as OptimisticAnnotation | Annotation | null;
            if (editingAnn && (
              editingAnn.id === tempId || 
              (editingAnn as OptimisticAnnotation)._tempId === tempId
            )) {
              newMap.set(modalId, {
                ...modalData,
                editingAnnotation: mappedAnnotation,
              });
              updated = true;
              // console.log('[createAnnotationWithRetry] 모달의 editingAnnotation 업데이트:', { modalId, tempId, realId: mappedAnnotation.id });
              break;
            }
          }
          return newMap;
        });
        
        // 캐시도 업데이트
        const pageNum = request.page_index;
        const cachedPage = pageCacheRef.current.get(pageNum);
        if (cachedPage) {
          pageCacheRef.current.set(pageNum, {
            ...cachedPage,
            annotations: cachedPage.annotations.map((a: Annotation) => {
              const optAnn = a as OptimisticAnnotation;
              if (optAnn._tempId === tempId) {
                return mappedAnnotation;
              }
              return a;
            }),
          });
          // console.log(`[createAnnotationWithRetry] 페이지 ${pageNum} 캐시 업데이트`);
        }

        dispatchLearningRecordsInvalidate(bookUid);
        return mappedAnnotation;
      } catch (error: any) {
        lastError = error;
        // console.error(`[Annotation] 생성 시도 ${attempt}/${maxRetries} 실패:`, error);
        
        // 마지막 시도가 아니면 재시도
        if (attempt < maxRetries) {
          const delay = Math.min(1000 * Math.pow(2, attempt - 1), 5000); // exponential backoff
          await new Promise(resolve => setTimeout(resolve, delay));
          continue;
        }
      }
    }
    
    // 모든 재시도 실패 시 optimistic annotation 제거
    // console.error('[Annotation] 최종 실패, optimistic annotation 제거:', lastError);
    setAnnotations(prev => {
      return prev.filter(a => {
        const optimisticAnn = a as OptimisticAnnotation;
        return optimisticAnn._tempId !== tempId;
      });
    });
    
    return null;
  }, []);

  // 특정 페이지의 주석만 다시 불러와서 state와 캐시 업데이트 (저장 후 1번만 호출)
  const reloadPageAnnotations = useCallback(async (targetPageNum: number, targetPageComponents: ApiPageComponent[]) => {
    if (!bookUid) return;
    
    try {
      // const rawAnnotations = await annotationService.getAnnotations(bookUid, targetPageNum);
      const rawAnnotations: Annotation[] = []; // 주석처리: 단일 페이지 조회 API 비활성화
      const mappedAnnotations = mapAnnotationsParagraphId(rawAnnotations, targetPageComponents);
      
      const newAnnotations = mappedAnnotations.map(a => ({
        ...a,
        _updatedAt: Date.now(),
      }));
      
      // 해당 페이지의 주석만 교체 (다른 페이지 주석은 유지)
      // 단, optimistic annotation(_isOptimistic: true)은 유지 (서버 응답 대기 중)
      setAnnotations(prev => {
        const otherPageAnnotations = prev.filter(a => {
          if (a.pageNumber === targetPageNum) {
            // 해당 페이지의 optimistic annotation은 유지
            const optAnn = a as OptimisticAnnotation;
            if (optAnn._isOptimistic === true) {
              return true; // optimistic annotation은 유지
            }
            return false; // 서버에서 받은 annotation으로 교체
          }
          return true; // 다른 페이지 annotation은 유지
        });
        return [...otherPageAnnotations, ...newAnnotations];
      });
      
      // 캐시도 함께 업데이트 (페이지 이동 후 돌아왔을 때 최신 주석 표시)
      const cachedData = pageCacheRef.current.get(targetPageNum);
      if (cachedData) {
        pageCacheRef.current.set(targetPageNum, {
          ...cachedData,
          annotations: newAnnotations,
        });
        // console.log(`[Cache] 페이지 ${targetPageNum} 주석 캐시 업데이트`);
      }
    } catch (err) {
      // console.error(`페이지 ${targetPageNum} 주석 다시 불러오기 중 오류:`, err);
    }
  }, [bookUid]);

  // usePageData 훅에서 제공하는 함수들을 사용하므로 중복 제거됨

  // 페이지 데이터를 평탄화된 컴포넌트 배열로 변환
  const flattenPageComponents = useCallback((page: ApiPageData, pageIdx: number): FlatComponent[] => {
    if (!page.components) return [];
    // pageIdx는 실제 페이지 번호(idx), page.page_no는 DB 인덱스
    return page.components
      .filter(c => c.kind !== 'header_title')
      .map((data, idx) => ({
        pageNo: pageIdx,        // 실제 페이지 번호 (idx) - 네비게이션용
        pageNoDb: page.page_no, // DB 인덱스 (page_no) - API 호출용
        displayNumber: page.display_number, // 표시용 페이지 번호
        componentIdx: idx,
        data
      }));
  }, []);


  // === 컴포넌트 인덱스 기반 페이지네이션 ===
  
  // 실제 DOM에서 보이는 컴포넌트 확인 (렌더링 후 호출)
  const updateVisibleComponentsFromDOM = useCallback(() => {
    const leftContainer = leftPageContainerRef.current;
    if (!leftContainer || allLoadedComponents.length === 0 || displayComponents.length === 0) return;
    
    const containerRect = leftContainer.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerBottom = containerRect.bottom;
    const viewportTop = window.scrollY;
    const viewportBottom = window.scrollY + window.innerHeight;
    
    // console.log(`[DOM 확인] ==============================`);
    // console.log(`[DOM 확인] 컨테이너: top=${containerTop.toFixed(0)}, bottom=${containerBottom.toFixed(0)}, 높이=${(containerBottom - containerTop).toFixed(0)}px`);
    // console.log(`[DOM 확인] 뷰포트: top=${viewportTop.toFixed(0)}, bottom=${viewportBottom.toFixed(0)}`);
    // console.log(`[DOM 확인] displayStartIndex: ${displayStartIndex}, 전체 컴포넌트: ${allLoadedComponents.length}개`);
    // console.log(`[DOM 확인] 표시 중인 컴포넌트: ${displayComponents.length}개`);
    
    // 현재 표시되는 페이지 범위
    const displayedPages = Array.from(new Set(displayComponents.map(c => c.pageNo))).sort((a, b) => a - b);
    // console.log(`[DOM 확인] 표시 중인 페이지 범위: ${displayedPages[0]} ~ ${displayedPages[displayedPages.length - 1]}`);
    
    // 실제로 화면에 보이는 컴포넌트들 찾기
    const visibleComponents: Array<{ index: number; component: FlatComponent; visibleRatio: number; isFullyVisible: boolean; hasOverflow: boolean }> = [];
    
    // 실제 보이는 영역 (뷰포트와 컨테이너의 교집합)
    const visibleTop = Math.max(containerTop, viewportTop);
    const visibleBottom = Math.min(containerBottom, viewportBottom);
    
    // console.log(`[DOM 확인] 실제 보이는 영역: top=${visibleTop.toFixed(0)}, bottom=${visibleBottom.toFixed(0)}`);
    
    // displayComponents에 있는 컴포넌트만 렌더링되므로, displayComponents 기준으로 확인
    // 하지만 allLoadedComponents의 인덱스를 찾기 위해 매핑 필요
    const componentIndexMap = new Map<string, number>();
    allLoadedComponents.forEach((comp, idx) => {
      const key = `${comp.pageNo}-${comp.componentIdx}`;
      componentIndexMap.set(key, idx);
    });
    
    // 실제 DOM에 있는 모든 컴포넌트 요소 찾기
    const allElements = leftContainer.querySelectorAll('[data-component-key]');
    // console.log(`[DOM 확인] DOM에 있는 컴포넌트 요소 수: ${allElements.length}`);
    
    // 각 요소를 확인하여 보이는지 체크
    for (const element of Array.from(allElements)) {
      const htmlElement = element as HTMLElement;
      const componentKey = htmlElement.getAttribute('data-component-key');
      if (!componentKey) continue;
      
      // allLoadedComponents에서 해당 컴포넌트 찾기
      const globalIndex = componentIndexMap.get(componentKey);
      if (globalIndex === undefined) {
        // console.log(`[DOM 확인] allLoadedComponents에서 찾을 수 없음: ${componentKey}`);
        continue;
      }
      
      const component = allLoadedComponents[globalIndex];
      const rect = htmlElement.getBoundingClientRect();
      const scrollHeight = htmlElement.scrollHeight;
      const clientHeight = htmlElement.clientHeight;
      const hasOverflow = scrollHeight > clientHeight;
      
      // rect.height가 유효한지 확인 (0이거나 NaN이면 스킵)
      if (!rect.height || rect.height <= 0 || isNaN(rect.height)) {
        // console.log(`[DOM 확인] 높이가 유효하지 않음: 인덱스 ${globalIndex}, 페이지 ${component.pageNo}, height=${rect.height}`);
        continue;
      }
      
      // 컴포넌트가 실제 보이는 영역과 겹치는지 확인
      // 컨테이너의 실제 보이는 영역 (뷰포트와 컨테이너의 교집합)
      const elementTop = rect.top;
      const elementBottom = rect.bottom;
      const elementLeft = rect.left;
      const elementRight = rect.right;
      const containerLeft = containerRect.left;
      const containerRight = containerRect.right;
      
      // 요소가 컨테이너의 가로 범위 내에 있는지 확인 (CSS multi-column 고려)
      const isInContainerHorizontal = elementRight > containerLeft && elementLeft < containerRight;
      
      // 요소가 보이는 영역과 겹치는지 확인 (세로)
      const overlapsTop = elementBottom > visibleTop;
      const overlapsBottom = elementTop < visibleBottom;
      const isInVisibleAreaVertical = overlapsTop && overlapsBottom;
      
      // 요소가 실제로 보이는 영역에 있는지 확인 (가로와 세로 모두)
      const isInVisibleArea = isInContainerHorizontal && isInVisibleAreaVertical;
      
      if (isInVisibleArea) {
        // 실제로 보이는 높이 계산
        const visibleTopBound = Math.max(elementTop, visibleTop);
        const visibleBottomBound = Math.min(elementBottom, visibleBottom);
        const visibleHeight = Math.max(0, visibleBottomBound - visibleTopBound);
        const visibleRatio = visibleHeight / rect.height;
        
        // 완전히 보이는지 확인 (상단과 하단이 모두 보이는 영역 내에 있어야 함)
        // CSS multi-column에서 분할된 요소는 scrollHeight > clientHeight이지만 실제로는 보이므로
        // hasOverflow 대신 위치 기반으로만 판단
        const isFullyVisible = elementTop >= visibleTop && elementBottom <= visibleBottom && visibleRatio >= 0.5;
        
        // 최소 30% 이상 보이면 포함 (10%는 너무 낮음)
        if (visibleRatio > 0.3) {
          visibleComponents.push({
            index: globalIndex,
            component,
            visibleRatio,
            isFullyVisible,
            hasOverflow
          });
          
          // if (hasOverflow) {
          //   console.log(`[DOM 확인] 오버플로우 발견! 인덱스: ${globalIndex}, 페이지: ${component.pageNo}, scrollHeight: ${scrollHeight}, clientHeight: ${clientHeight}`);
          // }
        } else {
          // console.log(`[DOM 확인] 보이는 비율이 낮음: 인덱스 ${globalIndex}, 페이지 ${component.pageNo}, 비율 ${(visibleRatio * 100).toFixed(1)}%, top=${elementTop.toFixed(0)}, bottom=${elementBottom.toFixed(0)}, left=${elementLeft.toFixed(0)}, right=${elementRight.toFixed(0)}`);
        }
      } else {
        // 보이지 않는 영역에 있음
        // if (!isInContainerHorizontal) {
        //   console.log(`[DOM 확인] 컨테이너 가로 범위 밖: 인덱스 ${globalIndex}, 페이지 ${component.pageNo}, left=${elementLeft.toFixed(0)}, right=${elementRight.toFixed(0)}, containerLeft=${containerLeft.toFixed(0)}, containerRight=${containerRight.toFixed(0)}`);
        // } else if (!isInVisibleAreaVertical) {
        //   if (elementBottom < visibleTop) {
        //     console.log(`[DOM 확인] 화면 위에 있음: 인덱스 ${globalIndex}, 페이지 ${component.pageNo}, top=${elementTop.toFixed(0)}, bottom=${elementBottom.toFixed(0)}`);
        //   } else if (elementTop > visibleBottom) {
        //     console.log(`[DOM 확인] 화면 아래에 있음: 인덱스 ${globalIndex}, 페이지 ${component.pageNo}, top=${elementTop.toFixed(0)}, bottom=${elementBottom.toFixed(0)}`);
        //   }
        // }
      }
    }
    
    // 인덱스 순서로 정렬
    visibleComponents.sort((a, b) => a.index - b.index);
    
    if (visibleComponents.length > 0) {
      const firstVisible = visibleComponents[0];
      
      // 완전히 보이는 컴포넌트만 필터링 (더 정확한 판단을 위해)
      // 최소 50% 이상 보이고, 상단과 하단이 모두 보이는 영역 내에 있어야 함
      const fullyVisibleComponents = visibleComponents.filter(v => 
        v.isFullyVisible && 
        v.visibleRatio >= 0.5
      );
      
      // console.log(`[DOM 확인] 완전히 보이는 컴포넌트 필터링: 전체 ${visibleComponents.length}개 중 ${fullyVisibleComponents.length}개`);
      
      // 완전히 보이는 컴포넌트가 있으면 그것을 기준으로, 없으면 전체를 기준으로
      const componentsToUse = fullyVisibleComponents.length > 0 ? fullyVisibleComponents : visibleComponents;
      const lastVisible = componentsToUse[componentsToUse.length - 1];
      const lastComponent = lastVisible.component;
      
      // console.log(`[DOM 확인] 실제 보이는 컴포넌트: ${visibleComponents.length}개 (완전히 보임: ${fullyVisibleComponents.length}개)`);
      // console.log(`[DOM 확인] 첫 번째 보이는 컴포넌트: 인덱스 ${firstVisible.index}, 페이지 ${firstVisible.component.pageNo}, 비율 ${(firstVisible.visibleRatio * 100).toFixed(1)}%`);
      // console.log(`[DOM 확인] 마지막 보이는 컴포넌트: 인덱스 ${lastVisible.index}, 페이지 ${lastComponent.pageNo}, 비율 ${(lastVisible.visibleRatio * 100).toFixed(1)}%, 완전히 보임: ${lastVisible.isFullyVisible}, 오버플로우: ${lastVisible.hasOverflow}`);
      
      // 실제로 보이는 첫 번째 컴포넌트가 displayStartIndex와 다르면 CSS multi-column으로 인해 일부가 밀려난 것
      const hasClippedAtStart = firstVisible.index > displayStartIndex;
      // if (hasClippedAtStart) {
      //   console.log(`[DOM 확인] 시작 부분이 잘림! displayStartIndex: ${displayStartIndex}, 실제 첫 번째: ${firstVisible.index}`);
      // }
      
      // 마지막 보이는 컴포넌트가 완전히 보이지 않으면 잘린 것으로 간주
      // CSS multi-column 분할 요소의 hasOverflow 오감지를 방지하기 위해 위치 기반으로만 판단
      const isLastComponentClipped = !lastVisible.isFullyVisible;
      
      // 마지막 보이는 컴포넌트의 페이지 확인
      const lastVisiblePage = lastComponent.pageNo;
      
      // 실제로 보이는 페이지 범위 확인 (완전히 보이는 컴포넌트 기준)
      const visiblePages = Array.from(new Set(componentsToUse.map(v => v.component.pageNo))).sort((a, b) => a - b);
      // console.log(`[DOM 확인] 실제 보이는 페이지 범위: ${visiblePages[0]} ~ ${visiblePages[visiblePages.length - 1]}`);
      
      // 해당 페이지의 마지막 컴포넌트인지 확인
      const lastComponentOfPage = allLoadedComponents
        .filter(c => c.pageNo === lastVisiblePage)
        .sort((a, b) => b.componentIdx - a.componentIdx)[0];
      
      const isLastComponentOfPage = lastComponent.componentIdx === lastComponentOfPage?.componentIdx;
      
      // console.log(`[DOM 확인] 마지막 보이는 페이지: ${lastVisiblePage}`);
      // console.log(`[DOM 확인] 해당 페이지의 마지막 컴포넌트인가: ${isLastComponentOfPage}`);
      // console.log(`[DOM 확인] 컴포넌트가 잘렸는가: ${isLastComponentClipped}`);
      
      // 다음 화면 시작 인덱스 결정
      // 마지막 컴포넌트가 완전히 보이지 않거나 오버플로우가 있거나, 해당 페이지의 마지막 컴포넌트가 아니면
      // 다음 화면에서 이 컴포넌트부터 시작해야 함
      let nextStartIndex: number;
      if (isLastComponentClipped) {
        // 잘린 컴포넌트부터 시작
        nextStartIndex = lastVisible.index;
        // console.log(`[DOM 확인] 마지막 컴포넌트가 잘림 → 다음 화면에서 ${nextStartIndex}부터 시작`);
      } else if (!isLastComponentOfPage) {
        // 해당 페이지의 마지막 컴포넌트가 아니면 다음 컴포넌트부터 시작
        nextStartIndex = lastVisible.index + 1;
        // console.log(`[DOM 확인] 페이지의 마지막 컴포넌트가 아님 → 다음 화면에서 ${nextStartIndex}부터 시작`);
      } else {
        // 완전히 보인 컴포넌트의 다음부터 시작
        nextStartIndex = lastVisible.index + 1;
        // console.log(`[DOM 확인] 완전히 보임 → 다음 화면에서 ${nextStartIndex}부터 시작`);
      }
      
      // console.log(`[DOM 확인] 다음 화면 시작 인덱스: ${nextStartIndex}`);
      // console.log(`[DOM 확인] displayEndIndexRef 업데이트: ${displayEndIndexRef.current} → ${nextStartIndex}`);
      
      // displayEndIndexRef 업데이트
      displayEndIndexRef.current = nextStartIndex;
      
      // 페이지 범위 업데이트 (실제로 보이는 페이지 범위의 마지막 페이지 사용)
      const actualLastVisiblePage = visiblePages.length > 0 ? visiblePages[visiblePages.length - 1] : lastVisiblePage;
      lastVisiblePageRef.current = actualLastVisiblePage;
      // console.log(`[DOM 확인] 마지막 보이는 페이지 업데이트: ${lastVisiblePage} → ${actualLastVisiblePage} (실제 보이는 페이지 범위 기준)`);
      
      // 완전히 표시된 8페이지 그룹을 캐시에 저장
      if (visiblePages.length > 0 && currentPageGroup) {
        const group = currentPageGroup;
        
        // 그룹 내 모든 페이지가 완전히 표시되었는지 확인
        let allPagesFullyDisplayed = true;
        for (let pageNo = group.start; pageNo <= group.end; pageNo++) {
          // allLoadedComponents에 해당 페이지가 있는지 확인
          const hasPage = allLoadedComponents.some(c => c.pageNo === pageNo);
          if (hasPage) {
            // 해당 페이지의 모든 컴포넌트 찾기
            const pageComponents = allLoadedComponents.filter(c => c.pageNo === pageNo);
            // displayComponents에 있는 컴포넌트 찾기
            const displayedPageComponents = displayComponents.filter(c => c.pageNo === pageNo);
            // 모든 컴포넌트가 표시되었는지 확인
            if (pageComponents.length !== displayedPageComponents.length) {
              allPagesFullyDisplayed = false;
              break;
            }
          }
        }
        
        if (allPagesFullyDisplayed) {
          // 그룹 내 모든 컴포넌트 추출
          const groupComponents = allLoadedComponents.filter(
            c => c.pageNo >= group.start && c.pageNo <= group.end
          );
          
          // 캐시 키 생성 (예: "182-189")
          const cacheKey = `${group.start}-${group.end}`;
          pageRangeCacheRef.current.set(cacheKey, groupComponents);
          // console.log(`[캐시 저장] 8페이지 그룹 ${cacheKey} 캐시에 저장 (${groupComponents.length}개 컴포넌트)`);
        } else {
          // console.log(`[캐시 저장] 그룹 내 일부 페이지가 완전히 표시되지 않아 캐시 저장 안 함`);
        }
      }
      
      // console.log(`[DOM 확인] ==============================`);
    } else {
      // console.log(`[DOM 확인] 보이는 컴포넌트 없음`);
      // console.log(`[DOM 확인] 디버깅: displayComponents의 첫 번째와 마지막 컴포넌트 확인`);
      // if (displayComponents.length > 0) {
      //   const firstComp = displayComponents[0];
      //   const lastComp = displayComponents[displayComponents.length - 1];
      //   const firstKey = `${firstComp.pageNo}-${firstComp.componentIdx}`;
      //   const lastKey = `${lastComp.pageNo}-${lastComp.componentIdx}`;
      //   const firstEl = leftContainer.querySelector(`[data-component-key="${firstKey}"]`);
      //   const lastEl = leftContainer.querySelector(`[data-component-key="${lastKey}"]`);
      //   console.log(`[DOM 확인] 첫 번째 컴포넌트 요소 찾기: ${firstKey} -> ${firstEl ? '찾음' : '없음'}`);
      //   console.log(`[DOM 확인] 마지막 컴포넌트 요소 찾기: ${lastKey} -> ${lastEl ? '찾음' : '없음'}`);
      //   if (firstEl) {
      //     const rect = firstEl.getBoundingClientRect();
      //     console.log(`[DOM 확인] 첫 번째 요소 위치: top=${rect.top.toFixed(0)}, bottom=${rect.bottom.toFixed(0)}, 높이=${rect.height.toFixed(0)}`);
      //   }
      //   if (lastEl) {
      //     const rect = lastEl.getBoundingClientRect();
      //     console.log(`[DOM 확인] 마지막 요소 위치: top=${rect.top.toFixed(0)}, bottom=${rect.bottom.toFixed(0)}, 높이=${rect.height.toFixed(0)}`);
      //   }
      // }
    }
  }, [allLoadedComponents, displayStartIndex, displayComponents, currentPageGroup]);

  // === 화면 사이즈에 따른 페이지 그룹 관리 함수 ===
  
  // 전체 페이지를 하나의 그룹으로 관리 (usePageData에서 이미 전체 로드됨)
  const getGroupSize = useCallback((): number => {
    return lastPageIndex;
  }, [lastPageIndex]);
  
  // 페이지 번호로부터 그룹 계산 (화면 사이즈에 따라 그룹 크기 변동)
  const getPageGroup = useCallback((pageNo: number): { start: number; end: number } => {
    const groupSize = getGroupSize();
    
    // 그룹 크기 단위로 그룹 계산
    const groupStart = Math.floor((pageNo - 1) / groupSize) * groupSize + 1;
    const groupEnd = groupStart + groupSize - 1;
    
    return { start: groupStart, end: groupEnd };
  }, [getGroupSize]);

  // 현재 그룹 내에서 남은 데이터 확인
  const getRemainingDataInGroup = useCallback((group: { start: number; end: number }): {
    hasRemaining: boolean;
    startIndex: number;
    components: FlatComponent[];
  } => {
    // console.log('[getRemainingDataInGroup] 시작:', {
    //   group,
    //   displayEndIndexRef: displayEndIndexRef.current,
    //   allLoadedComponentsLength: allLoadedComponents.length
    // });
    
    // 그룹 내 컴포넌트 찾기
    const groupComponents = allLoadedComponents.filter(c => 
      c.pageNo >= group.start && c.pageNo <= group.end
    );
    
    // console.log('[getRemainingDataInGroup] 그룹 내 컴포넌트:', {
    //   groupComponentsCount: groupComponents.length,
    //   groupComponentsPreview: groupComponents.slice(0, 5).map(c => ({
    //     pageNo: c.pageNo,
    //     componentIdx: c.componentIdx,
    //     id: c.data.id
    //   }))
    // });
    
    if (groupComponents.length === 0) {
      // console.log('[getRemainingDataInGroup] 그룹 내 컴포넌트 없음');
      return { hasRemaining: false, startIndex: 0, components: [] };
    }
    
    // 그룹 내 첫 컴포넌트의 인덱스
    const groupStartIndex = allLoadedComponents.indexOf(groupComponents[0]);
    
    // displayEndIndexRef를 기준으로 남은 데이터 확인
    const currentEndIndex = displayEndIndexRef.current;
    const groupEndIndex = groupStartIndex + groupComponents.length;
    
    // 남은 데이터가 있는지 확인
    // currentEndIndex가 groupEndIndex보다 크거나 같으면 모든 컴포넌트를 표시한 것이므로 남은 데이터 없음
    // currentEndIndex가 groupEndIndex - 1일 때만 마지막 컴포넌트가 남아있음 (잘린 컴포넌트 재표시용)
    const hasRemaining = currentEndIndex >= groupStartIndex && currentEndIndex < groupEndIndex;
    
    // 남은 데이터가 있으면 currentEndIndex부터 시작, 없으면 그룹 시작점부터
    const startIndex = hasRemaining ? currentEndIndex : groupStartIndex;
    
    // 남은 컴포넌트 추출
    const remainingComponents = allLoadedComponents.slice(startIndex, groupEndIndex);
    
    const result = {
      hasRemaining,
      startIndex,
      components: remainingComponents.length > 0 ? remainingComponents : groupComponents
    };
    
    // console.log('[getRemainingDataInGroup] 결과:', {
    //   groupStartIndex,
    //   groupEndIndex,
    //   currentEndIndex,
    //   hasRemaining,
    //   startIndex,
    //   remainingComponentsCount: remainingComponents.length,
    //   remainingComponentsPreview: remainingComponents.slice(0, 5).map(c => ({
    //     pageNo: c.pageNo,
    //     componentIdx: c.componentIdx,
    //     id: c.data.id
    //   })),
    //   resultComponentsCount: result.components.length,
    //   resultComponentsPreview: result.components.slice(0, 5).map(c => ({
    //     pageNo: c.pageNo,
    //     componentIdx: c.componentIdx,
    //     id: c.data.id
    //   }))
    // });
    
    return result;
  }, [allLoadedComponents]);

  // 페이지가 완전히 표시되었는지 확인
  const isPageFullyDisplayed = useCallback((pageNo: number): boolean => {
    // 해당 페이지의 모든 컴포넌트 찾기
    const pageComponents = allLoadedComponents.filter(c => c.pageNo === pageNo);
    if (pageComponents.length === 0) return false;
    
    // displayComponents에 있는 컴포넌트 찾기
    const displayedPageComponents = displayComponents.filter(c => c.pageNo === pageNo);
    
    // 모든 컴포넌트가 표시되었는지 확인
    return pageComponents.length === displayedPageComponents.length;
  }, [allLoadedComponents, displayComponents]);

  // 마지막 완전히 표시된 페이지의 다음 컴포넌트 인덱스 찾기
  const getNextPageStartIndex = useCallback((): number => {
    if (displayComponents.length === 0) return 0;
    
    // 표시된 페이지들을 역순으로 확인
    const displayedPages = Array.from(new Set(displayComponents.map(c => c.pageNo))).sort((a, b) => b - a);
    
    // 각 페이지가 완전히 표시되었는지 확인
    for (const pageNo of displayedPages) {
      if (isPageFullyDisplayed(pageNo)) {
        // 완전히 표시된 페이지를 찾았으면, 그 다음 페이지의 첫 컴포넌트 인덱스 반환
        const nextPageNo = pageNo + 1;
        const nextPageFirstComponent = allLoadedComponents.find(c => c.pageNo === nextPageNo);
        if (nextPageFirstComponent) {
          const nextIndex = allLoadedComponents.indexOf(nextPageFirstComponent);
          // console.log(`[다음 페이지 계산] 페이지 ${pageNo} 완전 표시 → 다음 페이지 ${nextPageNo} 시작 인덱스: ${nextIndex}`);
          return nextIndex;
        }
      }
    }
    
    // 완전히 표시된 페이지가 없으면 displayEndIndexRef 사용
    // console.log(`[다음 페이지 계산] 완전히 표시된 페이지 없음 → displayEndIndexRef 사용: ${displayEndIndexRef.current}`);
    return displayEndIndexRef.current;
  }, [allLoadedComponents, displayComponents, isPageFullyDisplayed]);

  // 현재 표시할 컴포넌트 계산 (startIndex부터 화면에 맞는 만큼)
  // 높이 제한 + 페이지 수 제한 모두 적용
  // 중복 컴포넌트 제거 헬퍼 함수
  const removeDuplicateComponents = useCallback((components: FlatComponent[]): FlatComponent[] => {
    const uniqueComponents = components.filter((component, index, self) => {
      return index === self.findIndex((c) => 
        c.pageNo === component.pageNo && 
        c.componentIdx === component.componentIdx &&
        c.data.id === component.data.id
      );
    });
    
    if (uniqueComponents.length !== components.length) {
      // console.warn(`[중복 제거] 컴포넌트 중복 제거: ${components.length}개 → ${uniqueComponents.length}개`);
    }
    
    return uniqueComponents;
  }, []);

  const calculateDisplayComponents = useCallback((
    components: FlatComponent[],
    startIndex: number,
    containerHeight: number,
    containerWidth?: number
  ) => {
    // console.log('[calculateDisplayComponents] 시작:', {
    //   startIndex,
    //   componentsLength: components.length,
    //   containerHeight,
    //   containerWidth,
    //   startComponent: startIndex < components.length ? {
    //     pageNo: components[startIndex].pageNo,
    //     componentIdx: components[startIndex].componentIdx,
    //     id: components[startIndex].data.id,
    //     measuredHeight: components[startIndex].measuredHeight
    //   } : null
    // });
    
    const result: FlatComponent[] = [];
    const isSinglePage = effectivePagesPerViewRef.current === 1;
    const totalMaxHeight = isSinglePage
      ? containerHeight * COLUMN_HEIGHT_SAFETY_FACTOR
      : containerHeight * 2 * COLUMN_HEIGHT_SAFETY_FACTOR;
    const hardMaxHeight = isSinglePage ? containerHeight : containerHeight * 2;
    let currentHeight = 0;

    const includedPages = new Set<number>();

    // float 이미지가 있을 때 텍스트가 좁은 공간에 감싸지므로 높이 보정 필요
    // floatRemainingHeight > 0이면 텍스트가 이미지 옆 ~50% 너비에서 렌더링됨
    let floatRemainingHeight = 0;
    const FLOAT_TEXT_HEIGHT_FACTOR = 1.8; // 50% 너비 → 약 1.8배 높이 필요

    const getColumnRemaining = (curHeight: number) => {
      const posInColumn = curHeight % containerHeight;
      return containerHeight - posInColumn;
    };

    for (let i = startIndex; i < components.length; i++) {
      const component = components[i];
      const height = component.measuredHeight || 50;
      const kind = component.data.kind;

      // float 이미지 옆 텍스트는 좁은 너비에서 렌더링되므로 높이 보정
      let effectiveHeight = height;
      if (floatRemainingHeight > 0 && !IMAGE_KINDS.has(kind)) {
        // 텍스트가 float 이미지 옆에서 감싸지면 더 많은 높이 필요
        effectiveHeight = Math.ceil(height * FLOAT_TEXT_HEIGHT_FACTOR);
        // 보정된 높이(effectiveHeight)만큼 float 영역 소모 (일관성 유지)
        floatRemainingHeight = Math.max(0, floatRemainingHeight - effectiveHeight);
      }

      if (currentHeight + effectiveHeight <= totalMaxHeight) {
        if (IMAGE_KINDS.has(kind)) {
          const colRemaining = getColumnRemaining(currentHeight);
          if (height > colRemaining && colRemaining >= containerHeight * 0.15) {
            // 남은 공간이 15% 이상이면 제한된 높이로 표시
            result.push({ ...component, constrainedHeight: colRemaining });
            currentHeight += colRemaining;
          } else if (height > colRemaining) {
            // 남은 공간이 15% 미만이고 이미지가 안 맞으면 다음 화면으로
            if (result.length === 0) {
              // 첫 컴포넌트면 반드시 표시
              result.push(component);
              currentHeight += height;
              floatRemainingHeight = height;
            } else {
              break;
            }
          } else {
            result.push(component);
            currentHeight += height;
            // float 이미지 (constrainedHeight 없음) → 이후 텍스트 높이 보정 시작
            floatRemainingHeight = height;
          }
        } else {
          result.push(component);
          currentHeight += effectiveHeight;
        }
        includedPages.add(component.pageNo);
      } else {
        // totalMaxHeight 초과 - 이미지는 남은 공간에 맞춰 표시, 텍스트는 hardMaxHeight까지 추가
        if (IMAGE_KINDS.has(kind)) {
          const colRemaining = getColumnRemaining(currentHeight);
          const imageRemaining = Math.min(colRemaining, Math.max(0, hardMaxHeight - currentHeight));
          if (imageRemaining >= containerHeight * 0.15) {
            result.push({ ...component, constrainedHeight: imageRemaining });
            includedPages.add(component.pageNo);
            currentHeight += imageRemaining;
          } else if (result.length === 0) {
            // 첫 번째 컴포넌트가 이미지인데 남은 공간이 부족한 경우:
            // 컨테이너 전체 높이로 제한하여 반드시 표시 (빈 화면 방지)
            const safeHeight = Math.max(containerHeight, height);
            result.push({ ...component, constrainedHeight: safeHeight });
            includedPages.add(component.pageNo);
            currentHeight += safeHeight;
          } else {
            // 이전 컴포넌트가 있으면 여기서 중단 → 이미지는 다음 화면 첫 번째로 표시됨
            break;
          }
        } else if (TEXT_KINDS.has(kind) && currentHeight + effectiveHeight <= hardMaxHeight) {
          // 텍스트는 hardMaxHeight까지 추가 가능 (초과하지 않도록 체크)
          result.push(component);
          currentHeight += effectiveHeight;
          includedPages.add(component.pageNo);
        } else {
          if (result.length === 0) {
            // 첫 컴포넌트는 반드시 표시 (빈 화면 방지)
            result.push(component);
            currentHeight += effectiveHeight;
            includedPages.add(component.pageNo);
          }
          break;
        }
      }
    }
    
    // console.log('[calculateDisplayComponents] 완료:', {
    //   startIndex,
    //   resultCount: result.length,
    //   resultPreview: result.slice(0, 5).map(c => ({
    //     pageNo: c.pageNo,
    //     componentIdx: c.componentIdx,
    //     id: c.data.id,
    //     measuredHeight: c.measuredHeight
    //   })),
    //   lastComponent: result.length > 0 ? {
    //     pageNo: result[result.length - 1].pageNo,
    //     componentIdx: result[result.length - 1].componentIdx,
    //     id: result[result.length - 1].data.id
    //   } : null,
    //   currentHeight,
    //   totalMaxHeight,
    //   includedPages: Array.from(includedPages).sort((a, b) => a - b)
    // });
    
    return result;
  }, []);
  
  // 측정 시작 (페이지 데이터가 로드되면) — 캐시에 있는 전체 페이지 사용
  const startMeasurement = useCallback(async () => {
    if (!pageData || isMeasuring) return;
    
    // 이미 전체 컴포넌트가 로드되어 있으면 스킵
    if (allLoadedComponents.length > 0) {
      return;
    }
    
    setIsMeasuring(true);
    setIsContentReady(false);
    setDisplayStartIndex(0);
    
    // 캐시에서 전체 페이지 컴포넌트 수집 (페이지 순서대로)
    let allComponents: FlatComponent[] = [];
    const pagesToLoad: number[] = [];
    
    const sortedPageNos = Array.from(pageCacheRef.current.keys()).sort((a, b) => a - b);
    for (const pageNo of sortedPageNos) {
      const cached = pageCacheRef.current.get(pageNo);
      if (cached) {
        allComponents = [...allComponents, ...flattenPageComponents(cached.page, pageNo)];
        pagesToLoad.push(pageNo);
      }
    }
    
    // 캐시가 비어 있으면 현재 페이지만이라도 사용
    if (allComponents.length === 0 && pageData) {
      allComponents = [...flattenPageComponents(pageData, currentPageNumber)];
      pagesToLoad.push(currentPageNumber);
      if (nextPageData) {
        allComponents = [...allComponents, ...flattenPageComponents(nextPageData, currentPageNumber + 1)];
        pagesToLoad.push(currentPageNumber + 1);
      }
    }
    
    // console.log(`[측정] 전체 ${pagesToLoad.length}페이지, ${allComponents.length}개 컴포넌트 수집`);
    setLoadedPageNumbers(pagesToLoad);
    setComponentsToMeasure(allComponents);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageData, nextPageData, currentPageNumber, isMeasuring, flattenPageComponents, pageCacheRef, allLoadedComponents]);

  // 측정 완료 후 allLoadedComponents 저장 및 첫 화면 표시
  useEffect(() => {
    if (!isMeasuring || componentsToMeasure.length === 0) return;
    
    const measureAndSetup = () => {
      const measureContainer = measureContainerRef.current;
      const leftContainer = leftPageContainerRef.current;
      
      if (!measureContainer || !leftContainer) {
        // console.log('[측정] 컨테이너 없음');
        setIsMeasuring(false);
        isGroupTransitioningRef.current = false;
        return;
      }
      // 컨테이너 높이가 0이면 레이아웃 미완료 - fallback으로 다중 페이지 표시 가능하게 (한 페이지만 표시되는 현상 방지)
      const containerHeight = Math.max(leftContainer.clientHeight - 5, 600);
      const measuredComponents: FlatComponent[] = [];
      const measureElements = measureContainer.querySelectorAll('[data-measure-idx]');
      
      measureElements.forEach((el, idx) => {
        const height = el.getBoundingClientRect().height;
        const component = componentsToMeasure[idx];
        if (component) {
          measuredComponents.push({
            ...component,
            measuredHeight: height + 16 // 마진 포함
          });
        }
      });
      
      // console.log(`[측정] ${measuredComponents.length}개 컴포넌트 측정 완료`);
      
      // 각 컴포넌트의 측정된 높이 로그
      // console.log(`[측정] 컴포넌트별 높이:`, measuredComponents.map((c, i) => ({
      //   idx: i,
      //   pageNo: c.pageNo,
      //   componentIdx: c.componentIdx,
      //   height: c.measuredHeight
      // })));
      
      // 페이지 순서대로 정렬 (이전 그룹으로 이동할 때 역순 표시를 위해 필요)
      measuredComponents.sort((a, b) => {
        if (a.pageNo !== b.pageNo) {
          return a.pageNo - b.pageNo;
        }
        return a.componentIdx - b.componentIdx;
      });
      
      // 중복 실행 방지: 동일한 페이지 그룹에 대해 이미 처리 중이거나 완료된 경우 스킵
      // 뷰포트/줌 변경 시 재계산을 위해 컨테이너 크기를 setupKey에 포함
      const pageGroup = getPageGroup(currentPageNumber);
      const containerWidth = leftContainer.clientWidth;
      const setupKey = `${pageGroup.start}-${pageGroup.end}-${measuredComponents.length}-${containerHeight}-${containerWidth}`;
      const isPrevGroupMove = isMovingToPrevGroupRef.current;
      
      // 현재 표시 중인 페이지 범위 계산 (ref 사용하여 최신 값 참조)
      const currentDisplay = displayComponentsRef.current;
      const currentDisplayFirstPage = currentDisplay.length > 0 ? currentDisplay[0].pageNo : null;
      const currentDisplayLastPage = currentDisplay.length > 0 ? currentDisplay[currentDisplay.length - 1].pageNo : null;
      const isInSameGroup = currentDisplayFirstPage !== null && 
                           currentDisplayFirstPage >= pageGroup.start && 
                           currentDisplayLastPage !== null &&
                           currentDisplayLastPage <= pageGroup.end;
      
      // 강화된 중복 체크:
      // 1. 같은 페이지 그룹 내에 이미 표시 중이고
      // 2. 이전 그룹 이동이 아닌 경우 스킵 (이전 그룹 이동은 마지막 화면 표시 필요)
      // 단, 뷰포트/줌 변경에 의한 강제 재측정(forceRemeasure)인 경우 스킵하지 않음
      const isForceRemeasure = isForceRemeasureRef.current;
      if (!isForceRemeasure && isInSameGroup && !isPrevGroupMove) {
        // console.log(`[화면 표시] 중복 실행 방지 (displayComponents 기반): setupKey=${setupKey}, 현재 표시=${currentDisplayFirstPage}~${currentDisplayLastPage}, isPrevGroupMove=${isPrevGroupMove}`);
        setIsMeasuring(false);
        isGroupTransitioningRef.current = false;
        return;
      }
      
      // ref 기반 중복 체크 (보조) - 강제 재측정 시에도 스킵하지 않음
      const lastKeyBase = lastCompletedSetupKeyRef.current?.replace('-prev', '') || null;
      if (!isForceRemeasure && lastKeyBase === setupKey && !isPrevGroupMove) {
        // console.log(`[화면 표시] 중복 실행 방지 (ref 기반): setupKey=${setupKey}, lastKey=${lastCompletedSetupKeyRef.current}`);
        setIsMeasuring(false);
        isGroupTransitioningRef.current = false;
        return;
      }
      if (isForceRemeasure) isForceRemeasureRef.current = false;
      
      // 시작 시점에 즉시 키 저장 (완료 전 중복 호출 방지)
      // 이전 그룹 이동 시 -prev 접미사 추가하여 구분
      const effectiveKey = isPrevGroupMove ? `${setupKey}-prev` : setupKey;
      lastCompletedSetupKeyRef.current = effectiveKey;
      // console.log(`[화면 표시] 새로운 setup 시작: setupKey=${setupKey}, isPrevGroupMove=${isPrevGroupMove}, effectiveKey=${effectiveKey}, 현재 표시=${currentDisplayFirstPage}~${currentDisplayLastPage}`);
      
      // 모든 로드된 컴포넌트 저장
      setAllLoadedComponents(measuredComponents);
      isGroupTransitioningRef.current = false;
      
      // console.log(`[CSS Multi-Column] 컨테이너 높이: ${containerHeight}px, 2컬럼 최대: ${containerHeight * 2}px`);
      
      // 현재 페이지 그룹 설정 (8페이지 단위) - 위에서 이미 계산됨
      // 이전 그룹으로 이동한 경우 확인
      // 방법 1: ref를 통한 명시적 표시 (가장 확실한 방법)
      // 방법 2: currentPageGroup이 설정되어 있고, 그 그룹의 시작이 현재 그룹의 시작보다 크면 이전 그룹으로 이동한 것
      const isPrevGroup = isMovingToPrevGroupRef.current || 
        (currentPageGroup !== null && currentPageGroup.start > pageGroup.start);
      
      // 상세 로그 비활성화
      // console.log(`[화면 표시] 그룹 확인: pageGroup=${pageGroup.start}~${pageGroup.end}, isPrevGroup=${isPrevGroup}`);
      
      let visibleComponents: FlatComponent[];
      let startIndex: number;
      
      // 이전 그룹으로 이동하는 경우 무조건 뒤에서부터 표시
      if (isPrevGroup || isMovingToPrevGroupRef.current) {
        // 이전 그룹인 경우: 현재 그룹의 컴포넌트만 필터링하여 마지막 페이지부터 뒤에서 앞으로 화면에 맞는 만큼 표시
        // 중요: 마지막 페이지의 모든 컴포넌트가 반드시 포함되어야 함
        
        // 현재 그룹에 해당하는 컴포넌트만 필터링
        
        const groupComponents = measuredComponents.filter(c => 
          c.pageNo >= pageGroup.start && c.pageNo <= pageGroup.end
        );
        
        // 상세 로그 비활성화 (이전 그룹 화면 분할)

        let startIndexFromGroup = 0;
        
        if (groupComponents.length === 0) {
          // 그룹 컴포넌트가 없으면 전체 사용 (fallback) - calculateDisplayComponents로 일관된 분할
          const fallbackComponents = measuredComponents;

          const fallbackScreens: { startIndex: number; endIndex: number; components: FlatComponent[] }[] = [];
          let fbIdx = 0;
          const fbLimit = fallbackComponents.length;
          let fbIter = 0;

          while (fbIdx < fallbackComponents.length && fbIter < fbLimit) {
            const screenComps = calculateDisplayComponents(fallbackComponents, fbIdx, containerHeight, containerWidth);
            if (screenComps.length === 0) break;

            const endIdx = fbIdx + screenComps.length;
            fallbackScreens.push({ startIndex: fbIdx, endIndex: endIdx, components: screenComps });

            if (endIdx <= fbIdx) break;
            
            // 마지막 컴포넌트가 잘린 이미지면 다음 화면에서 다시 시작
            const lastComp = screenComps[screenComps.length - 1];
            if (lastComp?.constrainedHeight && IMAGE_KINDS.has(lastComp.data.kind)) {
              fbIdx = endIdx - 1;
            } else {
              fbIdx = endIdx;
            }
            fbIter++;
          }

          // 사전 계산된 화면 배열 저장
          precomputedScreensRef.current = fallbackScreens;

          // 마지막 화면 선택
          const lastScreenIdx = fallbackScreens.length - 1;
          activeScreenIndexRef.current = lastScreenIdx;
          const lastScreen = fallbackScreens[lastScreenIdx];

          visibleComponents = lastScreen
            ? lastScreen.components
            : fallbackComponents;

          // 화면 분할 정보 저장 (호환성 유지)
          screenGroupsRef.current = fallbackScreens.map(s => ({
            startIdx: s.startIndex,
            endIdx: s.endIndex - 1,
            pages: Array.from(new Set(s.components.map(c => c.pageNo))).sort((a, b) => a - b),
          }));
          currentScreenIndexRef.current = lastScreenIdx;

          if (fallbackScreens.length > 1 && lastScreen) {
            displayEndIndexRef.current = lastScreen.startIndex;
          } else {
            displayEndIndexRef.current = 0;
          }

          if (visibleComponents.length > 0) {
            const targetComponent = visibleComponents[0];
            startIndex = allLoadedComponents.findIndex(c =>
              c.pageNo === targetComponent.pageNo &&
              c.componentIdx === targetComponent.componentIdx
            );
            if (startIndex === -1 && lastScreen) {
              startIndex = lastScreen.startIndex;
            }
            startIndexFromGroup = lastScreen?.startIndex || 0;
          } else {
            startIndex = 0;
            startIndexFromGroup = 0;
          }
          
        } else {
          // 그룹 컴포넌트 사용
          // 목표 페이지가 설정되어 있으면 해당 페이지까지 표시, 없으면 그룹의 마지막 페이지까지 표시
          const targetPageNo = targetPageForPrevGroupRef.current;
          const groupLastPageNo = groupComponents[groupComponents.length - 1]?.pageNo;
          const lastPageNo = targetPageNo !== null && targetPageNo <= groupLastPageNo
            ? targetPageNo
            : groupLastPageNo;
          
          // 상세 로그 비활성화 (componentsToUse 생성)
          
          // 목표 페이지까지의 컴포넌트만 필터링 (목표 페이지가 설정된 경우)
          let componentsToUse = targetPageNo !== null && targetPageNo < groupLastPageNo
            ? groupComponents.filter(c => c.pageNo <= targetPageNo)
            : groupComponents;
          
          // ⚠️ 중요: componentsToUse가 정렬되어 있는지 확인하고 정렬 보장
          const isSorted = componentsToUse.every((c, idx) => {
            if (idx === 0) return true;
            const prev = componentsToUse[idx - 1];
            if (prev.pageNo !== c.pageNo) {
              return prev.pageNo < c.pageNo;
            }
            return prev.componentIdx <= c.componentIdx;
          });
          
          if (!isSorted) {
            // console.warn(`[화면 표시] componentsToUse가 정렬되지 않음! 정렬 수행`);
            componentsToUse = [...componentsToUse].sort((a, b) => {
              if (a.pageNo !== b.pageNo) {
                return a.pageNo - b.pageNo;
              }
              return a.componentIdx - b.componentIdx;
            });
          }
          
          // 마지막 페이지의 모든 컴포넌트 인덱스 찾기 (componentsToUse 기준, 0부터 시작)
          // 뒤에서부터 마지막 페이지의 마지막 컴포넌트 인덱스 찾기 (첫 발견이 마지막 인덱스)
          let lastPageLastIndex = -1;
          for (let i = componentsToUse.length - 1; i >= 0; i--) {
            if (componentsToUse[i].pageNo === lastPageNo) {
              lastPageLastIndex = i;
              break;  // 첫 발견이 마지막 인덱스이므로 바로 break
            }
          }
          if (lastPageLastIndex === -1) {
            lastPageLastIndex = componentsToUse.length - 1;  // fallback
          }
          
          // 앞에서부터 마지막 페이지의 첫 컴포넌트 인덱스 찾기
          let lastPageFirstIndex = lastPageLastIndex;
          for (let i = lastPageLastIndex - 1; i >= 0; i--) {
            if (componentsToUse[i].pageNo === lastPageNo) {
              lastPageFirstIndex = i;
            } else {
              break;
            }
          }
          
          // 디버깅 로그 비활성화 (마지막 페이지 컴포넌트 상세)
          const lastPageComponents = componentsToUse.filter(c => c.pageNo === lastPageNo);
          
          if (lastPageFirstIndex < 0 || lastPageLastIndex < 0 || lastPageFirstIndex > lastPageLastIndex) {
            // console.error(`[화면 표시] 마지막 페이지(${lastPageNo})를 찾을 수 없음!`);
            // fallback: 전체 표시
            visibleComponents = componentsToUse;
            startIndex = allLoadedComponents.indexOf(componentsToUse[0]);
            startIndexFromGroup = 0;
          } else {
            // ⚠️ 이전 그룹 이동 시: calculateDisplayComponents를 일관되게 사용하여 화면 분할
            // (높이 기반 직접 분할 대신 동일한 함수를 사용하여 정방향/역방향 분할 결과 일치 보장)
            const prevGroupScreens: { startIndex: number; endIndex: number; components: FlatComponent[] }[] = [];
            let scanIdx = 0;
            const scanLimit = componentsToUse.length;
            let scanIter = 0;

            while (scanIdx < componentsToUse.length && scanIter < scanLimit) {
              const screenComps = calculateDisplayComponents(componentsToUse, scanIdx, containerHeight, containerWidth);
              if (screenComps.length === 0) break;

              const endIdx = scanIdx + screenComps.length;
              prevGroupScreens.push({ startIndex: scanIdx, endIndex: endIdx, components: screenComps });

              if (endIdx <= scanIdx) break;
              
              // 마지막 컴포넌트가 잘린 이미지면 다음 화면에서 다시 시작
              const lastComp = screenComps[screenComps.length - 1];
              if (lastComp?.constrainedHeight && IMAGE_KINDS.has(lastComp.data.kind)) {
                scanIdx = endIdx - 1;
              } else {
                scanIdx = endIdx;
              }
              scanIter++;
            }

            // 사전 계산된 화면 배열 저장 (이전/다음 이동 시 일관된 결과 보장)
            // componentsToUse 기반 인덱스를 measuredComponents 기반으로 변환
            const prevGroupScreensMapped = prevGroupScreens.map(s => {
              const firstComp = s.components[0];
              const mappedStart = measuredComponents.findIndex(c =>
                c.pageNo === firstComp.pageNo && c.componentIdx === firstComp.componentIdx
              );
              return {
                startIndex: mappedStart !== -1 ? mappedStart : s.startIndex,
                endIndex: mappedStart !== -1 ? mappedStart + s.components.length : s.endIndex,
                components: s.components,
              };
            });
            precomputedScreensRef.current = prevGroupScreensMapped;

            // 마지막 화면 선택 (이전 그룹 이동이므로 뒤에서부터)
            const lastScreenIdx = prevGroupScreens.length - 1;
            activeScreenIndexRef.current = lastScreenIdx;
            const lastScreen = prevGroupScreens[lastScreenIdx];

            visibleComponents = lastScreen
              ? lastScreen.components
              : componentsToUse;

            // 화면 분할 정보 저장 (호환성 유지)
            screenGroupsRef.current = prevGroupScreens.map(s => ({
              startIdx: s.startIndex,
              endIdx: s.endIndex - 1,
              pages: Array.from(new Set(s.components.map(c => c.pageNo))).sort((a, b) => a - b),
            }));
            currentScreenIndexRef.current = lastScreenIdx;

            if (lastScreenIdx > 0 && lastScreen) {
              displayEndIndexRef.current = lastScreen.startIndex;
            } else {
              displayEndIndexRef.current = 0;
            }

            // startIndex 계산
            if (visibleComponents.length > 0) {
              const targetComponent = visibleComponents[0];
              startIndex = measuredComponents.findIndex(c =>
                c.pageNo === targetComponent.pageNo &&
                c.componentIdx === targetComponent.componentIdx
              );

              if (startIndex === -1 && lastScreen) {
                startIndex = lastScreen.startIndex;
              }

              startIndexFromGroup = lastScreen?.startIndex || 0;
            } else {
              startIndex = 0;
              startIndexFromGroup = 0;
            }
          }
        }
        
        // 이전 그룹으로 이동하는 것을 처리했으므로 ref 리셋
        isMovingToPrevGroupRef.current = false;
        targetPageForPrevGroupRef.current = null;
        
        const firstPage = visibleComponents.length > 0 ? visibleComponents[0].pageNo : currentPageNumber;
        const lastPage = visibleComponents.length > 0 ? visibleComponents[visibleComponents.length - 1].pageNo : currentPageNumber;
        const expectedLastPage = pageGroup.end;
        
        // 역순 표시 완료
      } else {
        // 일반적인 경우: 모든 화면(screen) 경계를 사전 계산하여 캐싱
        // 처음부터 끝까지 calculateDisplayComponents를 반복 호출하여 모든 화면 분할을 한 번에 계산
        const allScreens: { startIndex: number; endIndex: number; components: FlatComponent[] }[] = [];
        let scanIdx = 0;
        const scanSafetyLimit = measuredComponents.length;
        let scanIterations = 0;

        while (scanIdx < measuredComponents.length && scanIterations < scanSafetyLimit) {
          const screenComponents = calculateDisplayComponents(measuredComponents, scanIdx, containerHeight, leftContainer.clientWidth);
          if (screenComponents.length === 0) break;

          let endIdx = scanIdx + screenComponents.length;
          
          // 마지막 컴포넌트가 constrainedHeight인지 확인 (이미지가 잘린 경우)
          const lastComp = screenComponents[screenComponents.length - 1];
          const isLastConstrained = lastComp?.constrainedHeight !== undefined;
          
          
          allScreens.push({ startIndex: scanIdx, endIndex: endIdx, components: screenComponents });

          if (endIdx <= scanIdx) break; // 무한 루프 방지
          
          // 마지막 컴포넌트가 잘렸으면 다음 화면에서 그 컴포넌트부터 다시 시작
          // (단, 이미지의 경우에만 - 텍스트는 CSS multi-column이 자동으로 연속 처리)
          if (isLastConstrained && IMAGE_KINDS.has(lastComp.data.kind)) {
            scanIdx = endIdx - 1; // 잘린 이미지를 다음 화면 처음부터 다시 표시
          } else {
            scanIdx = endIdx;
          }
          scanIterations++;
        }

        // 사전 계산된 화면 배열 캐싱
        precomputedScreensRef.current = allScreens;

        // 페이지별 전체 컴포넌트 수 확인
        const pageComponentCounts = new Map<number, number>();
        measuredComponents.forEach(c => {
          pageComponentCounts.set(c.pageNo, (pageComponentCounts.get(c.pageNo) || 0) + 1);
        });
        
        // 화면별로 각 페이지의 컴포넌트가 모두 포함되었는지 확인
        const pageScreenMapping = new Map<number, { total: number; inScreens: number[] }>();
        pageComponentCounts.forEach((count, pageNo) => {
          pageScreenMapping.set(pageNo, { total: count, inScreens: [] });
        });
        
        allScreens.forEach((screen, screenIdx) => {
          const pagesInScreen = new Set<number>();
          screen.components.forEach(c => pagesInScreen.add(c.pageNo));
          pagesInScreen.forEach(pageNo => {
            const mapping = pageScreenMapping.get(pageNo);
            if (mapping) mapping.inScreens.push(screenIdx);
          });
        });
        
        // 한 화면에만 있으면서 일부만 포함된 페이지 찾기
        pageScreenMapping.forEach((mapping, pageNo) => {
          if (mapping.inScreens.length === 1) {
            const screenIdx = mapping.inScreens[0];
            const screen = allScreens[screenIdx];
            const compsInScreen = screen.components.filter(c => c.pageNo === pageNo).length;
            if (compsInScreen < mapping.total) {
              console.error(`[페이지불완전] 페이지 ${pageNo}: 전체 ${mapping.total}개 중 ${compsInScreen}개만 화면 ${screenIdx}에 포함 (${mapping.total - compsInScreen}개 누락)`);
            }
          }
        });

        // currentPageNumber에 해당하는 화면 찾기
        // pendingComponentNo가 있으면 해당 컴포넌트가 포함된 화면 우선 선택
        let targetScreenIndex = 0;
        let foundByComponentNo = false;
        
        if (pendingComponentNo !== null) {
          // pendingComponentNo를 포함하는 화면 찾기
          for (let si = 0; si < allScreens.length; si++) {
            const screen = allScreens[si];
            const hasTargetComponent = screen.components.some(
              c => c.pageNo === currentPageNumber && c.data.component_no === pendingComponentNo
            );
            if (hasTargetComponent) {
              targetScreenIndex = si;
              foundByComponentNo = true;
              break;
            }
          }
        }
        
        // pendingComponentNo로 찾지 못했으면 기존 로직 사용
        if (!foundByComponentNo) {
          for (let si = 0; si < allScreens.length; si++) {
            const screen = allScreens[si];
            const screenPages = screen.components.map(c => c.pageNo);
            if (screenPages.includes(currentPageNumber)) {
              targetScreenIndex = si;
              break;
            }
            // currentPageNumber보다 큰 페이지가 시작되면 그 직전 화면 사용
            if (screenPages.length > 0 && screenPages[0] > currentPageNumber) {
              targetScreenIndex = Math.max(0, si - 1);
              break;
            }
            targetScreenIndex = si; // 마지막 화면 사용 (fallback)
          }
        }

        activeScreenIndexRef.current = targetScreenIndex;
        const targetScreen = allScreens[targetScreenIndex];

        if (targetScreen) {
          visibleComponents = targetScreen.components;
          startIndex = targetScreen.startIndex;
          displayEndIndexRef.current = targetScreen.endIndex;
        } else {
          // fallback: 기존 로직
          const targetStartIndex = measuredComponents.findIndex(c => c.pageNo >= currentPageNumber);
          const actualStartIndex = targetStartIndex !== -1 ? targetStartIndex : 0;
          visibleComponents = calculateDisplayComponents(measuredComponents, actualStartIndex, containerHeight, leftContainer.clientWidth);
          startIndex = actualStartIndex;
          displayEndIndexRef.current = actualStartIndex + visibleComponents.length;
        }
        // 이전 그룹으로 이동하는 것이 아니므로 ref 리셋
        isMovingToPrevGroupRef.current = false;
      }
      
      // 페이지 범위 계산
      const firstPage = visibleComponents.length > 0 ? visibleComponents[0].pageNo : currentPageNumber;
      const lastPage = visibleComponents.length > 0 ? visibleComponents[visibleComponents.length - 1].pageNo : currentPageNumber;
      
      firstVisiblePageRef.current = firstPage;
      lastVisiblePageRef.current = lastPage;
      
      // 값이 변경된 경우에만 setCurrentPageGroup 호출 (불필요한 useEffect 트리거 방지)
      if (!currentPageGroup || 
          currentPageGroup.start !== pageGroup.start || 
          currentPageGroup.end !== pageGroup.end) {
        setCurrentPageGroup(pageGroup);
      }
      setDisplayStartIndex(startIndex);
      
      // 현재 표시되는 페이지별 컴포넌트 수 계산
      const pageComponentCounts = new Map<number, number>();
      visibleComponents.forEach(c => {
        pageComponentCounts.set(c.pageNo, (pageComponentCounts.get(c.pageNo) || 0) + 1);
      });
      
      // 각 페이지의 전체 컴포넌트 수 계산
      const totalPageComponentCounts = new Map<number, number>();
      measuredComponents.forEach(c => {
        totalPageComponentCounts.set(c.pageNo, (totalPageComponentCounts.get(c.pageNo) || 0) + 1);
      });
      
      // console.log(`[화면 표시] ==============================`);
      // console.log(`[화면 표시] 컴포넌트 인덱스: 0 ~ ${visibleComponents.length - 1} (총 ${visibleComponents.length}개)`);
      // console.log(`[화면 표시] 페이지 범위: ${firstPage} ~ ${lastPage}`);
      // console.log(`[화면 표시] 다음 화면 시작 인덱스: ${displayEndIndexRef.current} / 전체: ${measuredComponents.length}`);
      // console.log(`[화면 표시] 페이지별 표시 상태:`);
      // Array.from(pageComponentCounts.keys()).sort((a, b) => a - b).forEach(pageNo => {
      //   const displayed = pageComponentCounts.get(pageNo) || 0;
      //   const total = totalPageComponentCounts.get(pageNo) || 0;
      //   const isComplete = displayed === total;
      //   console.log(`[화면 표시]   페이지 ${pageNo}: ${displayed}/${total}개 표시 ${isComplete ? '(완전)' : '(일부)'}`);
      // });
      // console.log(`[화면 표시] ==============================`);
      
      // 중복 제거
      const uniqueVisibleComponents = removeDuplicateComponents(visibleComponents);
      
      // 상태 업데이트
      setDisplayComponents(uniqueVisibleComponents);
      setComponentsToMeasure([]);
      
      // 핵심 로그만 유지
      // console.log(`[화면 표시] setup 완료: effectiveKey=${effectiveKey}, 표시 페이지=${visibleComponents[0]?.pageNo}~${visibleComponents[visibleComponents.length - 1]?.pageNo}`);
      
      setIsMeasuring(false);
      
      // 이전 그룹으로 이동했을 때 목표 페이지로 스크롤할지 확인
      const shouldScrollToTarget = targetPageForPrevGroupRef.current !== null;
      const targetPageNo = targetPageForPrevGroupRef.current;
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsContentReady(true);
          // 페이지 이동 후 레이아웃 재계산 강제 (resize 시에만 표시되는 현상 방지)
          requestAnimationFrame(() => {
            void leftPageContainerRef.current?.offsetHeight;
            void measureContainerRef.current?.offsetHeight;
          });
          // 렌더링 후 실제 DOM 확인 및 스크롤 (약간의 지연 후) - window 스크롤 사용
          setTimeout(() => {
            if (shouldScrollToTarget && targetPageNo !== null) {
              const targetElement = document.querySelector(`[data-page-marker="${targetPageNo}"]`);
              if (targetElement) {
                const elementRect = targetElement.getBoundingClientRect();
                const currentScrollY = window.scrollY;
                const targetScrollY = currentScrollY + elementRect.top - 200; // 200px 여유 (상단 여백)
                window.scrollTo({ top: Math.max(0, targetScrollY), behavior: 'smooth' });
                // console.log(`[화면 표시] 목표 페이지(${targetPageNo})로 스크롤`);
              } else {
                // console.warn(`[화면 표시] 목표 페이지(${targetPageNo}) 요소를 찾을 수 없음`);
              }
            }
            updateVisibleComponentsFromDOM();
          }, 300);
        });
      });
    };
    
    const timer = setTimeout(measureAndSetup, 50);
    return () => clearTimeout(timer);
    // currentPageGroup 제거: getPageGroup(currentPageNumber)로 이미 계산하므로 불필요
    // currentPageGroup 변경 시 불필요한 재실행 방지
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMeasuring, componentsToMeasure, currentPageNumber, calculateDisplayComponents, updateVisibleComponentsFromDOM]);
  
  // 렌더링 후 실제 DOM에서 보이는 컴포넌트 확인
  useEffect(() => {
    if (!isContentReady || displayComponents.length === 0) return;
    
    // 렌더링 완료 후 실제 DOM 확인
    const timer = setTimeout(() => {
      updateVisibleComponentsFromDOM();
    }, 200); // 렌더링 완료 대기
    
    return () => clearTimeout(timer);
  }, [isContentReady, displayComponents, updateVisibleComponentsFromDOM]);
  
  // === 사전 계산된 화면 기반 다음/이전 페이지 핸들러 ===
  const handleNextPageByIndex = useCallback(async () => {
    // 다음 페이지 버튼 클릭 시 되돌아가기 버튼 및 강조 표시 닫기
    setShowGoBackButton(false);
    setGoBackPageNo(null);
    setHighlightedAnnotationId(null);
    // 페이지 이동 시 열린 스티키 노트 모달 닫기
    setOpenModals(new Map());
    setNewNoteModalId(null);
    setIsModalOpen(false);

    if (isGroupTransitioningRef.current) {
      return;
    }

    const screens = precomputedScreensRef.current;
    const currentIdx = activeScreenIndexRef.current;

    // 사전 계산된 화면이 있으면 인덱스 기반으로 이동 (항상 동일한 페이지 분할 보장)
    if (screens.length > 0 && currentIdx < screens.length - 1) {
      const nextIdx = currentIdx + 1;
      const nextScreen = screens[nextIdx];
      
      
      activeScreenIndexRef.current = nextIdx;

      setDisplayStartIndex(nextScreen.startIndex);
      displayEndIndexRef.current = nextScreen.endIndex;

      const updatedGroup = getPageGroup(nextScreen.components[0].pageNo);
      setCurrentPageGroup(updatedGroup);

      const firstPage = nextScreen.components[0].pageNo;
      const lastPage = nextScreen.components[nextScreen.components.length - 1].pageNo;
      firstVisiblePageRef.current = firstPage;
      lastVisiblePageRef.current = lastPage;
      if (bookUid) {
        bookService.updateProgress(bookUid, firstPage).catch(() => {});
      }

      const uniqueVisibleComponents = removeDuplicateComponents(nextScreen.components);
      setDisplayComponents(uniqueVisibleComponents);
      setIsContentReady(true);

      // 다음 페이지 이동 시 화면 분할 정보 초기화
      screenGroupsRef.current = [];
      currentScreenIndexRef.current = 0;

      setTimeout(() => {
        updateVisibleComponentsFromDOM();
      }, 300);
      return;
    }

    // fallback: 사전 계산된 화면이 없으면 기존 로직 사용
    const leftContainer = leftPageContainerRef.current;
    if (!leftContainer) {
      return;
    }

    screenGroupsRef.current = [];
    currentScreenIndexRef.current = 0;

    const currentDisplayedPage = displayComponents.length > 0
      ? displayComponents[0].pageNo
      : currentPageNumber;
    const currentGroup = getPageGroup(currentDisplayedPage);

    const remaining = getRemainingDataInGroup(currentGroup);
    const containerHeight = leftContainer.clientHeight - 5;

    if (remaining.hasRemaining && remaining.components.length > 0) {
      if (remaining.startIndex === displayStartIndex) {
        // 동일 컴포넌트 반복 감지 → fall through
      } else {
      const visibleComponents = calculateDisplayComponents(allLoadedComponents, remaining.startIndex, containerHeight, leftContainer.clientWidth);

      if (visibleComponents.length > 0) {
        const newEndIndex = remaining.startIndex + visibleComponents.length;
        setDisplayStartIndex(remaining.startIndex);
        displayEndIndexRef.current = newEndIndex;
        const updatedGroup = getPageGroup(visibleComponents[0].pageNo);
        setCurrentPageGroup(updatedGroup);

        const firstPage = visibleComponents[0].pageNo;
        const lastPage = visibleComponents[visibleComponents.length - 1].pageNo;
        firstVisiblePageRef.current = firstPage;
        lastVisiblePageRef.current = lastPage;
        if (bookUid) {
          bookService.updateProgress(bookUid, firstPage).catch(() => {});
        }

        const uniqueVisibleComponents = removeDuplicateComponents(visibleComponents);
        setDisplayComponents(uniqueVisibleComponents);
        setIsContentReady(true);

        setTimeout(() => {
          updateVisibleComponentsFromDOM();
        }, 300);
        return;
      }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookUid, currentPageGroup, displayComponents, currentPageNumber, getRemainingDataInGroup, allLoadedComponents, calculateDisplayComponents, handleNavigateToPage, updateVisibleComponentsFromDOM]);
  
  const handlePrevPageByIndex = useCallback(async () => {
    // 이전 페이지 버튼 클릭 시 되돌아가기 버튼 및 강조 표시 닫기
    setShowGoBackButton(false);
    setGoBackPageNo(null);
    setHighlightedAnnotationId(null);
    // 페이지 이동 시 열린 스티키 노트 모달 닫기
    setOpenModals(new Map());
    setNewNoteModalId(null);
    setIsModalOpen(false);

    if (isGroupTransitioningRef.current) {
      return;
    }

    const screens = precomputedScreensRef.current;
    const currentIdx = activeScreenIndexRef.current;

    // 사전 계산된 화면이 있으면 인덱스 기반으로 이동 (항상 동일한 페이지 분할 보장)
    if (screens.length > 0 && currentIdx > 0) {
      const prevIdx = currentIdx - 1;
      const prevScreen = screens[prevIdx];
      activeScreenIndexRef.current = prevIdx;

      setDisplayStartIndex(prevScreen.startIndex);
      displayEndIndexRef.current = prevScreen.endIndex;

      const updatedGroup = getPageGroup(prevScreen.components[0].pageNo);
      setCurrentPageGroup(updatedGroup);

      const firstPage = prevScreen.components[0].pageNo;
      const lastPage = prevScreen.components[prevScreen.components.length - 1].pageNo;
      firstVisiblePageRef.current = firstPage;
      lastVisiblePageRef.current = lastPage;
      if (bookUid) {
        bookService.updateProgress(bookUid, firstPage).catch(() => {});
      }

      const uniqueVisibleComponents = removeDuplicateComponents(prevScreen.components);
      setDisplayComponents(uniqueVisibleComponents);
      setIsContentReady(true);

      // 이전 페이지 이동 시 화면 분할 정보 초기화
      screenGroupsRef.current = [];
      currentScreenIndexRef.current = 0;

      setTimeout(() => {
        updateVisibleComponentsFromDOM();
      }, 300);
      return;
    }

    // fallback: 사전 계산된 화면이 없으면 기존 로직 사용
    const leftContainer = leftPageContainerRef.current;
    if (!leftContainer) return;

    screenGroupsRef.current = [];
    currentScreenIndexRef.current = 0;

    const containerHeight = leftContainer.clientHeight - 5;

    const currentDisplayedPage = displayComponents.length > 0
      ? displayComponents[0].pageNo
      : currentPageNumber;
    const currentGroup = getPageGroup(currentDisplayedPage);

    const groupComponents = allLoadedComponents.filter(c =>
      c.pageNo >= currentGroup.start && c.pageNo <= currentGroup.end
    );

    if (groupComponents.length === 0) {
      return;
    }

    const groupStartIndex = allLoadedComponents.indexOf(groupComponents[0]);

    let actualDisplayStartIndex = displayStartIndex;
    if (displayComponents.length > 0) {
      const firstDisplayComponent = displayComponents[0];
      const foundIndex = allLoadedComponents.findIndex(c =>
        c.pageNo === firstDisplayComponent.pageNo &&
        c.componentIdx === firstDisplayComponent.componentIdx
      );
      if (foundIndex !== -1) {
        actualDisplayStartIndex = foundIndex;
      }
    }

    if (actualDisplayStartIndex <= groupStartIndex) {
      return;
    }

    const fallbackScreens: { startIndex: number; components: FlatComponent[] }[] = [];
    let scanIndex = groupStartIndex;
    const safetyLimit = allLoadedComponents.length;
    let iterations = 0;

    while (scanIndex < actualDisplayStartIndex && iterations < safetyLimit) {
      const visibleComponents = calculateDisplayComponents(
        allLoadedComponents, scanIndex, containerHeight, leftContainer.clientWidth
      );
      if (visibleComponents.length === 0) break;

      const endIndex = scanIndex + visibleComponents.length;
      fallbackScreens.push({ startIndex: scanIndex, components: visibleComponents });

      if (endIndex <= scanIndex) break;
      scanIndex = endIndex;
      iterations++;
    }

    if (fallbackScreens.length === 0) {
      return;
    }

    const prevScreen = fallbackScreens[fallbackScreens.length - 1];
    const visibleComponents = prevScreen.components;
    const newStartIndex = prevScreen.startIndex;
    const newEndIndex = newStartIndex + visibleComponents.length;

    setDisplayStartIndex(newStartIndex);
    displayEndIndexRef.current = newEndIndex;
    const updatedGroup = getPageGroup(visibleComponents[0].pageNo);
    setCurrentPageGroup(updatedGroup);

    const firstPage = visibleComponents[0].pageNo;
    const lastPage = visibleComponents[visibleComponents.length - 1].pageNo;
    firstVisiblePageRef.current = firstPage;
    lastVisiblePageRef.current = lastPage;
    if (bookUid) {
      bookService.updateProgress(bookUid, firstPage).catch(() => {});
    }

    const uniqueVisibleComponents = removeDuplicateComponents(visibleComponents);
    setDisplayComponents(uniqueVisibleComponents);
    setIsContentReady(true);

    setTimeout(() => {
      updateVisibleComponentsFromDOM();
    }, 300);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookUid, currentPageGroup, displayComponents, displayStartIndex, allLoadedComponents, currentPageNumber, calculateDisplayComponents, handleNavigateToPage, updateVisibleComponentsFromDOM]);

  // usePageNavigation 훅에서 진행 상태 업데이트를 처리하므로 제거됨

  // 이전 페이지 번호 추적 (무한 루프 방지)
  const prevPageNumberRef = useRef<number | null>(null);
  const prevForceNavigateRef = useRef<number | undefined>(undefined);

  // 페이지 변경 시 상태 초기화 (URL 변경 시에만)
  useEffect(() => {
    const forceNavigateValue = locationState?.forceNavigate;
    const isSamePageForceNavigate = prevPageNumberRef.current === currentPageNumber
      && forceNavigateValue !== undefined
      && prevForceNavigateRef.current !== forceNavigateValue;

    // 같은 페이지면 스킵 (무한 루프 방지) — 단, forceNavigate가 변경된 경우는 실행
    if (prevPageNumberRef.current === currentPageNumber && !isSamePageForceNavigate) {
      return;
    }

    // forceNavigate 값 업데이트
    prevForceNavigateRef.current = forceNavigateValue;

    // console.log('[페이지 변경] 상태 초기화:', {
    //   prevPage: prevPageNumberRef.current,
    //   currentPage: currentPageNumber,
    //   isSamePageForceNavigate,
    //   forceNavigateValue,
    // });

    // 같은 페이지 재이동 (forceNavigate) 시: 컴포넌트/측정은 유지하고 어노테이션만 재로드
    if (isSamePageForceNavigate) {
      // annotation reload effect가 다시 트리거되도록 리셋
      annotationLoadTriggerRef.current = '';

      // API에서 최신 어노테이션 재로드 (pageCacheRef는 건드리지 않음 - 다른 페이지 이동 시 영향 방지)
      reloadAllAnnotationsRef.current().catch(err => {
        // console.error('[Annotation] 같은 페이지 재로드 실패:', err);
      });

      prevPageNumberRef.current = currentPageNumber;
      return;
    }

    // 다른 페이지로 이동 시: 전체 상태 초기화
    // pendingHighlightAnnotationId가 있으면 어노테이션 초기화를 하지 않음 (강조 표시를 위해)
    if (!pendingHighlightAnnotationId) {
      setAnnotations([]);
    }

    // 페이지 변경 시 강조 표시 및 타이머 초기화
    if (!pendingHighlightAnnotationId) {
      if (highlightTimerRef.current) {
        clearTimeout(highlightTimerRef.current);
        highlightTimerRef.current = null;
      }
      setHighlightedAnnotationId(null);
    } else {
      if (highlightTimerRef.current) {
        clearTimeout(highlightTimerRef.current);
        highlightTimerRef.current = null;
      }
    }

    setAllLoadedComponents([]);
    setDisplayStartIndex(0);
    displayEndIndexRef.current = 0;
    setDisplayComponents([]);
    setLoadedPageNumbers([]);
    setComponentsToMeasure([]);
    setIsMeasuring(false);
    setIsContentReady(false);
    setCurrentPageGroup(null);
    lastCompletedSetupKeyRef.current = null;
    precomputedScreensRef.current = [];
    activeScreenIndexRef.current = 0;
    annotationLoadTriggerRef.current = '';

    // 페이지 변경 시 열린 메모 모달 닫기
    setOpenModals(new Map());
    setNewNoteModalId(null);
    setIsModalOpen(false);

    // 이전/다음 페이지 버튼으로 이동 시 되돌아가기 버튼 닫기
    if (!pendingHighlightAnnotationId) {
      setShowGoBackButton(false);
      setGoBackPageNo(null);
    }

    // 이전 페이지 번호 업데이트
    prevPageNumberRef.current = currentPageNumber;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageNumber, pendingHighlightAnnotationId, locationState?.forceNavigate]);

  // pageData가 로드되면 측정 시작
  useEffect(() => {
    if (!pageData || isMeasuring) return;
    
    // 이미 로드된 컴포넌트가 있고 표시 중이면 스킵
    if (isContentReady && displayComponents.length > 0) return;
    
    // allLoadedComponents가 있고 현재 페이지와 일치하면 스킵
    if (allLoadedComponents.length > 0 && allLoadedComponents[0]?.pageNo === currentPageNumber) {
      // console.log(`[측정 스킵] 이미 로드된 데이터 사용`);
      return;
    }
    
    // DOM 렌더링 대기 후 측정 시작
    const timer = setTimeout(() => {
      startMeasurement();
    }, 50);

    return () => clearTimeout(timer);
  }, [pageData, nextPageData, isMeasuring, isContentReady, currentPageNumber, displayComponents.length, startMeasurement]);

  // 뷰포트/줌 변경 시 강제 재측정 (일반 창 크기 조절용)
  const forceRemeasure = useCallback(() => {
    const loaded = allLoadedComponentsRef.current;
    if (loaded.length === 0) return;
    isForceRemeasureRef.current = true;
    precomputedScreensRef.current = []; // 뷰포트 변경 시 사전 계산된 화면 무효화
    activeScreenIndexRef.current = 0;
    setIsContentReady(false);
    setIsMeasuring(true);
    setComponentsToMeasure([...loaded]);
  }, []);

  // 브라우저 확대/축소 감지 시 현재 페이지로 다시 navigate하여 컴포넌트 재로드 (state 유지)
  const initialDevicePixelRatioRef = useRef(window.devicePixelRatio);
  
  // 브라우저 확대/축소 시 현재 페이지로 다시 navigate (state 유지하면서 컴포넌트 재로드)
  const handleZoomReload = useCallback(() => {
    if (!bookUid) return;

    // 현재 페이지로 다시 navigate (state에 timestamp 추가하여 강제 location 변경)
    const targetPath = `/api-book/viewer/${bookUid}/${currentPageNumber}`;
    navigate(targetPath, {
      replace: true,
      state: {
        forceReload: Date.now(),
        // 기존 state 유지
        pendingHighlightAnnotationId,
        pendingComponentNo,
        showGoBackButton,
        goBackPageNo,
      }
    });

    // devicePixelRatio 업데이트
    initialDevicePixelRatioRef.current = window.devicePixelRatio;
  }, [bookUid, currentPageNumber, navigate, pendingHighlightAnnotationId, pendingComponentNo, showGoBackButton, goBackPageNo]);
  
  useEffect(() => {
    let zoomTimeoutRef: ReturnType<typeof setTimeout> | null = null;
    let resizeTimeoutRef: ReturnType<typeof setTimeout> | null = null;

    const handleZoomChange = () => {
      const currentRatio = window.devicePixelRatio;
      // devicePixelRatio가 변경되면 브라우저 확대/축소로 판단하여 페이지 재로드
      if (Math.abs(currentRatio - initialDevicePixelRatioRef.current) > 0.01) {
        // 줌 감지 시 resize에 의한 불필요한 forceRemeasure 취소
        if (resizeTimeoutRef) clearTimeout(resizeTimeoutRef);
        handleZoomReload();
      }
    };

    const handleResize = () => {
      // 일반 창 크기 조절은 forceRemeasure로 처리
      forceRemeasure();
    };

    const debouncedZoom = () => {
      if (zoomTimeoutRef) clearTimeout(zoomTimeoutRef);
      zoomTimeoutRef = setTimeout(handleZoomChange, 300);
    };

    const debouncedResize = () => {
      if (resizeTimeoutRef) clearTimeout(resizeTimeoutRef);
      resizeTimeoutRef = setTimeout(handleResize, 150);
    };

    // 브라우저 확대/축소 감지를 위한 matchMedia 사용
    const mqString = `(resolution: ${window.devicePixelRatio}dppx)`;
    const mq = window.matchMedia(mqString);
    const handleMqChange = () => {
      debouncedZoom();
    };
    mq.addEventListener('change', handleMqChange);

    // 일반 창 크기 조절
    window.addEventListener('resize', debouncedResize);

    const container = leftPageContainerRef.current ?? viewerContainerNode;
    const resizeObserver = container
      ? (() => {
          const ro = new ResizeObserver(debouncedResize);
          ro.observe(container);
          return ro;
        })()
      : null;

    return () => {
      if (zoomTimeoutRef) clearTimeout(zoomTimeoutRef);
      if (resizeTimeoutRef) clearTimeout(resizeTimeoutRef);
      mq.removeEventListener('change', handleMqChange);
      window.removeEventListener('resize', debouncedResize);
      resizeObserver?.disconnect();
    };
  }, [forceRemeasure, viewerContainerNode, handleZoomReload]);

  // effectivePagesPerView 변경 시 강제 재측정 (첨부파일 패널 열기/닫기로 1쪽↔2쪽 전환)
  const prevEffectivePagesPerViewRef = useRef(effectivePagesPerView);
  useEffect(() => {
    if (prevEffectivePagesPerViewRef.current !== effectivePagesPerView) {
      prevEffectivePagesPerViewRef.current = effectivePagesPerView;
      forceRemeasure();
    }
  }, [effectivePagesPerView, forceRemeasure]);

  // 폰트 설정 변경 시 페이지 재구성은 저장 버튼 클릭 시 새로고침으로 처리
  // (Layout.tsx의 handleSaveFontSettings에서 window.location.reload() 호출)

  // annotation 재로드 (분배 완료 후) - 무한 루프 방지를 위해 ref 사용
  useEffect(() => {
    if (!bookUid || !isContentReady || displayComponents.length === 0) return;
    if (!pageData) return; // pageData가 없으면 스킵
    
    // 실제로 표시되는 페이지 범위를 기반으로 트리거 생성 (CSS Multi-Column용)
    const allDisplayedComponents = displayComponents;
    if (allDisplayedComponents.length === 0) return;
    
    const displayedPageNumbers = Array.from(new Set(allDisplayedComponents.map(comp => comp.pageNo))).sort((a, b) => a - b);
    const pageRangeKey = `${displayedPageNumbers[0]}-${displayedPageNumbers[displayedPageNumbers.length - 1]}-${displayedPageNumbers.length}`;
    
    // 페이지 범위가 변경되었을 때만 로드 (중복 호출 방지)
    if (annotationLoadTriggerRef.current === pageRangeKey) {
      return; // 이미 로드됨
    }
    annotationLoadTriggerRef.current = pageRangeKey;
    
    // console.log(`[Annotation] 페이지 범위 변경 감지: ${pageRangeKey}, 어노테이션 재로드`);

    // 약간의 지연 후 annotation 로드 (무한 루프 방지)
    const timer = setTimeout(() => {
      reloadAllAnnotations().catch(err => {
        // console.error('[Annotation] 로드 실패:', err);
      });
    }, 200);
    
    return () => clearTimeout(timer);
  }, [bookUid, isContentReady, displayComponents, pageData, reloadAllAnnotations]);

  // 강조 표시 useEffect의 이전 값 추적을 위한 ref
  const prevHighlightEffectRef = useRef<{
    pendingHighlightAnnotationId: string | null;
    annotationIds: string;
    currentPageNumber: number;
    isContentReady: boolean;
    forceNavigate: number | undefined;
  }>({
    pendingHighlightAnnotationId: null,
    annotationIds: '',
    currentPageNumber: 0,
    isContentReady: false,
    forceNavigate: undefined
  });
  
  // pendingHighlightAnnotationId가 있고 어노테이션이 로드되면 강조 표시 설정
  useEffect(() => {
    // 이전 값과 비교하여 실제로 변경되었는지 확인
    const annotationIds = annotations.map(a => a.id).sort().join(',');
    const forceNavigateValue = locationState?.forceNavigate;
    const currentValues = {
      pendingHighlightAnnotationId,
      annotationIds,
      currentPageNumber,
      isContentReady,
      forceNavigate: forceNavigateValue
    };
    
    const prevValues = prevHighlightEffectRef.current;
    const hasChanged = 
      prevValues.pendingHighlightAnnotationId !== currentValues.pendingHighlightAnnotationId ||
      prevValues.annotationIds !== currentValues.annotationIds ||
      prevValues.currentPageNumber !== currentValues.currentPageNumber ||
      prevValues.isContentReady !== currentValues.isContentReady ||
      prevValues.forceNavigate !== currentValues.forceNavigate;
    
    if (!hasChanged) {
      // 값이 변경되지 않았으면 실행하지 않음
      return;
    }
    
    // 이전 값 업데이트
    prevHighlightEffectRef.current = currentValues;
    
    // console.log('[강조 표시 useEffect] 실행:', {
    //   pendingHighlightAnnotationId,
    //   annotationCount: annotations.length,
    //   currentPage: currentPageNumber,
    //   isContentReady
    // });
    
    if (!pendingHighlightAnnotationId) {
      // pending이 없으면 아무것도 하지 않음 (타이머는 계속 실행되도록 함)
      return;
    }
    
    // 어노테이션이 아직 로드되지 않았으면 대기
    if (annotations.length === 0) {
      // console.log('[강조 표시] 어노테이션 대기 중:', pendingHighlightAnnotationId, '현재 페이지:', currentPageNumber);
      return;
    }
    
    // 기존 타이머 정리 (새로운 강조 표시를 설정하기 전에)
    if (highlightTimerRef.current) {
      clearTimeout(highlightTimerRef.current);
      highlightTimerRef.current = null;
    }
    
    // 어노테이션 목록에서 해당 ID 찾기 (모든 어노테이션에서 검색)
    let matchedAnnotation = annotations.find(a => a.id === pendingHighlightAnnotationId);
    
    // ID가 일치하는 어노테이션을 찾았을 때, 해당 어노테이션이 현재 페이지에 있는지 확인
    if (matchedAnnotation) {
      // 어노테이션의 pageNumber는 page_no (DB 인덱스)이고, currentPageNumber는 idx (실제 페이지 번호)임
      // currentPageNumber (idx)를 page_no로 변환하여 비교
      const currentPageNo = findPageNoFromIdx(currentPageNumber);
      const annotationPageNo = matchedAnnotation.pageNumber;
      
      // 현재 페이지와 어노테이션의 페이지가 일치하는지 확인
      if (currentPageNo !== null && annotationPageNo === currentPageNo) {
        // console.log('[강조 표시] 어노테이션 로드 완료, 강조 표시 설정:', {
        //   annotationId: matchedAnnotation.id,
        //   currentPageIdx: currentPageNumber,
        //   currentPageNo: currentPageNo,
        //   annotationPageNo: annotationPageNo,
        //   pendingId: pendingHighlightAnnotationId
        // });
        // 어노테이션이 로드되었고 현재 페이지에 있으면 강조 표시 설정
        setHighlightedAnnotationId(matchedAnnotation.id);
        
        // 메모 타입이면 StickyNoteModal 열기 (학습 기록 패널에서 클릭 시 학생/교수 동일 모달)
        if (matchedAnnotation.type === 'note') {
          const noteAnnotation = matchedAnnotation;
          const noteLines = noteAnnotation.note ? noteAnnotation.note.split('\n') : [];
          const colorMap: Record<string, 'green' | 'yellow' | 'blue'> = {
            '#EBFFCF': 'green', '#FEFFCF': 'yellow', '#E3F2FF': 'blue',
          };
          let originalTitle = noteLines[0] || '';
          let originalText = noteLines.slice(1).join('\n') || '';
          if (pendingMemoFallback && (!originalText.trim() || !originalTitle.trim())) {
            if (!originalTitle.trim() && pendingMemoFallback.title) originalTitle = pendingMemoFallback.title;
            if (!originalText.trim() && pendingMemoFallback.subject) originalText = pendingMemoFallback.subject;
          }
          let modalX = window.innerWidth / 2;
          let modalY = window.innerHeight / 2;
          
          // 화면에 보이는 메모 요소 찾기 (HighlightMarker가 있는 것 우선)
          const container = leftPageContainerRef.current;
          const containerRect = container?.getBoundingClientRect();
          const allNoteEls = document.querySelectorAll(`[data-note-id="${noteAnnotation.id}"], [data-annotation-id="${noteAnnotation.id}"]`);
          let visibleNoteEl: Element | null = null;
          
          for (const el of allNoteEls) {
            const rect = el.getBoundingClientRect();
            if (rect.height === 0) continue;
            
            const isInContainer = containerRect
              ? (rect.top < containerRect.bottom && rect.bottom > containerRect.top &&
                 rect.left < containerRect.right && rect.right > containerRect.left)
              : true;
            
            if (!isInContainer) continue;
            
            // HighlightMarker가 있는 요소 우선
            if (el.querySelector('[data-highlight-marker]')) {
              visibleNoteEl = el;
              break;
            }
            if (!visibleNoteEl) visibleNoteEl = el;
          }
          
          if (visibleNoteEl) {
            const rect = visibleNoteEl.getBoundingClientRect();
            modalX = Math.min(rect.right + 20, window.innerWidth - 350);
            modalY = Math.max(rect.top - 50, 20);
            const existingPositions = Array.from(openModals.values())
              .map(m => m.position)
              .filter((p): p is { x: number; y: number } => p !== undefined);
            let adjustedY = modalY;
            let attempts = 0;
            while (attempts < 10) {
              const overlaps = existingPositions.some(pos =>
                Math.abs(pos.x - modalX) < 350 && Math.abs(pos.y - adjustedY) < 300
              );
              if (!overlaps) break;
              adjustedY += 50;
              attempts++;
            }
            modalY = adjustedY;
          } else {
            modalX = Math.min(window.innerWidth / 2 + 100, window.innerWidth - 350);
            modalY = Math.max(100, 20);
          }
          const currentUserId = user ? parseInt(user.id) || 0 : 0;
          const isOwner = noteAnnotation.userId === currentUserId;
          setOpenModals(prev => {
            const newMap = new Map(prev);
            newMap.set(noteAnnotation.id, {
              noteTitle: originalTitle,
              noteText: originalText,
              noteColor: colorMap[noteAnnotation.color || ''] || 'yellow',
              noteAttachments: [],
              showNoteMenu: false,
              showColorPicker: false,
              isNoteEditMode: false,
              editingAnnotation: noteAnnotation,
              position: { x: modalX, y: modalY },
              originalNoteTitle: originalTitle,
              originalNoteText: originalText,
              canEdit: isOwner,
            });
            return newMap;
          });
        }
        
        // 캐시 무효화하여 강조 표시가 즉시 반영되도록 함
        renderTextWithHighlightsCache.current.clear();
        setPendingHighlightAnnotationId(null);
        setPendingComponentNo(null);
        setPendingMemoFallback(null);
        setPendingSharedAnnotationData(null);
        
        // 강조 표시 유지 (타이머 제거 - 계속 유지)
      } else {
        // 어노테이션은 찾았지만 현재 페이지가 아니면 대기 (페이지가 변경 중일 수 있음)
        // console.log('[강조 표시] 어노테이션 찾음, 하지만 현재 페이지와 다름, 대기:', {
        //   annotationId: matchedAnnotation.id,
        //   annotationPageNo: annotationPageNo,
        //   currentPageIdx: currentPageNumber,
        //   currentPageNo: currentPageNo,
        //   pendingId: pendingHighlightAnnotationId
        // });
      }
    } else {
      // ID가 일치하는 어노테이션을 찾지 못함
      // pendingSharedAnnotationData가 있으면 임시 어노테이션 생성하여 강조 표시
      if (pendingSharedAnnotationData && pendingComponentNo !== null) {
        const currentPageNo = findPageNoFromIdx(currentPageNumber);
        if (currentPageNo !== null) {
          // componentNo로 해당 컴포넌트의 paragraphId 찾기 (ref 사용으로 무한 루프 방지)
          const currentDisplayComponents = displayComponentsRef.current;
          const targetComponent = currentDisplayComponents.find(c => 
            c.pageNoDb === currentPageNo && c.data.component_no === pendingComponentNo
          );
          const paragraphId = targetComponent?.data.id;
          
          if (paragraphId) {
            // 임시 어노테이션 객체 생성
            const tempAnnotation = {
              id: pendingHighlightAnnotationId!,
              userId: 0,
              bookId: bookId,
              pageNumber: currentPageNo,
              type: (pendingSharedAnnotationData.type?.toLowerCase() === 'memo' ? 'note' :
                     pendingSharedAnnotationData.type?.toLowerCase() === 'underline' ? 'underline' :
                     pendingSharedAnnotationData.type?.toLowerCase() === 'box' ? 'box' : 'highlight') as 'highlight' | 'note' | 'underline' | 'box',
              color: pendingSharedAnnotationData.color || '#4169E1',
              range: {
                paragraphId: paragraphId,
                startOffset: pendingSharedAnnotationData.startOffset,
                endOffset: pendingSharedAnnotationData.endOffset,
                selectedText: pendingSharedAnnotationData.selectedText || '',
              },
              paragraphId: paragraphId,
              componentNo: pendingComponentNo ?? undefined,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
              _isSharedFolder: true,
            } as Annotation & { _isSharedFolder?: boolean };
            
            // 임시 어노테이션을 annotations에 추가 (이미 없는 경우에만)
            setAnnotations(prev => {
              if (prev.some(a => a.id === tempAnnotation.id)) {
                return prev;
              }
              return [...prev, tempAnnotation];
            });
            
            // 강조 표시 설정
            setHighlightedAnnotationId(pendingHighlightAnnotationId);
            
            // 캐시 무효화하여 강조 표시가 즉시 반영되도록 함
            renderTextWithHighlightsCache.current.clear();
            setPendingHighlightAnnotationId(null);
            setPendingComponentNo(null);
            setPendingMemoFallback(null);
            setPendingSharedAnnotationData(null);
          }
        }
      }
      // console.log('[강조 표시] 어노테이션 대기 중 (ID 불일치):', {
      //   pendingId: pendingHighlightAnnotationId,
      //   currentPageIdx: currentPageNumber,
      //   annotationCount: annotations.length,
      //   annotationIds: annotations.map(a => a.id),
      //   annotationPages: annotations.map(a => ({ id: a.id, pageNo: a.pageNumber }))
      // });
    }
  }, [annotations, pendingHighlightAnnotationId, pendingMemoFallback, pendingSharedAnnotationData, pendingComponentNo, currentPageNumber, isContentReady, findPageNoFromIdx, locationState?.forceNavigate, bookId]);

  // 되돌아가기 버튼: 강조 표시 첫 글자 바로 위에 배치
  const updateHighlightMarkerPosition = useCallback(() => {
    if (!showGoBackButton || !highlightedAnnotationId) {
      setHighlightMarkerPosition(null);
      hasScrolledToHighlightRef.current = null;
      return;
    }
    
    const viewportWidth = window.innerWidth;
    const container = leftPageContainerRef.current;
    const containerRect = container?.getBoundingClientRect();

    // 현재 강조 표시된 어노테이션 요소 찾기
    // data-annotation-id가 일치하고, data-highlight-marker가 있으며, 화면에 보이는 요소
    const allElements = document.querySelectorAll(`[data-annotation-id="${highlightedAnnotationId}"]`);
    let highlightedEl: Element | null = null;

    for (const el of allElements) {
      const rect = el.getBoundingClientRect();
      if (rect.height === 0) continue;
      
      // 화면에 보이는지 확인
      const isInContainer = containerRect
        ? (rect.top < containerRect.bottom &&
           rect.bottom > containerRect.top &&
           rect.left < containerRect.right &&
           rect.right > containerRect.left)
        : true;
      
      if (!isInContainer) continue;
      
      // HighlightMarker(data-highlight-marker)가 있는 요소 우선
      const hasMarker = el.querySelector('[data-highlight-marker]');
      if (hasMarker) {
        highlightedEl = el;
        break;
      }
      
      // 마커가 없어도 화면에 보이는 첫 번째 요소 저장 (fallback)
      if (!highlightedEl) {
        highlightedEl = el;
      }
    }

    // 보이는 요소가 없으면 화면 전환 시도
    if (!highlightedEl && containerRect && allElements.length > 0) {
      const fallbackEl = allElements[0];
      const componentKey = (fallbackEl as HTMLElement).closest('[data-component-key]')?.getAttribute('data-component-key');
      if (componentKey) {
        const screens = precomputedScreensRef.current;
        for (let si = 0; si < screens.length; si++) {
          const screen = screens[si];
          const hasComponent = screen.components.some(
            c => `${c.pageNo}-${c.componentIdx}` === componentKey
          );
          if (hasComponent && si !== activeScreenIndexRef.current) {
            activeScreenIndexRef.current = si;
            setDisplayStartIndex(screen.startIndex);
            displayEndIndexRef.current = screen.endIndex;
            const uniqueComps = removeDuplicateComponents(screen.components);
            setDisplayComponents(uniqueComps);
            setIsContentReady(true);
            hasScrolledToHighlightRef.current = null;
            setTimeout(() => updateHighlightMarkerPosition(), 300);
            return;
          }
        }
      }
      highlightedEl = fallbackEl;
    }

    if (!highlightedEl) {
      // 요소를 찾지 못함 - 되돌아가기 버튼 숨김
      setShowGoBackButton(false);
      setGoBackPageNo(null);
      setHighlightedAnnotationId(null);
      return;
    }

    const rect = highlightedEl.getBoundingClientRect();

    // 위치 계산 - 어노테이션 첫 글자 바로 위에 배치
    const buttonHeight = 40;
    const buttonWidth = 130;
    const gap = 8;
    
    let top = rect.top - buttonHeight - gap;
    let left = rect.left;
    
    // 화면 경계 처리
    if (top < 12) top = rect.bottom + gap;
    if (left + buttonWidth > viewportWidth - 12) left = viewportWidth - buttonWidth - 12;
    if (left < 12) left = 12;
    
    setHighlightMarkerPosition({ top, left });
    hasScrolledToHighlightRef.current = highlightedAnnotationId;
  }, [showGoBackButton, highlightedAnnotationId, removeDuplicateComponents]);

  useEffect(() => {
    if (!showGoBackButton) {
      setHighlightMarkerPosition(null);
      hasScrolledToHighlightRef.current = null;
      return;
    }
    if (!highlightedAnnotationId || !isContentReady) {
      setHighlightMarkerPosition(null);
      hasScrolledToHighlightRef.current = null;
      return;
    }

    // DOM에 어노테이션 요소가 나타날 때까지 폴링
    // updateHighlightMarkerPosition 내부에서 화면 전환 후 재호출할 수 있으므로
    // cancelled 플래그로 cleanup 시 중단
    let cancelled = false;
    let isPositionSet = false;
    let pollCount = 0;
    const maxPolls = 15;
    let pollTimer: ReturnType<typeof setTimeout> | null = null;

    const trySetPosition = () => {
      if (cancelled) return;
      const els = document.querySelectorAll(`[data-annotation-id="${highlightedAnnotationId}"]`);
      if (els.length > 0) {
        // DOM 요소 발견 → 위치 확정
        updateHighlightMarkerPosition();
        isPositionSet = true;
      } else if (pollCount < maxPolls) {
        // 아직 DOM에 없으면 재시도 (화면 전환으로 리렌더링 중일 수 있음)
        pollCount++;
        pollTimer = setTimeout(trySetPosition, 200);
      } else {
        // 폴링 최대 횟수 초과 - 어노테이션을 찾을 수 없으므로 되돌아가기 버튼 숨김
        setShowGoBackButton(false);
        setGoBackPageNo(null);
        setHighlightedAnnotationId(null);
      }
    };

    // 초기 200ms 대기 후 폴링 시작
    pollTimer = setTimeout(trySetPosition, 200);

    // 스크롤/리사이즈 시에는 즉시 위치 갱신 (이미 표시된 상태이므로)
    const updateHandler = () => {
      if (isPositionSet) {
        requestAnimationFrame(() => updateHighlightMarkerPosition());
      }
    };
    window.addEventListener('scroll', updateHandler, { passive: true });
    window.addEventListener('resize', updateHandler, { passive: true });
    const container = leftPageContainerRef.current;
    if (container) container.addEventListener('scroll', updateHandler, { passive: true });
    return () => {
      cancelled = true;
      if (pollTimer) clearTimeout(pollTimer);
      window.removeEventListener('scroll', updateHandler);
      window.removeEventListener('resize', updateHandler);
      container?.removeEventListener('scroll', updateHandler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showGoBackButton, highlightedAnnotationId, updateHighlightMarkerPosition, isContentReady]);

  // 폰트 설정 변경 시 위치 갱신 (레이아웃이 바뀌므로)
  useEffect(() => {
    if (!showGoBackButton || !highlightMarkerPosition) return;
    const timer = setTimeout(() => {
      updateHighlightMarkerPosition();
    }, 300);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontSettings]);

  // 같은 페이지에서 다른 화면의 컴포넌트로 이동할 때 화면 전환 (학습기록 클릭 시)
  useEffect(() => {
    if (pendingComponentNo === null || !isContentReady) return;
    
    const screens = precomputedScreensRef.current;
    if (screens.length === 0) return;
    
    // 현재 화면에 해당 컴포넌트가 있는지 확인
    const currentScreenIdx = activeScreenIndexRef.current;
    const currentScreen = screens[currentScreenIdx];
    if (!currentScreen) return;
    
    const hasComponentInCurrentScreen = currentScreen.components.some(
      c => c.pageNo === currentPageNumber && c.data.component_no === pendingComponentNo
    );
    
    // 현재 화면에 있으면 전환 불필요
    if (hasComponentInCurrentScreen) return;
    
    // 해당 컴포넌트가 포함된 화면 찾기
    for (let si = 0; si < screens.length; si++) {
      const screen = screens[si];
      const hasTargetComponent = screen.components.some(
        c => c.pageNo === currentPageNumber && c.data.component_no === pendingComponentNo
      );
      if (hasTargetComponent && si !== currentScreenIdx) {
        // 해당 화면으로 전환
        activeScreenIndexRef.current = si;
        setDisplayStartIndex(screen.startIndex);
        displayEndIndexRef.current = screen.endIndex;
        const uniqueComps = removeDuplicateComponents(screen.components);
        setDisplayComponents(uniqueComps);
        break;
      }
    }
  }, [pendingComponentNo, currentPageNumber, isContentReady, removeDuplicateComponents]);

  // usePageData 훅에서 제공하는 함수들을 사용하므로 중복 제거됨

  // usePageData 훅에서 페이지 데이터 로드 및 백그라운드 로드를 처리하므로 제거됨

  const handleBackToList = () => {
    navigate('/book/list');
  };

  // 컴포넌트 찾기 헬퍼 함수 (여러 페이지 구조 지원)
  const findComponentByIdAndPage = useCallback((paragraphId: string, pageNum: number): ApiPageComponent | undefined => {
    // 먼저 displayComponents에서 찾기
    const flatComponent = displayComponents.find(
      fc => fc.data.id === paragraphId && fc.pageNo === pageNum
    );
    if (flatComponent) {
      return flatComponent.data;
    }
    
    // allLoadedComponents에서 찾기
    const flatComponent2 = allLoadedComponents.find(
      fc => fc.data.id === paragraphId && fc.pageNo === pageNum
    );
    if (flatComponent2) {
      return flatComponent2.data;
    }
    
    // 페이지 캐시에서 찾기
    const cachedPage = pageCacheRef.current.get(pageNum);
    if (cachedPage) {
      return cachedPage.page.components.find((c: ApiPageComponent) => c.id === paragraphId);
    }
    
    return undefined;
  }, [displayComponents, allLoadedComponents]);

  // 텍스트 선택 핸들러 (여러 문단 지원)
  const handleTextSelection = useCallback(() => {
    // 학습 기록 패널이 열려있으면 툴바를 표시하지 않음
    if (showLearningRecords) {
      return;
    }
    
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      // console.log('[TextSelection] 선택 영역 없음');
      setToolbarPosition(null);
      setSelectedRange(null);
      setSelectedPageNumber(null);
      setSelectedRanges([]);
      return;
    }

    const range = selection.getRangeAt(0);
    const selectedText = selection.toString().trim();
    
    // console.log('[TextSelection] 텍스트 선택 감지:', { selectedText: selectedText.substring(0, 50), length: selectedText.length });
    
    if (!selectedText || selectedText.length === 0) {
      // console.log('[TextSelection] 선택된 텍스트 없음');
      setToolbarPosition(null);
      setSelectedRange(null);
      setSelectedPageNumber(null);
      setSelectedRanges([]);
      return;
    }

    // 두 페이지 컨테이너 모두 확인
    const isInFirstPage = contentRef.current && contentRef.current.contains(range.commonAncestorContainer);
    const isInSecondPage = contentRef2.current && contentRef2.current.contains(range.commonAncestorContainer);
    
    // 선택 영역이 두 페이지에 걸쳐 있을 수 있으므로 두 컨테이너 모두 확인
    const allComponents = displayComponents;
    
    // console.log('[TextSelection] 페이지 확인:', { isInFirstPage, isInSecondPage, componentsCount: allComponents.length });
    
    if ((!isInFirstPage && !isInSecondPage) || allComponents.length === 0) {
      // console.warn('[TextSelection] 페이지 컨테이너에 없거나 컴포넌트 없음');
      setToolbarPosition(null);
      return;
    }

    // 선택 범위 내의 모든 paragraph 요소 찾기
    const findParagraphsInRange = (): HTMLElement[] => {
      const paragraphs: HTMLElement[] = [];
      
      // 두 컨테이너 모두에서 paragraph 요소 검색
      const containers = [contentRef.current, contentRef2.current].filter(Boolean) as HTMLElement[];
      
      for (const container of containers) {
        const allParagraphElements = container.querySelectorAll('[data-paragraph-id]');
        allParagraphElements.forEach((el) => {
          const htmlEl = el as HTMLElement;
          // 선택 범위와 해당 요소가 교차하는지 확인
          if (selection.containsNode(htmlEl, true)) {
            paragraphs.push(htmlEl);
          }
        });
      }
      
      return paragraphs;
    };

    const paragraphElements = findParagraphsInRange();
    
    // 단일 문단 내에서만 선택한 경우 - 기존 로직 사용
    if (paragraphElements.length <= 1) {
      // data-paragraph-id와 data-page-no를 가진 부모 요소 찾기
      let node: Node | null = range.commonAncestorContainer;
      let paragraphElement: HTMLElement | null = null;
      const currentContentRef = isInFirstPage ? contentRef.current : contentRef2.current;

      while (node && currentContentRef && node !== currentContentRef) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as HTMLElement;
          if (element.hasAttribute && element.hasAttribute('data-paragraph-id')) {
            paragraphElement = element;
            break;
          }
        }
        node = node.parentNode;
      }

      if (!paragraphElement) {
        // console.warn('[TextSelection] paragraphElement를 찾을 수 없음');
        setToolbarPosition(null);
        return;
      }

      const paragraphId = paragraphElement.getAttribute('data-paragraph-id');
      const pageNoStr = paragraphElement.getAttribute('data-page-no');
      
      // console.log('[TextSelection] paragraphElement 찾음:', { paragraphId, pageNoStr });
      
      if (!paragraphId || !pageNoStr) {
        // console.warn('[TextSelection] paragraphId 또는 pageNoStr 없음');
        setToolbarPosition(null);
        return;
      }

      // data-page-no는 DB 인덱스(page_no)를 의미
      const pageNoDb = parseInt(pageNoStr, 10);
      
      // page_no에서 idx로 변환 (displayComponents에서 찾기)
      const allComponents = displayComponents;
      const flatComponent = allComponents.find(fc => fc.pageNoDb === pageNoDb);
      const actualPageIdx = flatComponent ? flatComponent.pageNo : null;
      
      if (actualPageIdx === null) {
        // console.warn('[TextSelection] page_no에서 idx로 변환 실패:', pageNoDb);
        setToolbarPosition(null);
        return;
      }
      
      const component = findComponentByIdAndPage(paragraphId, actualPageIdx);

      // console.log('[TextSelection] component 찾기:', { paragraphId, pageNoDb, actualPageIdx, found: !!component, hasContent: !!component?.content });

      if (!component || !component.content) {
        // console.warn('[TextSelection] component를 찾을 수 없거나 content 없음');
        setToolbarPosition(null);
        return;
      }

      const originalText = component.content;
      let paragraphTextElement: HTMLElement | null = paragraphElement.hasAttribute('data-paragraph-text') 
        ? paragraphElement 
        : paragraphElement.querySelector('[data-paragraph-text]') as HTMLElement | null;
      
      // console.log('[TextSelection] paragraphTextElement 찾기:', { 
      //   hasDataParagraphText: paragraphElement.hasAttribute('data-paragraph-text'),
      //   found: !!paragraphTextElement 
      // });
      
      if (!paragraphTextElement) {
        // console.warn('[TextSelection] paragraphTextElement를 찾을 수 없음');
        setToolbarPosition(null);
        return;
      }
      
      try {
        const preCaretRange = document.createRange();
        preCaretRange.selectNodeContents(paragraphTextElement);
        preCaretRange.setEnd(range.startContainer, range.startOffset);
        const domStartOffset = preCaretRange.toString().length;

        const postCaretRange = document.createRange();
        postCaretRange.selectNodeContents(paragraphTextElement);
        postCaretRange.setEnd(range.endContainer, range.endOffset);
        const domEndOffset = postCaretRange.toString().length;
        
        const domTextContent = paragraphTextElement.textContent || '';
        let startOffset = domStartOffset;
        let endOffset = domEndOffset;

        if (domTextContent !== originalText) {
          const selectedTextFromDOM = domTextContent.substring(domStartOffset, domEndOffset);
          const searchIndex = originalText.indexOf(selectedTextFromDOM);
          if (searchIndex !== -1) {
            startOffset = searchIndex;
            endOffset = searchIndex + selectedTextFromDOM.length;
          }
        }
        
        if (startOffset === -1 || endOffset === -1 || startOffset >= endOffset || endOffset > originalText.length) {
          setToolbarPosition(null);
          return;
        }
        
        const actualSelectedText = originalText.substring(startOffset, endOffset);
        const textRange: TextRange = {
          paragraphId,
          startOffset,
          endOffset,
          selectedText: actualSelectedText,
        };

        setSelectedRange(textRange);
        setSelectedPageNumber(actualPageIdx);  // idx 값 저장
        setSelectedRanges([{
          pageNo: actualPageIdx,  // idx 값 저장
          paragraphId,
          startOffset,
          endOffset,
          selectedText: actualSelectedText,
          componentIndex: component.component_no,
        }]);

        // API 호출을 위한 page_no 저장 (별도 상태 필요 시 추가)
        // 현재는 CreateAnnotationRequest 생성 시 page_no를 찾아서 전달
        // 학습 기록 패널이 열려있지 않을 때만 툴바 표시
        if (!showLearningRecords) {
          const rect = range.getBoundingClientRect();
          const toolbarPos = { x: rect.left + rect.width / 2, y: rect.top };
          // console.log('[TextSelection] 툴바 위치 설정:', toolbarPos);
          setToolbarPosition(toolbarPos);
        }
        setClickedAnnotation(null);
      } catch (err) {
        // console.error('오프셋 계산 중 오류:', err);
        setToolbarPosition(null);
        setSelectedRange(null);
        setSelectedPageNumber(null);
        setSelectedRanges([]);
      }
      return;
    }

    // 여러 문단이 선택된 경우
    const multiRanges: MultiParagraphRange[] = [];
    
    for (const paragraphElement of paragraphElements) {
      const paragraphId = paragraphElement.getAttribute('data-paragraph-id');
      const pageNoStr = paragraphElement.getAttribute('data-page-no');
      
      if (!paragraphId || !pageNoStr) continue;
      
      // data-page-no는 DB 인덱스(page_no)를 의미
      const pageNoDb = parseInt(pageNoStr, 10);
      
      // page_no에서 idx로 변환 (displayComponents에서 찾기)
      const allComponentsForMulti = displayComponents;
      const flatComponentForMulti = allComponentsForMulti.find(fc => fc.pageNoDb === pageNoDb);
      const pageNo = flatComponentForMulti ? flatComponentForMulti.pageNo : null;
      
      if (pageNo === null) {
        // console.warn('[TextSelection] 여러 문단 선택: page_no에서 idx로 변환 실패:', pageNoDb);
        continue;
      }
      
      const component = findComponentByIdAndPage(paragraphId, pageNo);
      
      if (!component || !component.content) continue;
      
      const originalText = component.content;
      const paragraphTextElement = paragraphElement.hasAttribute('data-paragraph-text') 
        ? paragraphElement 
        : paragraphElement.querySelector('[data-paragraph-text]') as HTMLElement | null;
      
      if (!paragraphTextElement) continue;
      
      try {
        // 문단 전체 범위 생성
        const paragraphRange = document.createRange();
        paragraphRange.selectNodeContents(paragraphTextElement);
        
        // 선택 범위가 이 문단보다 앞에서 시작하는지 확인
        const startsBeforeParagraph = range.compareBoundaryPoints(Range.START_TO_START, paragraphRange) <= 0;
        // 선택 범위가 이 문단보다 뒤에서 끝나는지 확인
        const endsAfterParagraph = range.compareBoundaryPoints(Range.END_TO_END, paragraphRange) >= 0;
        
        let domStartOffset = 0;
        let domEndOffset = paragraphTextElement.textContent?.length || 0;
        
        // 선택 범위가 이 문단 내에서 시작하는 경우
        if (!startsBeforeParagraph && paragraphTextElement.contains(range.startContainer)) {
          try {
            const preRange = document.createRange();
            preRange.selectNodeContents(paragraphTextElement);
            preRange.setEnd(range.startContainer, range.startOffset);
            domStartOffset = preRange.toString().length;
          } catch {
            // 오류 시 문단 시작부터
            domStartOffset = 0;
          }
        }
        
        // 선택 범위가 이 문단 내에서 끝나는 경우
        if (!endsAfterParagraph && paragraphTextElement.contains(range.endContainer)) {
          try {
            const postRange = document.createRange();
            postRange.selectNodeContents(paragraphTextElement);
            postRange.setEnd(range.endContainer, range.endOffset);
            domEndOffset = postRange.toString().length;
          } catch {
            // 오류 시 문단 끝까지
            domEndOffset = paragraphTextElement.textContent?.length || 0;
          }
        }
        
        let startOffset = domStartOffset;
        let endOffset = domEndOffset;
        
        // DOM 텍스트와 원본 텍스트가 다른 경우 보정
        const domTextContent = paragraphTextElement.textContent || '';
        if (domTextContent !== originalText && domEndOffset > domStartOffset) {
          const selectedTextFromDOM = domTextContent.substring(domStartOffset, domEndOffset);
          const searchIndex = originalText.indexOf(selectedTextFromDOM);
          if (searchIndex !== -1) {
            startOffset = searchIndex;
            endOffset = searchIndex + selectedTextFromDOM.length;
          }
        }
        
        if (startOffset >= 0 && endOffset > startOffset && endOffset <= originalText.length) {
          multiRanges.push({
            pageNo,
            paragraphId,
            startOffset,
            endOffset,
            selectedText: originalText.substring(startOffset, endOffset),
            componentIndex: component.component_no,
          });
        }
      } catch (err) {
        // console.error('여러 문단 오프셋 계산 중 오류:', err);
      }
    }
    
    if (multiRanges.length === 0) {
      setToolbarPosition(null);
      return;
    }
    
    // 첫 번째 범위를 기본 selectedRange로 설정 (호환성 유지)
    const firstRange = multiRanges[0];
    setSelectedRange({
      paragraphId: firstRange.paragraphId,
      startOffset: firstRange.startOffset,
      endOffset: firstRange.endOffset,
      selectedText: firstRange.selectedText,
    });
    setSelectedPageNumber(firstRange.pageNo);
    setSelectedRanges(multiRanges);
    
    // 학습 기록 패널이 열려있지 않을 때만 툴바 표시
    if (!showLearningRecords) {
      const rect = range.getBoundingClientRect();
      setToolbarPosition({ x: rect.left + rect.width / 2, y: rect.top });
    }
    setClickedAnnotation(null);
  }, [displayComponents, findComponentByIdAndPage, showLearningRecords]);

  // 툴바 및 관련 상태 초기화 함수 (재사용)
  const closeAllToolbars = useCallback(() => {
    setToolbarPosition(null);
    setSelectedRange(null);
    setSelectedPageNumber(null);
    setSelectedRanges([]);
    setClickedAnnotation(null);
    setShowHighlightDropdown(false);
    setShowHighlightColorPicker(false);
    setShowUnderlineColorPicker(false);
    setHighlightDropdownPosition(null);
  }, []);

  useLayoutEffect(() => {
    const el = toolbarRef.current;
    if (!el || !toolbarPosition) return;

    const margin = 30;
    const vw = window.innerWidth;
    const toolbarWidth = el.offsetWidth;
    const halfWidth = toolbarWidth / 2;

    const leftEdge = toolbarPosition.x - halfWidth;
    const rightEdge = toolbarPosition.x + halfWidth;

    let shiftX = 0;
    if (rightEdge > vw - margin) {
      shiftX = vw - margin - rightEdge;
    }
    if (leftEdge + shiftX < margin) {
      shiftX = margin - leftEdge;
    }

    if (shiftX !== 0) {
      el.style.transform = `translateX(calc(-50% + ${shiftX}px)) translateY(-100%) translateY(-8px)`;
    } else {
      el.style.transform = '';
    }
  }, [toolbarPosition]);

  // 음성 버튼 클릭 핸들러 (헤더의 음성 버튼 클릭 시)
  const handleVoiceRecord = async () => {
    closeAllToolbars();
    // 모달만 열기 (녹음은 시작하지 않음)
    openRecordingModal();
  };

  // 퀴즈 생성 버튼 클릭 핸들러 (헤더의 퀴즈 생성 버튼 클릭 시)
  const handleQuizCreateClick = useCallback((params: { selectedText: string; showTextTooLongModal?: boolean }) => {
    const { selectedText, showTextTooLongModal } = params;
    if (showTextTooLongModal) {
      setShowTextTooLongModal(true);
      return;
    }
    setAiSelectedText(selectedText || '');
    setAiPanelMode('quiz');
    setShowAIPanel(true);
  }, []);

  // 메모 관련 핸들러
  const handleAddNoteAttachment = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const newAttachments = Array.from(files).map(file => ({
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        name: file.name,
        file: file,
      }));
      setNoteAttachments(prev => [...prev, ...newAttachments]);
    }
    if (noteFileInputRef.current) noteFileInputRef.current.value = '';
  };

  const handleRemoveNoteAttachment = (attachmentId: string) => {
    setNoteAttachments(prev => prev.filter(att => att.id !== attachmentId));
  };

  // 메모 모달 리셋 핸들러
  const resetNoteModal = () => {
    setIsModalOpen(false);
    setEditingAnnotation(null);
    setNoteTitle('');
    setNoteText('');
    setNoteColor('yellow');
    setNoteAttachments([]);
    setShowNoteMenu(false);
    setShowColorPicker(false);
    setIsNoteEditMode(true);
    // 새 메모 모달도 닫기
    if (newNoteModalId) {
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(newNoteModalId);
        return newMap;
      });
      setNewNoteModalId(null);
    }
  };

  // 주석 저장 핸들러 (여러 문단 지원)
  const handleSaveHighlight = async (e?: React.MouseEvent, customColor?: string) => {
    e?.preventDefault();
    e?.stopPropagation();
    
    // console.log('[Highlight] 저장 시도:', {
    //   selectedRange,
    //   selectedRanges: selectedRanges.length,
    //   selectedPageNumber,
    //   displayComponents: displayComponents.length,
    //   bookUid,
    // });
    
    const hasComponents = displayComponents.length > 0;
    if (!hasComponents || !bookUid) {
      // console.warn('[Highlight] 저장 실패: 컴포넌트 없음 또는 bookUid 없음');
      return;
    }
    
    // UUID 생성 헬퍼
    const generateTempId = () => `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    // 여러 문단이 선택된 경우
    if (selectedRanges.length > 0) {
      const color = customColor || (isProfessor ? '#ef4444' : STUDENT_MARKER_COLORS[selectedMarkerColor]);
      const tempIds: string[] = [];
      
      // 각 문단에 대해 optimistic update로 즉시 추가
      for (const rangeItem of selectedRanges) {
        try {
          const tempId = generateTempId();
          tempIds.push(tempId);
          const pageNoDb = findPageNoFromIdx(rangeItem.pageNo);
          const request: CreateAnnotationRequest = {
            page_index: rangeItem.pageNo,
            page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
            component_no: rangeItem.componentIndex,
            start_offset: rangeItem.startOffset,
            end_offset: rangeItem.endOffset,
            type: 'highlight',
            color: color,
            text: rangeItem.selectedText || '',
            visibility: 'PRIVATE',
          };
          
          // 즉시 프론트에 반영
          addAnnotationOptimistically(request, tempId);
          
          // 백그라운드에서 API 호출 (재시도 로직 포함)
          createAnnotationWithRetry(bookUid, request, tempId).catch(err => {
            // console.error(`[Highlight] 최종 실패 (tempId: ${tempId}):`, err);
          });
        } catch (err) {
          // console.error('하이라이트 optimistic update 중 오류:', err);
        }
      }
      
      closeAllToolbars();
      window.getSelection()?.removeAllRanges();
      return;
    }
    
    // 단일 문단 선택 (기존 로직 - 호환성 유지)
    if (!selectedRange || selectedPageNumber === null) {
      // console.warn('[Highlight] 저장 실패: selectedRange 또는 selectedPageNumber 없음');
      return;
    }
    
    const currentPageNum = selectedPageNumber;
    const component = findComponentByIdAndPage(selectedRange.paragraphId, currentPageNum);
    if (!component) {
      // console.warn('[Highlight] 저장 실패: component를 찾을 수 없음', { paragraphId: selectedRange.paragraphId, pageNo: currentPageNum });
      return;
    }

    const color = customColor || (isProfessor ? '#ef4444' : STUDENT_MARKER_COLORS[selectedMarkerColor]);
    const tempId = generateTempId();
    
    try {
      const pageNoDb = findPageNoFromIdx(currentPageNum);
      const request: CreateAnnotationRequest = {
        page_index: currentPageNum,
        page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
        component_no: component.component_no,
        start_offset: selectedRange.startOffset,
        end_offset: selectedRange.endOffset,
        type: 'highlight',
        color: color,
        text: selectedRange.selectedText || '',  // 선택된 텍스트
        visibility: 'PRIVATE',  // 기본값: PRIVATE
      };
      
      // 즉시 프론트에 반영
      addAnnotationOptimistically(request, tempId);
      
      // 백그라운드에서 API 호출 (재시도 로직 포함)
      createAnnotationWithRetry(bookUid, request, tempId).catch(err => {
        console.error(`[Highlight] 최종 실패 (tempId: ${tempId}):`, err);
      });
      
      setToolbarPosition(null);
      setSelectedRange(null);
      setSelectedPageNumber(null);
      setSelectedRanges([]);
      setShowHighlightDropdown(false);
      setShowHighlightColorPicker(false);
      setHighlightDropdownPosition(null);
      window.getSelection()?.removeAllRanges();
    } catch (err) {
      // console.error('하이라이트 optimistic update 중 오류:', err);
    }
  };

  const handleSaveUnderline = async (e?: React.MouseEvent, customColor?: string) => {
    e?.preventDefault();
    e?.stopPropagation();
    
    // console.log('[Underline] 저장 시도:', {
    //   selectedRange,
    //   selectedRanges: selectedRanges.length,
    //   selectedPageNumber,
    //   displayComponents: displayComponents.length,
    //   bookUid,
    // });
    
    const hasComponents = displayComponents.length > 0;
    if (!hasComponents || !bookUid) {
      // console.warn('[Underline] 저장 실패: 컴포넌트 없음 또는 bookUid 없음');
      return;
    }
    
    // UUID 생성 헬퍼
    const generateTempId = () => `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    // 여러 문단이 선택된 경우
    if (selectedRanges.length > 0) {
      const color = customColor || STUDENT_MARKER_COLORS[selectedMarkerColor];
      const tempIds: string[] = [];
      
      // 각 문단에 대해 optimistic update로 즉시 추가
      for (const rangeItem of selectedRanges) {
        try {
          const tempId = generateTempId();
          tempIds.push(tempId);
          const pageNoDb = findPageNoFromIdx(rangeItem.pageNo);
          const request: CreateAnnotationRequest = {
            page_index: rangeItem.pageNo,
            page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
            component_no: rangeItem.componentIndex,
            start_offset: rangeItem.startOffset,
            end_offset: rangeItem.endOffset,
            type: 'underline',
            color: color,
            text: rangeItem.selectedText || '',  // 선택된 텍스트
            visibility: 'PRIVATE',  // 기본값: PRIVATE
          };
          
          // 즉시 프론트에 반영
          addAnnotationOptimistically(request, tempId);
          
          // 백그라운드에서 API 호출 (재시도 로직 포함)
          createAnnotationWithRetry(bookUid, request, tempId).catch(err => {
            // console.error(`[Underline] 최종 실패 (tempId: ${tempId}):`, err);
          });
        } catch (err) {
          // console.error('밑줄 optimistic update 중 오류:', err);
        }
      }
      
      closeAllToolbars();
      window.getSelection()?.removeAllRanges();
      return;
    }
    
    // 단일 문단 선택 (기존 로직 - 호환성 유지)
    if (!selectedRange || selectedPageNumber === null) {
      // console.warn('[Underline] 저장 실패: selectedRange 또는 selectedPageNumber 없음');
      return;
    }
    
    const currentPageNum = selectedPageNumber;
    const component = findComponentByIdAndPage(selectedRange.paragraphId, currentPageNum);
    if (!component) {
      // console.warn('[Underline] 저장 실패: component를 찾을 수 없음', { paragraphId: selectedRange.paragraphId, pageNo: currentPageNum });
      return;
    }

    const color = customColor || STUDENT_MARKER_COLORS[selectedMarkerColor];
    const tempId = generateTempId();
    
    try {
      const pageNoDb = findPageNoFromIdx(currentPageNum);
      const request: CreateAnnotationRequest = {
        page_index: currentPageNum,
        page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
        component_no: component.component_no,
        start_offset: selectedRange.startOffset,
        end_offset: selectedRange.endOffset,
        type: 'underline',
        color: color,
        text: selectedRange.selectedText || '',  // 선택된 텍스트
        visibility: 'PRIVATE',  // 기본값: PRIVATE
      };
      
      // 즉시 프론트에 반영
      addAnnotationOptimistically(request, tempId);
      
      // 백그라운드에서 API 호출 (재시도 로직 포함)
      createAnnotationWithRetry(bookUid, request, tempId).catch(err => {
        console.error(`[Underline] 최종 실패 (tempId: ${tempId}):`, err);
      });
      
      setToolbarPosition(null);
      setSelectedRange(null);
      setSelectedPageNumber(null);
      setSelectedRanges([]);
      setShowHighlightDropdown(false);
      setShowUnderlineColorPicker(false);
      setHighlightDropdownPosition(null);
      window.getSelection()?.removeAllRanges();
    } catch (err) {
      // console.error('밑줄 optimistic update 중 오류:', err);
    }
  };

  // 영역 지정 // 사용 안해서 주석 처리 초기 버전에서 언급되어 개발만 진행
  // const handleSaveAreaHighlight = async (e?: React.MouseEvent) => {
  //   e?.preventDefault();
  //   e?.stopPropagation();
    
  //   const hasComponents = leftComponents.length > 0 || rightComponents.length > 0;
  //   if (!hasComponents || !bookUid) return;
    
  //   // 여러 문단이 선택된 경우
  //   if (selectedRanges.length > 0) {
  //     try {
  //       const affectedPages = new Set<number>();
        
  //       for (const rangeItem of selectedRanges) {
  //         const component = findComponentByIdAndPage(rangeItem.paragraphId, rangeItem.pageNo);
  //         if (!component || !component.content) continue;
          
  //         await annotationService.createAnnotation(bookUid, {
  //           page_index: rangeItem.pageNo,
  //           component_no: component.index,
  //           start_offset: 0,
  //           end_offset: component.content.length,
  //           type: 'box',
  //           color: '#FFF0F3',
  //         });
  //         affectedPages.add(rangeItem.pageNo);
  //       }
        
  //       for (const pageNo of affectedPages) {
  //         const cachedPage = pageCacheRef.current.get(pageNo);
  //         if (cachedPage) {
  //           await reloadPageAnnotations(pageNo, cachedPage.page.components);
  //         }
  //       }
        
  //       setToolbarPosition(null);
  //       setSelectedRange(null);
  //       setSelectedPageNumber(null);
  //       setSelectedRanges([]);
  //       window.getSelection()?.removeAllRanges();
  //     } catch (err) {
  //       alert('영역지정 저장에 실패했습니다.');
  //     }
  //     return;
  //   }
    
  //   // 단일 문단 선택
  //   if (!selectedRange || selectedPageNumber === null) return;
    
  //   const currentPageNum = selectedPageNumber;
  //   const component = findComponentByIdAndPage(selectedRange.paragraphId, currentPageNum);

  //   if (!component || !component.content) return;

  //   try {
  //     await annotationService.createAnnotation(bookUid, {
  //       page_index: currentPageNum,
  //       component_no: component.index,
  //       start_offset: 0,
  //       end_offset: component.content.length,
  //       type: 'box',
  //       color: '#FFF0F3',
  //     });
      
  //     const cachedPage = pageCacheRef.current.get(currentPageNum);
  //     if (cachedPage) {
  //       await reloadPageAnnotations(currentPageNum, cachedPage.page.components);
  //     }
      
  //     setToolbarPosition(null);
  //     setSelectedRange(null);
  //     setSelectedPageNumber(null);
  //     setSelectedRanges([]);
  //     window.getSelection()?.removeAllRanges();
  //   } catch (err) {
  //     alert('영역지정 저장에 실패했습니다.');
  //   }
  // };

  const handleSaveNote = async () => {
    const hasComponents = displayComponents.length > 0;
    // 단일 선택 또는 여러 문단 선택 모두 지원
    if ((!selectedRange && selectedRanges.length === 0) || !hasComponents) return;
    
    // 선택된 텍스트 위치 계산하여 모달 위치 설정
    let modalX = window.innerWidth / 2;
    let modalY = window.innerHeight / 2;
    
    if (toolbarPosition) {
      // 툴바 위치 근처에 모달 표시
      modalX = Math.min(toolbarPosition.x + 100, window.innerWidth - 350);
      modalY = Math.max(toolbarPosition.y - 100, 20);
    } else {
      // 선택된 텍스트 영역 찾기
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const rect = range.getBoundingClientRect();
        modalX = Math.min(rect.right + 20, window.innerWidth - 350);
        modalY = Math.max(rect.top - 50, 20);
      }
    }
    
    // 새 메모를 openModals에 추가하여 수정 모달과 동일한 스타일로 표시
    const tempId = `new-note-${Date.now()}`;
    setNewNoteModalId(tempId);
    setOpenModals(prev => {
      const newMap = new Map(prev);
      newMap.set(tempId, {
        noteTitle: '',
        noteText: '',
        noteColor: 'yellow',
        noteAttachments: [],
        showNoteMenu: false,
        showColorPicker: false,
        isNoteEditMode: true, // 새 메모는 바로 편집 모드
        editingAnnotation: null,
        position: { x: modalX, y: modalY }, // 텍스트 근처에 작은 크기로 표시
        selectedRange: selectedRange, // 선택된 범위 저장
        selectedPageNumber: selectedPageNumber, // 선택된 페이지 번호 저장
        selectedRanges: selectedRanges, // 선택된 여러 범위 저장
        originalNoteTitle: '', // 새 메모는 빈 값
        originalNoteText: '', // 새 메모는 빈 값
      });
      return newMap;
    });
    
    setIsModalOpen(true);
    setToolbarPosition(null);
  };

  const uploadNoteAttachments = async (): Promise<string[]> => {
    const uploadedFileIds: string[] = [];
    
    for (const attachment of noteAttachments) {
      if (attachment.file) {
        try {
          const formData = new FormData();
          formData.append('upload', attachment.file, attachment.name);
          formData.append('purpose', 'GENERAL');

          const response = await apiClient.post('/viewer/files/upload', formData, {
            headers: { 'accept': 'application/json', 'Content-Type': 'multipart/form-data' },
          });

          if (response.data?.data?.file_id) {
            uploadedFileIds.push(response.data.data.file_id);
          } else if (response.data?.file_id) {
            uploadedFileIds.push(response.data.file_id);
          }
        } catch (err) {
          // console.error('[Note] 파일 업로드 실패:', attachment.name, err);
        }
      }
    }
    
    return uploadedFileIds;
  };

  // 특정 모달의 메모 저장 (여러 모달 지원)
  const handleConfirmNoteForModal = async (annotationId: string) => {
    const modalData = openModals.get(annotationId);
    if (!modalData) return;
    
    const { noteTitle: modalNoteTitle, noteText: modalNoteText, noteColor: modalNoteColor, editingAnnotation: modalEditingAnnotation } = modalData;
    
    if (!modalNoteTitle.trim() && !modalNoteText.trim()) return;

    const noteContent = `${modalNoteTitle}\n${modalNoteText}`.trim();
    const colorValue = NOTE_BACKGROUND_COLORS[modalNoteColor];

    if (!modalEditingAnnotation) return;

    // 임시 메모(temp-로 시작)는 수정할 수 없음 - 서버에서 실제 UUID를 받아온 후에만 수정 가능
    if (modalEditingAnnotation.id.startsWith('temp-')) {
      alert('메모가 아직 생성 중입니다. 잠시 후 다시 시도해주세요.');
      return;
    }

    try {
      await annotationService.updateAnnotation(modalEditingAnnotation, { note: noteContent, color: colorValue });
      // 메모 수정 후 직접 annotations 상태 업데이트 (reloadPageAnnotations 호출하지 않음)
      setAnnotations(prev => prev.map(ann => 
        ann.id === modalEditingAnnotation.id 
          ? { ...ann, note: noteContent, color: colorValue, _updatedAt: Date.now() }
          : ann
      ));
      // 캐시도 함께 업데이트
      const cachedPage = pageCacheRef.current.get(modalEditingAnnotation.pageNumber);
      if (cachedPage) {
        pageCacheRef.current.set(modalEditingAnnotation.pageNumber, {
          ...cachedPage,
          annotations: cachedPage.annotations.map((ann: Annotation) => 
            ann.id === modalEditingAnnotation.id 
              ? { ...ann, note: noteContent, color: colorValue, _updatedAt: Date.now() }
              : ann
          ),
        });
      }
      if (bookUid) dispatchLearningRecordsInvalidate(bookUid);
      // 모달 닫기
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
    } catch (err: any) {
      const errorDetail = err.response?.data?.error || err.response?.data?.detail || err.message;
      alert(`메모 수정에 실패했습니다: ${errorDetail}`);
    }
  };

  // 새 메모 생성용 핸들러 (annotationId를 받아서 처리)
  const handleConfirmNoteForNewModal = async (annotationId: string) => {
    const modalData = openModals.get(annotationId);
    if (!modalData) return;
    
    const { noteTitle: modalNoteTitle, noteText: modalNoteText, noteColor: modalNoteColor, selectedRange: modalSelectedRange, selectedPageNumber: modalSelectedPageNumber, selectedRanges: modalSelectedRanges } = modalData;
    const noteContent = `${modalNoteTitle}\n${modalNoteText}`.trim();
    const colorValue = NOTE_BACKGROUND_COLORS[modalNoteColor];

    if (!noteContent.trim()) {
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
      return;
    }

    const hasComponents = displayComponents.length > 0;
    if (!hasComponents || !bookUid) {
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
      return;
    }
    
    // UUID 생성 헬퍼
    const generateTempId = () => `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    // 여러 문단이 선택된 경우
    const rangesToUse = modalSelectedRanges || [];
    if (rangesToUse.length > 0) {
      const tempIds: string[] = [];
      
      // 각 문단에 대해 optimistic update로 즉시 추가
      for (const rangeItem of rangesToUse) {
        try {
          const tempId = generateTempId();
          tempIds.push(tempId);
          const pageNoDb = findPageNoFromIdx(rangeItem.pageNo);
          const request: CreateAnnotationRequest = {
            page_index: rangeItem.pageNo,
            page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
            component_no: rangeItem.componentIndex,
            start_offset: rangeItem.startOffset,
            end_offset: rangeItem.endOffset,
            type: 'note',
            note: noteContent,
            color: colorValue,
            text: rangeItem.selectedText || '',
            visibility: 'PRIVATE',
          };
          
          // 즉시 프론트에 반영
          addAnnotationOptimistically(request, tempId);
          
          // 백그라운드에서 API 호출 (재시도 로직 포함)
          createAnnotationWithRetry(bookUid, request, tempId).catch(err => {
            // console.error(`[Note] 최종 실패 (tempId: ${tempId}):`, err);
          });
        } catch (err) {
          // console.error('메모 optimistic update 중 오류:', err);
        }
      }
      
      // 모달 닫기
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
      // 모달에서 저장한 selectedRange, selectedRanges는 사용하지 않음 (이미 API 호출 완료)
      return;
    }
    
    // 단일 문단 선택
    const rangeToUse = modalSelectedRange;
    const pageNumToUse = modalSelectedPageNumber;
    if (!rangeToUse || pageNumToUse === null || pageNumToUse === undefined) {
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
      return;
    }
    
    const currentPageNum: number = pageNumToUse;
    const component = findComponentByIdAndPage(rangeToUse.paragraphId, currentPageNum);
    if (!component) {
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
      return;
    }

    const tempId = generateTempId();
    
    try {
      const pageNoDb = findPageNoFromIdx(currentPageNum);
      const request: CreateAnnotationRequest = {
        page_index: currentPageNum,
        page_no: pageNoDb ?? undefined,  // DB 인덱스 (page_no)
        component_no: component.component_no,
        start_offset: rangeToUse.startOffset,
        end_offset: rangeToUse.endOffset,
        type: 'note',
        note: noteContent,
        color: colorValue,
        text: rangeToUse.selectedText || '',  // 선택된 텍스트
        visibility: 'PRIVATE',  // 기본값: PRIVATE
      };
      
      // 즉시 프론트에 반영
      const optimisticAnnotation = addAnnotationOptimistically(request, tempId);
      
      // 모달의 editingAnnotation을 optimistic annotation으로 업데이트 (서버 응답 후 실제 UUID로 업데이트됨)
      setOpenModals(prev => {
        const newMap = new Map(prev);
        const modalData = newMap.get(annotationId);
        if (modalData) {
          newMap.set(annotationId, {
            ...modalData,
            editingAnnotation: optimisticAnnotation as Annotation,
          });
          // console.log('[handleConfirmNoteForNewModal] 모달의 editingAnnotation을 optimistic annotation으로 설정:', { annotationId, tempId });
        }
        return newMap;
      });
      
      // 백그라운드에서 API 호출 (재시도 로직 포함)
      createAnnotationWithRetry(bookUid, request, tempId).then((createdAnnotation) => {
        if (createdAnnotation) {
          // console.log('[handleConfirmNoteForNewModal] 메모 생성 완료, 실제 UUID:', createdAnnotation.id);
          // 모달은 유지하고 editingAnnotation만 업데이트됨 (이미 createAnnotationWithRetry에서 처리됨)
        }
      }).catch(err => {
        console.error(`[Note] 최종 실패 (tempId: ${tempId}):`, err);
        // 실패 시 모달 닫기
        setOpenModals(prev => {
          const newMap = new Map(prev);
          newMap.delete(annotationId);
          return newMap;
        });
        if (annotationId === newNoteModalId) {
          setNewNoteModalId(null);
          setIsModalOpen(false);
        }
      });
      
      // 모달은 유지 (서버 응답 후 실제 UUID로 업데이트되면 수정 가능)
      // 모달에서 저장한 selectedRange, selectedRanges는 사용하지 않음 (이미 API 호출 완료)
    } catch (err) {
      // console.error('메모 optimistic update 중 오류:', err);
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.delete(annotationId);
        return newMap;
      });
      if (annotationId === newNoteModalId) {
        setNewNoteModalId(null);
        setIsModalOpen(false);
      }
    }
  };

  // 메모 저장 (기존 코드 호환성용)
  const handleConfirmNote = async () => {
    // 새 메모 모달이 openModals에 있으면 해당 모달의 데이터 사용
    if (newNoteModalId) {
      await handleConfirmNoteForNewModal(newNoteModalId);
      return;
    }

    // 기존 코드 호환성 (editingAnnotation이 있는 경우)
    if (editingAnnotation) {
      // 기존 모달이 열려있으면 해당 모달의 핸들러 사용
      const existingModal = Array.from(openModals.entries()).find(([_, data]) => data.editingAnnotation?.id === editingAnnotation.id);
      if (existingModal) {
        await handleConfirmNoteForModal(existingModal[0]);
        resetNoteModal();
        return;
      }
      
      // 임시 메모(temp-로 시작)는 수정할 수 없음 - 서버에서 실제 UUID를 받아온 후에만 수정 가능
      if (editingAnnotation.id.startsWith('temp-')) {
        alert('메모가 아직 생성 중입니다. 잠시 후 다시 시도해주세요.');
        resetNoteModal();
        return;
      }

      try {
        const noteContent = `${noteTitle}\n${noteText}`.trim();
        const colorValue = NOTE_BACKGROUND_COLORS[noteColor];
        await annotationService.updateAnnotation(editingAnnotation, { note: noteContent, color: colorValue });
        // 메모 수정 후 직접 annotations 상태 업데이트 (reloadPageAnnotations 호출하지 않음)
        setAnnotations(prev => prev.map(ann => 
          ann.id === editingAnnotation.id 
            ? { ...ann, note: noteContent, color: colorValue, _updatedAt: Date.now() }
            : ann
        ));
        // 캐시도 함께 업데이트
        const cachedPage = pageCacheRef.current.get(editingAnnotation.pageNumber);
        if (cachedPage) {
          pageCacheRef.current.set(editingAnnotation.pageNumber, {
            ...cachedPage,
            annotations: cachedPage.annotations.map((ann: Annotation) => 
              ann.id === editingAnnotation.id 
                ? { ...ann, note: noteContent, color: colorValue, _updatedAt: Date.now() }
                : ann
            ),
          });
        }
        if (bookUid) dispatchLearningRecordsInvalidate(bookUid);
        resetNoteModal();
      } catch (err: any) {
        const errorDetail = err.response?.data?.error || err.response?.data?.detail || err.message;
        alert(`메모 수정에 실패했습니다: ${errorDetail}`);
      }
      return;
    }

  };

  // 주석 클릭 핸들러
  const handleAnnotationClick = (annotation: Annotation, event?: React.MouseEvent) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    window.getSelection()?.removeAllRanges();
    
    // 채팅창이 열려있으면 아무 동작도 하지 않음
    if (showAIPanel) {
      return;
    }
    
    // 학습 기록 패널이 열려있어도 어노테이션 클릭은 작동해야 함
    // 단, 툴바는 학습 기록 패널이 열려있으면 표시하지 않음
    const shouldShowToolbar = !showLearningRecords;
    
    if (annotation.type === 'note') {
      const noteLines = annotation.note ? annotation.note.split('\n') : [];
      const colorMap: Record<string, 'green' | 'yellow' | 'blue'> = {
        '#EBFFCF': 'green', '#FEFFCF': 'yellow', '#E3F2FF': 'blue',
      };
      
      // 클릭 위치 계산 (텍스트가 칠해진 근처에 모달 표시)
      let modalX = window.innerWidth / 2;
      let modalY = window.innerHeight / 2;
      
      if (event?.target) {
        const rect = (event.target as HTMLElement).getBoundingClientRect();
        // 텍스트 영역의 오른쪽 상단 근처에 위치
        modalX = Math.min(rect.right + 20, window.innerWidth - 350); // 모달 너비 고려
        modalY = Math.max(rect.top - 50, 20); // 상단 여백 고려
        
        // 이미 열린 모달들과 겹치지 않도록 위치 조정
        const existingPositions = Array.from(openModals.values())
          .map(m => m.position)
          .filter((p): p is { x: number; y: number } => p !== undefined);
        let adjustedY = modalY;
        let attempts = 0;
        while (attempts < 10) {
          const overlaps = existingPositions.some(pos => 
            Math.abs(pos.x - modalX) < 350 && Math.abs(pos.y - adjustedY) < 300
          );
          if (!overlaps) break;
          adjustedY += 50; // 50px씩 아래로 이동
          attempts++;
        }
        modalY = adjustedY;
      }
      
      // 여러 메모창을 열 수 있도록 Map에 추가
      const originalTitle = noteLines[0] || '';
      const originalText = noteLines.slice(1).join('\n') || '';
      setOpenModals(prev => {
        const newMap = new Map(prev);
        newMap.set(annotation.id, {
          noteTitle: originalTitle,
          noteText: originalText,
          noteColor: colorMap[annotation.color || ''] || 'yellow',
          noteAttachments: [],
          showNoteMenu: false,
          showColorPicker: false,
          isNoteEditMode: false, // 기본적으로 읽기 모드로 열림
          editingAnnotation: annotation,
          position: { x: modalX, y: modalY }, // 텍스트 근처에 작은 크기로 표시
          originalNoteTitle: originalTitle, // 원본 제목 저장
          originalNoteText: originalText, // 원본 내용 저장
        });
        return newMap;
      });
      
      setClickedAnnotation(null);
      setToolbarPosition(null);
    } else {
      setClickedAnnotation(annotation);
      // 채팅창이 열려있지 않을 때만 툴바 표시 (학습 기록 패널이 열려있어도 툴바 표시)
      if (!showAIPanel) {
        if (event?.target) {
          const rect = (event.target as HTMLElement).getBoundingClientRect();
          setToolbarPosition({ x: rect.left + rect.width / 2, y: rect.top });
        } else {
          setToolbarPosition({ x: window.innerWidth / 2, y: window.innerHeight / 3 });
        }
      }
    }
  };

  const handleRemoveAnnotation = async (annotationId: string) => {
    // console.log('[삭제] handleRemoveAnnotation 호출됨:', annotationId);
    
    // 공유 폴더 어노테이션인지 확인 (학생은 교수가 공유한 어노테이션 삭제 불가)
    const targetAnnotation = annotations.find(a => a.id === annotationId);
    // console.log('[삭제] targetAnnotation:', targetAnnotation);
    
    if (targetAnnotation && (targetAnnotation as Annotation & { _isSharedFolder?: boolean })._isSharedFolder) {
      // console.log('[삭제] 공유 폴더 어노테이션이라 삭제 불가');
      alert('공유된 주석은 삭제할 수 없습니다.');
      setClickedAnnotation(null);
      setToolbarPosition(null);
      return;
    }

    // 낙관적 삭제: 먼저 UI에서 즉시 제거
    setAnnotations(prev => prev.filter(a => a.id !== annotationId));
    setClickedAnnotation(null);
    setToolbarPosition(null);
    setIsModalOpen(false);
    setEditingAnnotation(null);
    // pending 상태 초기화 (highlight effect가 삭제된 어노테이션으로 모달을 다시 여는 것 방지)
    if (pendingHighlightAnnotationId === annotationId) {
      setPendingHighlightAnnotationId(null);
      setPendingMemoFallback(null);
      setPendingComponentNo(null);
      setPendingSharedAnnotationData(null);
    }
    // 삭제된 어노테이션이 강조 중이면 강조 표시 및 되돌아가기 관련 상태 초기화
    if (highlightedAnnotationId === annotationId) {
      setHighlightedAnnotationId(null);
      setHighlightMarkerPosition(null);
      if (highlightTimerRef.current) {
        clearTimeout(highlightTimerRef.current);
        highlightTimerRef.current = null;
      }
    }
    // 모달 제거 (openModals Map에서 삭제)
    setOpenModals(new Map());
    setNewNoteModalId(null);
    // 렌더 캐시 클리어 (삭제 즉시 반영)
    renderTextWithHighlightsCache.current.clear();
    // console.log('[삭제] UI에서 제거 완료');

    // 임시 ID(temp-로 시작)인 경우 서버에 저장되지 않았으므로 API 호출 불필요
    if (annotationId.startsWith('temp-')) {
      // console.log('[삭제] 임시 ID라 API 호출 스킵');
      return;
    }

    // 실제 UUID인 경우 서버에 DELETE 요청 (에러 발생해도 UI는 이미 삭제됨)
    try {
      // console.log('[삭제] API 호출 시작:', annotationId);
      await annotationService.deleteAnnotation(annotationId);
      // console.log('[삭제] API 호출 성공');
      if (bookUid) dispatchLearningRecordsInvalidate(bookUid, true);
    } catch (err: any) {
      // console.error('[삭제] API 오류:', err?.response?.status, err?.response?.data, err?.message);
    }
  };

  // 텍스트 하이라이트 렌더링 (메모이제이션 최적화)
  const renderTextWithHighlightsCache = useRef<Map<string, React.ReactNode>>(new Map());
  const lastAnnotationsRef = useRef<string>('');
  
  const renderTextWithHighlights = useCallback((text: string, paragraphId: string, pageNum: number, pageNoDb: number): React.ReactNode => {
    if (hideAnnotations) return text;
    
    // a.pageNumber는 DB 인덱스(page_no)이므로 pageNoDb와 비교해야 함
    const paragraphAnnotations = annotations.filter(a => 
      a.range.paragraphId === paragraphId && a.pageNumber === pageNoDb
    );
    
    const annotationHash = paragraphAnnotations.map(a => {
      const optimisticAnn = a as OptimisticAnnotation;
      return `${a.id}:${a.note || ''}:${a.color || ''}:${(a as any)._updatedAt || ''}:${optimisticAnn._tempId || ''}:${optimisticAnn._isOptimistic || false}`;
    }).join('|');
    // 캐시 키는 pageNoDb를 사용 (pageNumber와 일치하도록), highlightedAnnotationId도 포함
    const cacheKey = `${paragraphId}-${pageNoDb}-${annotationHash}-${highlightedAnnotationId || ''}`;
    
    // Optimistic annotation이 있거나 강조 표시가 있는 경우 캐시 무시
    const hasOptimistic = paragraphAnnotations.some(a => (a as OptimisticAnnotation)._isOptimistic);
    const hasHighlightedAnnotation = highlightedAnnotationId && paragraphAnnotations.some(a => a.id === highlightedAnnotationId);
    if (!hasOptimistic && !hasHighlightedAnnotation && renderTextWithHighlightsCache.current.has(cacheKey)) {
      return renderTextWithHighlightsCache.current.get(cacheKey)!;
    }
    
    if (paragraphAnnotations.length === 0) {
      renderTextWithHighlightsCache.current.set(cacheKey, text);
      return text;
    }

    const nonAreaAnnotations = paragraphAnnotations.filter(a => a.type !== 'box' && a.color !== '#FFF0F3');
    if (nonAreaAnnotations.length === 0) return text;

    const sortedAnnotations = [...nonAreaAnnotations].sort((a, b) => a.range.startOffset - b.range.startOffset);
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;

    sortedAnnotations.forEach((annotation) => {
      if (annotation.range.startOffset > lastIndex) {
        parts.push(text.substring(lastIndex, annotation.range.startOffset));
      }

      const safeStartOffset = Math.min(annotation.range.startOffset, text.length);
      const safeEndOffset = Math.min(annotation.range.endOffset, text.length);
      
      if (safeStartOffset < lastIndex) {
        if (safeEndOffset <= lastIndex) return;
        const adjustedStartOffset = lastIndex;
        const highlightedText = text.substring(adjustedStartOffset, safeEndOffset);
        
        const isHighlighted = highlightedAnnotationId === annotation.id;
        if (annotation.type === 'highlight') {
          parts.push(
            <HighlightedText key={`highlight-${annotation.id}`} data-highlight data-annotation-id={annotation.id} $color={annotation.color || "#FFEB3B"} $isAreaSelection={false}
              title="하이라이트 (클릭하여 제거)"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAnnotationClick(annotation, e); }}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
            >
              {isHighlighted && <HighlightMarker data-highlight-marker />}
              {highlightedText}
            </HighlightedText>
          );
        } else if (annotation.type === 'underline') {
          parts.push(
            <UnderlinedText key={`underline-${annotation.id}`} data-highlight data-annotation-id={annotation.id} $color={annotation.color || "#ef4444"} title="밑줄 (클릭하여 제거)"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAnnotationClick(annotation, e); }}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
            >
              {isHighlighted && <HighlightMarker data-highlight-marker />}
              {highlightedText}
            </UnderlinedText>
          );
        }
        lastIndex = safeEndOffset;
        return;
      }
      
      const highlightedText = text.substring(safeStartOffset, safeEndOffset);
      const isHighlighted = highlightedAnnotationId === annotation.id;

      if (annotation.type === 'highlight') {
        parts.push(
          <HighlightedText key={`highlight-${annotation.id}`} data-highlight data-annotation-id={annotation.id} $color={annotation.color || "#FFEB3B"} $isAreaSelection={false}
            title="하이라이트 (클릭하여 제거)"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAnnotationClick(annotation, e); }}
            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
          >
            {isHighlighted && <HighlightMarker data-highlight-marker />}
            {highlightedText}
          </HighlightedText>
        );
      } else if (annotation.type === 'underline') {
        parts.push(
          <UnderlinedText key={`underline-${annotation.id}`} data-highlight data-annotation-id={annotation.id} $color={annotation.color || "#ef4444"} title="밑줄 (클릭하여 제거)"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAnnotationClick(annotation, e); }}
            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
          >
            {isHighlighted && <HighlightMarker data-highlight-marker />}
            {highlightedText}
          </UnderlinedText>
        );
      } else if (annotation.type === 'note') {
        const noteColor = annotation.color || '#FEFFCF';
        const noteColorType: 'green' | 'yellow' | 'blue' = noteColor === '#EBFFCF' ? 'green' : noteColor === '#E3F2FF' ? 'blue' : 'yellow';
        const noteLines = annotation.note ? annotation.note.split('\n') : [];
        const title = noteLines[0] || '';
        const content = noteLines.slice(1).join('\n');
        
        parts.push(
          <React.Fragment key={`note-${annotation.id}`}>
            <HighlightedText data-highlight data-note-id={annotation.id} data-annotation-id={annotation.id} $color={noteColor} $isAreaSelection={false} title="메모 (클릭하여 보기)"
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleAnnotationClick(annotation, e); }}
              onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
            >
              {isHighlighted && <HighlightMarker data-highlight-marker />}
              {highlightedText}
              {/* 호버 시 메모창 표시 로직 주석처리 (향후 복구 예정) */}
              {/* <InlineStickyNoteWrapper annotationId={annotation.id} color={noteColorType} noteTitle={title} noteContent={content} onViewNote={() => handleAnnotationClick(annotation)} /> */}
            </HighlightedText>
          </React.Fragment>
        );
      }

      lastIndex = Math.max(lastIndex, safeEndOffset);
    });

    if (lastIndex < text.length) parts.push(text.substring(lastIndex));

    const result = <>{parts}</>;
    renderTextWithHighlightsCache.current.set(cacheKey, result);
    return result;
  }, [annotations, hideAnnotations, highlightedAnnotationId]);
  
  // 주석 변경 시 관련 캐시만 선택적 무효화 (전체 clear 대신)
  useEffect(() => {
    const currentHash = annotations.map(a => `${a.id}:${a.range.paragraphId}`).sort().join('|');
    
    // 주석 구조가 실제로 변경된 경우에만 캐시 정리
    if (lastAnnotationsRef.current !== currentHash) {
      lastAnnotationsRef.current = currentHash;
      
      // 캐시가 너무 커지면 정리 (메모리 관리)
      if (renderTextWithHighlightsCache.current.size > 100) {
        renderTextWithHighlightsCache.current.clear();
      }
    }
  }, [annotations]);

  // Content 높이 측정 (디바운스 적용)
  useEffect(() => {
    let rafId: number | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    
    const updateContentHeight = () => {
      if (rafId) cancelAnimationFrame(rafId);
      
      rafId = requestAnimationFrame(() => {
        if (contentRef.current) {
          const children = Array.from(contentRef.current.children);
          if (children.length > 0) {
            const firstChild = children[0] as HTMLElement;
            const lastChild = children[children.length - 1] as HTMLElement;
            const firstTop = firstChild.offsetTop;
            const lastBottom = lastChild.offsetTop + lastChild.offsetHeight;
            setContentTop(firstTop);
            setContentHeight(lastBottom - firstTop);
        } else {
            setContentTop(0);
            setContentHeight(contentRef.current.scrollHeight);
          }
        }
      });
    };

    // 디바운스된 업데이트
    const debouncedUpdate = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(updateContentHeight, 50);
    };

    updateContentHeight();
    window.addEventListener('resize', debouncedUpdate);
    
    // MutationObserver는 childList만 감시 (attributes 제외로 성능 향상)
    const observer = new MutationObserver(debouncedUpdate);
    if (contentRef.current) {
      observer.observe(contentRef.current, { childList: true, subtree: false });
    }

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (timeoutId) clearTimeout(timeoutId);
      window.removeEventListener('resize', debouncedUpdate);
      observer.disconnect();
    };
  }, [pageData, nextPageData]);

  // 모바일 네이티브 텍스트 선택 UI(복사/공유/웹검색) 억제 - 커스텀 SelectionToolbar만 표시
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      const container = containerRef.current;
      if (!container) return;
      const target = e.target as HTMLElement;
      if (!container.contains(target)) return;
      if (target.closest('input') || target.closest('textarea')) return;
      e.preventDefault();
    };
    document.addEventListener('contextmenu', handleContextMenu, { capture: true });
    return () => document.removeEventListener('contextmenu', handleContextMenu, { capture: true } as EventListenerOptions);
  }, []);

  // 모바일: selectionchange 이벤트로 텍스트 선택 완료 감지 (OS가 선택을 확정한 후 툴바 표시)
  useEffect(() => {
    const isMobile = 'ontouchstart' in window || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    if (!isMobile) return;

    let debounceTimer: NodeJS.Timeout | null = null;
    const handleSelectionChange = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const selection = window.getSelection();
        if (selection && selection.toString().trim().length > 0) {
          handleTextSelection();
        }
      }, 300);
    };
    document.addEventListener('selectionchange', handleSelectionChange);
    return () => {
      document.removeEventListener('selectionchange', handleSelectionChange);
      if (debounceTimer) clearTimeout(debounceTimer);
    };
  }, [handleTextSelection]);

  // 마우스업 이벤트
  useEffect(() => {
    const handleMouseUp = (e: MouseEvent | TouchEvent) => {
      const target = e.target as HTMLElement;
      // console.log('[MouseUp] 이벤트 발생:', {
      //   target: target.tagName,
      //   hasToolbar: !!target.closest('[data-toolbar]'),
      //   hasModal: !!target.closest('[data-modal]'),
      //   hasInlineNote: !!target.closest('[data-inline-note]'),
      //   hasHighlight: !!target.closest('[data-highlight]'),
      //   hasAreaSelection: !!target.closest('[data-area-selection]'),
      // });
      
      // [주석처리] 표 내용 보기 기능 비활성화
      // const clickedTableButton = target.closest('[data-table-view-button]') || 
      //                            (target.closest('button') && target.closest('[class*="TableViewButton"]'));
      // if (clickedTableButton) {
      //   console.log('[MouseUp] 테이블 모달 버튼 클릭 감지, 녹음 모달 닫기 로직 건너뜀');
      //   return;
      // }
      // const tableModalOpen = document.querySelector('[data-table-modal-overlay]');
      // if (tableModalOpen) {
      //   console.log('[MouseUp] 테이블 모달이 열려있어 녹음 모달 닫기 로직 건너뜀');
      //   return;
      // }
      // setTimeout(() => {
      //   const tableModalStillOpening = document.querySelector('[data-table-modal-overlay]');
      //   if (tableModalStillOpening) {
      //     console.log('[MouseUp] setTimeout: 테이블 모달이 열려있어 녹음 모달 닫기 로직 건너뜀');
      //     return;
      //   }
      // }, 50);
      
      // 녹음 모달 내부 클릭인지 확인 (버튼 클릭도 포함)
      const isRecordingModalClick = target.closest('[class*="RecordingModal"]') || 
                                     target.closest('[class*="RecordingModalOverlay"]') ||
                                     target.closest('[data-recording-modal]') ||
                                     target.closest('button[title="녹음 시작"]') ||
                                     target.closest('button[title="일시 중지"]') ||
                                     target.closest('button[title="녹음 재개"]') ||
                                     target.closest('button[title="녹음 중지"]') ||
                                     target.closest('button[title="미리 듣기"]') ||
                                     target.closest('button[title="재생 정지"]') ||
                                     target.closest('button[title="닫기"]');
      
      // 녹음 모달이 열려있으면 모달 닫기 (녹음 중이어도 모달만 닫고 녹음은 계속 진행)
      if (isRecordingModalOpen) {
        // 녹음 모달 내부가 아닌 경우에만 닫기
        if (!isRecordingModalClick) {
          // 약간의 지연을 두어 버튼 클릭 이벤트가 먼저 처리되도록 함
          setTimeout(() => {
            // [주석처리] 표 내용 보기 기능 비활성화
            // const tableModalStillOpen = document.querySelector('[data-table-modal-overlay]');
            // if (tableModalStillOpen) {
            //   console.log('[MouseUp] setTimeout 내부: 테이블 모달이 열려있어 녹음 모달 닫기 취소');
            //   return;
            // }
            
            // 모달이 여전히 열려있으면 닫기 (녹음 중이어도 모달만 닫음)
            if (isRecordingModalOpen) {
              closeRecordingModalOnly();
            }
          }, 150);
        }
      }
      
      // 드롭다운 메뉴가 열려있으면 텍스트 선택 처리 건너뛰기
      if (showHighlightDropdown) {
        // console.log('[MouseUp] 드롭다운이 열려있어 텍스트 선택 처리 건너뜀');
        return;
      }
      
      // [주석처리] 표 내용 보기 기능 비활성화
      // if (clickedTableButton) {
      //   return;
      // }
      
      if (target.closest('[data-toolbar]') || target.closest('[data-modal]') ||
          target.closest('[data-inline-note]') || target.closest('[data-highlight]') ||
          target.closest('[data-area-selection]') || target.closest('[data-color-picker]') ||
          target.closest('[class*="DropdownMenuOverlay"]') || target.closest('[class*="DropdownMenuContainer"]') ||
          isRecordingModalClick) {
        // console.log('[MouseUp] 툴바/모달 등 클릭으로 인해 텍스트 선택 처리 건너뜀');
        return;
      }
      setTimeout(() => handleTextSelection(), 10);
    };

    const handleTouchEnd = (e: TouchEvent) => {
      const selection = window.getSelection();
      const hasSelection = selection && selection.toString().trim().length > 0;
      if (hasSelection) {
        setTimeout(() => handleTextSelection(), 200);
        return;
      }
      handleMouseUp(e);
    };

    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('touchend', handleTouchEnd);

    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTextSelection, showLearningRecords, showHighlightDropdown, isRecordingModalOpen, isRecording, isPaused, closeRecordingModalOnly]);

  // 페이지 번호 입력 UI 외부 클릭 시 닫기는 usePageNavigation 훅에서 처리됨

  // 동기화 위치 버튼 외부 클릭 시 축소
  useEffect(() => {
    if (!isSyncLocationExpanded) return;
    
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // [주석처리] 표 내용 보기 기능 비활성화
      // const clickedTableButton = target.closest('[data-table-view-button]') || 
      //                            (target.closest('button') && target.closest('[class*="TableViewButton"]'));
      // if (clickedTableButton) {
      //   return;
      // }
      
      if (!target.closest('[data-sync-location-button]')) {
        setIsSyncLocationExpanded(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSyncLocationExpanded]);

  // 채팅창이 열릴 때 툴바 닫지 않음 (AI 패널이 열려있어도 텍스트 선택 툴바 사용 가능)

  // 학습 기록 패널이 열릴 때 툴바 강제로 닫기
  useEffect(() => {
    if (showLearningRecords) {
      closeAllToolbars();
    }
  }, [showLearningRecords, closeAllToolbars]);

  // 툴바 외부 클릭 시 닫기
  useEffect(() => {
    if (!toolbarPosition) return;

    // closeAllToolbars 함수 재사용

    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      // 학습 기록 패널이 열려있으면 무조건 툴바 닫기
      if (showLearningRecords) {
        closeAllToolbars();
        return;
      }
      
      // 드롭다운 메뉴 오버레이나 컨테이너 클릭은 무시 (드롭다운이 열려있을 때)
      if (target.closest('[class*="DropdownMenuOverlay"]') || target.closest('[class*="DropdownMenuContainer"]')) {
        return;
      }
      
      // 색상 선택기 클릭은 무시 (색상 선택기 내부 클릭 시)
      const colorPicker = target.closest('[data-color-picker]');
      if (colorPicker) {
        return;
      }
      
      // 툴바 내부 클릭은 무시 (더보기 버튼 클릭 포함) - 드롭다운이 열려있지 않을 때만
      if (target.closest('[data-toolbar]') && !showHighlightDropdown) {
        // console.log('[ClickOutside] 툴바 내부 클릭 감지, 무시');
        return;
      }
      
      // 더보기 버튼 직접 클릭도 무시 - 드롭다운이 열려있지 않을 때만
      if ((target.closest('button[title="더보기"]') || target.closest('.sc-inUfAx')) && !showHighlightDropdown) {
        // console.log('[ClickOutside] 더보기 버튼 클릭 감지, 무시');
        return;
      }
      
      // 모달 클릭은 무시 (모달이 열려있을 때)
      const clickedModal = target.closest('[data-sticky-note-modal]');
      if (clickedModal) {
        return;
      }
      
      // [주석처리] 표 내용 보기 기능 비활성화
      // const clickedTableButton = target.closest('[data-table-view-button]') || 
      //                            (target.closest('button') && target.closest('[class*="TableViewButton"]'));
      // if (clickedTableButton) {
      //   console.log('[ClickOutside] 테이블 모달 버튼 클릭 감지, 무시');
      //   return;
      // }
      // const clickedTableModal = target.closest('[data-table-modal-overlay]');
      // if (clickedTableModal) {
      //   console.log('[ClickOutside] 테이블 모달 클릭 감지, 무시');
      //   return;
      // }
      
      // 드롭다운이 열려있을 때는 드롭다운 외부 클릭만 처리
      if (showHighlightDropdown) {
        // 색상 선택기 클릭은 무시
        if (target.closest('[data-color-picker]')) {
          // console.log('[ClickOutside] 색상 선택기 클릭 감지, 무시');
          return;
        }
        // 드롭다운 외부 클릭 시 드롭다운 닫기
        if (!target.closest('[class*="DropdownMenuOverlay"]') && !target.closest('[class*="DropdownMenuContainer"]')) {
          // console.log('[ClickOutside] 드롭다운 외부 클릭, 드롭다운 닫기');
          setShowHighlightDropdown(false);
          setShowHighlightColorPicker(false);
          setShowUnderlineColorPicker(false);
          setHighlightDropdownPosition(null);
        }
        return; // 드롭다운이 열려있으면 툴바는 닫지 않음
      }
      
      // 색상 선택기가 열려있으면 닫기만 하고 툴바는 유지
      if (showHighlightColorPicker || showUnderlineColorPicker) {
        setShowHighlightColorPicker(false);
        setShowUnderlineColorPicker(false);
        setHighlightDropdownPosition(null);
        return;
      }
      
      // 채팅창 패널이나 학습 기록 패널 클릭 시 툴바 닫기
      const clickedAIPanel = target.closest('[data-ai-panel]');
      const clickedLearningPanel = target.closest('[data-learning-panel]');
      if (clickedAIPanel || clickedLearningPanel) {
        closeAllToolbars();
        return;
      }
      
      // 테이블 모달이 열려있으면 툴바 닫지 않기
      const tableModalOpen = document.querySelector('[data-table-modal-overlay]');
      if (tableModalOpen) {
        // console.log('[ClickOutside] 테이블 모달이 열려있어 툴바 닫기 건너뜀');
        return;
      }
      // Figure 이미지 확대 오버레이가 열려있으면 툴바 닫지 않기
      const figureImageOverlayOpen = document.querySelector('[data-figure-image-overlay]');
      if (figureImageOverlayOpen) {
        return;
      }
      
      // 그 외 모든 외부 클릭 시 툴바 닫기
      closeAllToolbars();
    };

    // bubble phase에서만 이벤트 감지 (capture phase는 더보기 버튼 클릭을 막을 수 있음)
    document.addEventListener('click', handleClickOutside, false);
    document.addEventListener('mousedown', handleClickOutside, false);
    
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
      document.removeEventListener('mousedown', handleClickOutside, false);
    };
  }, [toolbarPosition, showLearningRecords]);

  // useGestures 훅 사용 (컴포넌트 인덱스 기반 핸들러 사용)
  useGestures({
    containerRef,
    pageData,
    handlePrevPage: handlePrevPageByIndex,
    handleNextPage: handleNextPageByIndex,
    isModalOpen,
    isPageNumberExpanded,
    isRecordingModalOpen,
    showLearningRecords,
    showAIPanel,
  });

  // 기존 마우스 휠 및 터치 제스처 코드는 useGestures 훅으로 이동됨

  // 컴포넌트 렌더링 함수
  // pageNum: 실제 페이지 번호 (idx) - annotation 필터링용
  // pageNoDb: DB 인덱스 (page_no) - data-page-no 속성용
  const renderComponent = (component: ApiPageComponent, pageNum: number, pageNoDb: number, constrainedHeight?: number, footnoteText?: string) => {
    switch (component.kind) {
      case 'header_page_number':
        return null;
      case 'subtitle':
        return <ComponentContainer key={component.id} data-page-no={pageNoDb}><Subtitle>{component.content}</Subtitle></ComponentContainer>;
      case 'title':
        return <ComponentContainer key={component.id} data-page-no={pageNoDb}><Title>{component.content}</Title></ComponentContainer>;
      case 'paragraph':
        // a.pageNumber는 DB 인덱스(page_no)이므로 pageNoDb와 비교해야 함
        const paragraphAnnotations = annotations.filter(a => a.range.paragraphId === component.id && a.pageNumber === pageNoDb);
        const areaAnnotations = paragraphAnnotations.filter(a => a.type === 'box' || a.color === '#FFF0F3');
        
        return (
          <ComponentContainer key={component.id} data-page-no={pageNoDb} style={{ breakInside: 'auto' }}>
            <ParagraphText
              data-paragraph-id={component.id}
              data-paragraph-text="true"
              data-page-no={pageNoDb}
            >
              {areaAnnotations.map((annotation) => (
                <AreaSelectionOverlayComponent key={`area-overlay-${annotation.id}`} annotation={annotation} paragraphId={component.id} onAnnotationClick={handleAnnotationClick} highlightedAnnotationId={highlightedAnnotationId} />
              ))}
              <TextContentWrapper
                data-text-content="true"
              >
                {renderTextWithHighlights(component.content, component.id, pageNum, pageNoDb)}
              </TextContentWrapper>
            </ParagraphText>
          </ComponentContainer>
        );
      case 'figure':
        if (!component.media_urls || !component.media_urls.trim()) {
          return null;
        }
        const imageUrls = component.media_urls
          .split(',')
          .map((url: string) => url.trim())
          .filter((url: string) => url.startsWith('http://') || url.startsWith('https://'));

        if (imageUrls.length > 0) {
          const imageMaxHeight = constrainedHeight
            ? Math.max(constrainedHeight - 40, 30)
            : undefined;
          return (
            <ComponentContainer key={component.id} data-page-no={pageNoDb}>
              <Figure>
                <FigureImagesWrapper>
                  {imageUrls.map((url, idx) => (
                    <ExpandableFigureImage key={`${component.id}-img-${idx}`} src={url} alt={component.media_note || ''} maxHeight={imageMaxHeight} />
                  ))}
                </FigureImagesWrapper>
                {component.content && <FigureCaption>{component.content}</FigureCaption>}
                {footnoteText && <FigureSource>{footnoteText}</FigureSource>}
              </Figure>
            </ComponentContainer>
          );
        }

        const matrixResult = parseFigureMatrix(component.content || '', component.media_note || '');
        
        if (matrixResult.success) {
          const { rows, cols, items, rowLabels, colLabels } = matrixResult;
          const hasRowLabels = rowLabels.length === rows;
          const rowLabelWidth = 80;
          
          const rowItems: { marker: string; text: string }[][] = [];
          for (let r = 0; r < rows; r++) {
            rowItems.push(items.slice(r * cols, (r + 1) * cols));
          }
          
          return (
            <ComponentContainer key={component.id} data-page-no={pageNoDb}>
              <MatrixContainer>
                <MatrixOuterWrapper $cols={cols} $hasRowLabels={hasRowLabels} $rowLabelWidth={rowLabelWidth}>
                  {rowItems.map((rowCells, rowIdx) => (
                    <React.Fragment key={`row-${rowIdx}`}>
                      {hasRowLabels && <MatrixRowLabel $width={rowLabelWidth}>{rowLabels[rowIdx]}</MatrixRowLabel>}
                      {rowCells.map((item, colIdx) => (
                        <MatrixCell key={`cell-${rowIdx}-${colIdx}`} $row={rowIdx} $col={colIdx} $totalRows={rows} $totalCols={cols}>
                          <MatrixCellNumber>{item.marker}</MatrixCellNumber>
                          {item.text}
                        </MatrixCell>
                      ))}
                    </React.Fragment>
                  ))}
                  {colLabels.length > 0 && (
                    <>
                      {hasRowLabels && <MatrixColumnLabelSpacer />}
                      {colLabels.map((label, idx) => <MatrixColumnLabel key={idx}>{label}</MatrixColumnLabel>)}
                    </>
                  )}
                </MatrixOuterWrapper>
              </MatrixContainer>
            </ComponentContainer>
          );
        }
        
    return (
          <ComponentContainer key={component.id} data-page-no={pageNoDb}>
            <FigureDescription>
              {component.content && <FigureTitle>{component.content}</FigureTitle>}
              {component.media_note && <FigureNote>{component.media_note}</FigureNote>}
            </FigureDescription>
          </ComponentContainer>
        );
      case 'table':
        // [주석처리] 표 내용 보기 기능 비활성화 - TableModalWrapper 대신 caption만 표시
        // const tableRows = component.content.split('\n').filter(row => row.trim());
        // const tableHeader = tableRows.length > 0 ? tableRows[0].split('|').map(cell => cell.trim()) : [];
        // const tableBody = tableRows.slice(1).map(row => row.split('|').map(cell => cell.trim()));
        // return (
        //   <TableModalWrapper
        //     key={`${component.id}-${pageNoDb}`}
        //     componentId={component.id}
        //     pageNoDb={pageNoDb}
        //     tableHeader={tableHeader}
        //     tableBody={tableBody}
        //     mediaNote={component.media_note}
        //   />
        // );
        return (
          <TableComponentContainer key={component.id} data-page-no={pageNoDb}>
            {component.media_note && <TableCaption>{component.media_note}</TableCaption>}
          </TableComponentContainer>
        );
      case 'footnote':
        return <ComponentContainer key={component.id} data-page-no={pageNoDb}><Footnote>{component.content}</Footnote></ComponentContainer>;
      default:
        return null;
    }
  };

  // 진행 상태 조회 중
  if (isProgressLoading) {
    return <Layout bookUuid={bookUid}><Container><LoadingContainer>진행 상태를 불러오는 중...</LoadingContainer></Container></Layout>;
  }

  // 로딩/에러 상태
  if (loading) {
    return <Layout bookUuid={bookUid}><Container><LoadingContainer>페이지 데이터를 불러오는 중...</LoadingContainer></Container></Layout>;
  }

  if (error) {
    return <Layout bookUuid={bookUid}><Container><ErrorContainer><div>{error}</div><Button onClick={handleBackToList}>목록으로 돌아가기</Button></ErrorContainer></Container></Layout>;
  }

  if (!pageData) {
    return <Layout bookUuid={bookUid}><Container><ErrorContainer><div>페이지 데이터를 찾을 수 없습니다.</div><Button onClick={handleBackToList}>목록으로 돌아가기</Button></ErrorContainer></Container></Layout>;
  }

  return (
    <Layout 
      onVoiceRecord={handleVoiceRecord} 
      isRecording={isRecording} 
      bookUuid={bookUid}
      currentPageNo={currentPageNumber}
      getCurrentVisiblePageNo={() => firstVisiblePageRef.current || currentPageNumber}
      onNavigateToPage={handleNavigateToPage}
      onBackToList={handleBackToList}
      onQuizCreateClick={handleQuizCreateClick}
      convertPageNoDbToIdx={convertPageNoDbToIdx}
      onOpenLearningRecords={() => {
        closeAllToolbars();
        setShowLearningRecords(true);
      }}
      onOpenAIPanel={() => {
        closeAllToolbars();
        setAiPanelMode('chat');
        setShowAIPanel(true);
      }}
      isAIPanelOpen={showAIPanel}
      isLearningRecordsOpen={showLearningRecords}
    >
      <Container ref={containerRef}>
        <ViewerContainer ref={viewerContainerCallbackRef} data-viewer-content="true" tabIndex={-1} role="article">
          <Navigation>
            <PageInfo
              onClick={handlePageNumberClick}
              data-page-number-indicator
              $isExpanded={isPageNumberExpanded}
            >
              <span>P.</span>
              {isPageNumberExpanded ? (
                <>
                  <PageInfoInput
                    type="text"
                    value={pageNumberInput}
                    onChange={handlePageNumberInputChange}
                    onKeyDown={handlePageNumberInputKeyDown}
                    onClick={(e) => e.stopPropagation()}
                    placeholder="페이지"
                    autoFocus
                  />
                  {lastPageIndex > 0 && (
                    <span>/ {lastPageIndex}</span>
                  )}
                </>
              ) : (
                <span>
                  {displayComponents.length > 0 ? (
                    (() => {
                      const displayNumbers = displayComponents
                        .map(c => c.displayNumber)
                        .filter(n => n > 0);
                      if (displayNumbers.length === 0) {
                        return currentPageNumber || '';
                      }
                      const minPage = Math.min(...displayNumbers);
                      const maxPage = Math.max(...displayNumbers);
                      return minPage === maxPage 
                        ? `${minPage}` 
                        : `${minPage} - ${maxPage}`;
                    })()
                  ) : (
                    <>
                      {pageData.display_number || ''}
                      {nextPageData && nextPageData.display_number > 0 && ` - ${nextPageData.display_number}`}
                    </>
                  )}
                </span>
              )}
            </PageInfo>
            <NavButtonGroup>
              <NavButton onClick={handlePrevPageByIndex} disabled={pageData.idx <= 1 && displayStartIndex === 0} aria-label="이전페이지">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.325 2.95312C10.3749 2.99588 10.4158 3.04804 10.4455 3.10663C10.4753 3.16522 10.4931 3.2291 10.4981 3.2946C10.5032 3.3601 10.4952 3.42595 10.4748 3.48839C10.4543 3.55082 10.4218 3.60861 10.379 3.65846L6.65832 7.99979L10.379 12.3411C10.4243 12.3906 10.4591 12.4486 10.4815 12.5118C10.5039 12.5749 10.5134 12.642 10.5093 12.7089C10.5053 12.7758 10.4879 12.8412 10.458 12.9012C10.4282 12.9613 10.3866 13.0147 10.3357 13.0583C10.2849 13.102 10.2257 13.1349 10.1619 13.1553C10.098 13.1756 10.0307 13.1829 9.96393 13.1767C9.89719 13.1704 9.83238 13.1509 9.77335 13.1191C9.71432 13.0874 9.66228 13.0441 9.62032 12.9918L5.62032 8.32512C5.54268 8.23451 5.5 8.11912 5.5 7.99979C5.5 7.88046 5.54268 7.76507 5.62032 7.67446L9.62032 3.00779C9.70664 2.90725 9.82935 2.84508 9.96148 2.83496C10.0936 2.82483 10.2244 2.86757 10.325 2.95379" fill="#9B9B9B"/>
                </svg>
              </NavButton>
              <NavButton onClick={handleNextPageByIndex} aria-label="다음페이지">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M5.67458 2.95351C5.7753 2.86737 5.90609 2.82474 6.03823 2.835C6.17036 2.84525 6.29302 2.90754 6.37924 3.00818L10.3792 7.67484C10.4569 7.76546 10.4996 7.88085 10.4996 8.00018C10.4996 8.1195 10.4569 8.2349 10.3792 8.32551L6.37924 12.9922C6.29159 13.0879 6.17015 13.1458 6.04059 13.1536C5.91103 13.1614 5.78351 13.1185 5.68499 13.034C5.58647 12.9495 5.52467 12.83 5.51265 12.7008C5.50063 12.5716 5.53933 12.4427 5.62058 12.3415L9.34124 8.00018L5.62058 3.65884C5.53428 3.55829 5.49143 3.4276 5.50143 3.29547C5.51143 3.16335 5.57346 3.04059 5.67391 2.95418" fill="#9B9B9B"/>
                </svg>
              </NavButton>
            </NavButtonGroup>
          </Navigation>
          {isDraggingPdf && (
            <DropOverlayContainer>
              <DropZoneHalf
                $isDragOver={isLeftZoneDragOver}
                onDrop={handleLeftZoneDrop}
                onDragOver={handleLeftZoneDragOver}
                onDragLeave={handleLeftZoneDragLeave}
              >
                {isLeftZoneDragOver ? dropZoneContent : null}
              </DropZoneHalf>
              <DropZoneHalf
                $isDragOver={isRightZoneDragOver}
                onDrop={handleRightZoneDrop}
                onDragOver={handleRightZoneDragOver}
                onDragLeave={handleRightZoneDragLeave}
              >
                {isRightZoneDragOver ? dropZoneContent : null}
              </DropZoneHalf>
            </DropOverlayContainer>
          )}
          <BookViewerSplit>
            {openPdf && bookUid && attachmentPanelOnLeft && (
              <AttachmentPanelWrapper $show $onLeft style={{ order: -1 }}>
                <AttachmentPanel
                  bookUid={bookUid}
                  openPdf={openPdf}
                  onMinimize={handleMinimizePdf}
                  onClose={handleClosePdf}
                  panelOnLeft={true}
                  onPositionToggle={handleAttachmentPanelPositionToggle}
                />
              </AttachmentPanelWrapper>
            )}
            <BookContentPanel style={{ order: 0 }}>
              {/* 숨겨진 측정 컨테이너 */}
              {componentsToMeasure.length > 0 && (
                <div
                  ref={measureContainerRef}
                  style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    top: 0,
                    left: 0,
                    width: effectivePagesPerView === 2 && leftPageContainerRef.current?.clientWidth
                      ? (leftPageContainerRef.current.clientWidth - 48) / 2
                      : leftPageContainerRef.current?.clientWidth || '50%',
                    pointerEvents: 'none',
                    zIndex: -1,
                  }}
                >
                  {componentsToMeasure.map((fc, idx) => (
                    <div key={`measure-${idx}`} data-measure-idx={idx}>
                      {renderComponent(fc.data, fc.pageNo, fc.pageNoDb)}
                    </div>
                  ))}
                </div>
              )}

              {/* 페이지 로딩 중 메시지 표시 */}
              {(!isContentReady || (showGoBackButton && !highlightMarkerPosition)) && (
                <PageLoadingOverlay>
                  데이터를 화면에 최적화 하는 중입니다...
                </PageLoadingOverlay>
              )}

              {/* CSS Multi-Column Layout - 자동으로 2컬럼 분배 */}
              {/* 학습기록 이동 시 텍스트+어노테이션+되돌아가기버튼이 모두 준비된 후 한 번에 표시 */}
              <PagesContainer 
                ref={leftPageContainerRef}
                $pagesPerView={effectivePagesPerView}
                style={{ 
                  opacity: isContentReady && (!showGoBackButton || highlightMarkerPosition) ? 1 : 0 
                }} 
                key={`font-${fontSettings.fontSize}-${fontSettings.fontWeight}-${fontSettings.letterSpacing}-${fontSettings.lineHeight}-${fontSettings.fontFamily}-${effectivePagesPerView}`}
              >
                <ColumnContentWrapper ref={contentRef} data-pages-per-view={effectivePagesPerView} tabIndex={-1} role="article">
                  {/* CSS가 자동으로 2컬럼으로 분배 */}
                  {displayComponents.map((fc, idx) => {
                const cachedPage = pageCacheRef.current.get(fc.pageNo);
                const isLastComponentOfPage = cachedPage
                  ? fc.componentIdx === cachedPage.page.components.length - 1
                  : false;

                // 이전 컴포넌트와 페이지가 다르면 새 페이지 시작 (페이지 경계)
                const prevFc = idx > 0 ? displayComponents[idx - 1] : null;
                const isFirstComponentOfPage = idx === 0 || (prevFc && prevFc.pageNo !== fc.pageNo);
                // 다음 컴포넌트가 다른 페이지이거나 마지막이면 현재 페이지의 끝
                const nextFcForBoundary = idx + 1 < displayComponents.length ? displayComponents[idx + 1] : null;
                const isPageEnd = isLastComponentOfPage || !nextFcForBoundary || nextFcForBoundary.pageNo !== fc.pageNo;

                // footnote가 직전 figure에 병합되었으면 별도 렌더링 건너뛰기
                if (fc.data.kind === 'footnote' && idx > 0 && displayComponents[idx - 1].data.kind === 'figure') {
                  return null;
                }

                // figure 다음에 footnote가 오면 footnote 텍스트를 figure에 병합
                const nextFc = idx + 1 < displayComponents.length ? displayComponents[idx + 1] : null;
                const mergedFootnoteText = (fc.data.kind === 'figure' && nextFc?.data.kind === 'footnote')
                  ? nextFc.data.content
                  : undefined;

                return (
                  <React.Fragment key={`component-${fc.pageNo}-${fc.componentIdx}-${idx}`}>
                    {/* 페이지 경계: 이전 페이지 내용이 있을 때만 float clear + 페이지 번호 표시 */}
                    {isFirstComponentOfPage && idx > 0 && (prevFc?.displayNumber ?? fc.displayNumber) > 0 && (
                      <>
                        <div style={{ clear: 'both' }} />
                        <PageNumberWrapper data-page-marker={prevFc?.displayNumber ?? fc.displayNumber}>
                          <ComponentContainer><PageNumberMarker><PageNumberMarkerText>{prevFc?.displayNumber ?? fc.displayNumber}</PageNumberMarkerText></PageNumberMarker></ComponentContainer>
                        </PageNumberWrapper>
                      </>
                    )}
                    <div
                      data-component-key={`${fc.pageNo}-${fc.componentIdx}`}
                      data-page-no={fc.pageNo}
                      data-is-last-of-page={isLastComponentOfPage ? 'true' : 'false'}
                      style={{
                        ...(IMAGE_KINDS.has(fc.data.kind) ? (() => {
                          // 같은 페이지 내 다음 텍스트 컴포넌트가 있는지 확인 (footnote는 figure에 병합되므로 제외)
                          const hasTextAfter = !fc.constrainedHeight && displayComponents.slice(idx + 1).some(
                            nextComp => nextComp.pageNo === fc.pageNo && nextComp.data.kind !== 'footnote' && TEXT_KINDS.has(nextComp.data.kind)
                          );
                          return hasTextAfter ? {
                            float: 'left' as const,
                            width: 'fit-content',
                            maxWidth: 'min(350px, 50%)',
                            marginRight: '16px',
                            marginBottom: '16px',
                          } : {
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%',
                          };
                        })() : {}),
                        overflow: 'visible',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {renderComponent(fc.data, fc.pageNo, fc.pageNoDb, fc.constrainedHeight, mergedFootnoteText)}
                    </div>
                    {/* 페이지 끝에서 float clear + 마지막 페이지일 때 페이지 번호 표시 */}
                    {isPageEnd && (
                      <>
                        <div style={{ clear: 'both' }} />
                        {/* 화면의 마지막 컴포넌트이고 다음 페이지 내용이 없을 때 페이지 번호 표시 */}
                        {!nextFcForBoundary && fc.displayNumber > 0 && (
                          <PageNumberWrapper data-page-marker={fc.displayNumber}>
                            <ComponentContainer><PageNumberMarker><PageNumberMarkerText>{fc.displayNumber}</PageNumberMarkerText></PageNumberMarker></ComponentContainer>
                          </PageNumberWrapper>
                        )}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
            </ColumnContentWrapper>
            {/* 측정용 숨겨진 ref (기존 호환성 유지) */}
            <div ref={contentRef2} style={{ display: 'none' }} />
          </PagesContainer>
            </BookContentPanel>
            {openPdf && bookUid && !attachmentPanelOnLeft && (
              <AttachmentPanelWrapper $show $onLeft={false} style={{ order: 1 }}>
                <AttachmentPanel
                  bookUid={bookUid}
                  openPdf={openPdf}
                  onMinimize={handleMinimizePdf}
                  onClose={handleClosePdf}
                  panelOnLeft={false}
                  onPositionToggle={handleAttachmentPanelPositionToggle}
                />
              </AttachmentPanelWrapper>
            )}
          </BookViewerSplit>
          {/* 플로팅 폴더: 모달 "열기" 버튼으로 연 PDF가 있을 때만 표시 */}
          {folderPosition && openedPdfHistory.length > 0 && (
            <div
              ref={attachmentFloatingRef}
              style={{
                position: 'absolute',
                left: folderPosition.x,
                top: folderPosition.y,
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                alignItems: isFolderOnLeft ? 'flex-start' : 'flex-end',
                pointerEvents: 'none',
              }}
            >
              <div style={{ pointerEvents: 'auto' }}>
                {isFolderOpen && (
                  <div style={{
                    position: 'absolute',
                    ...(isFolderOnLeft ? { left: 0 } : { right: 0 }),
                    bottom: '100%',
                    marginBottom: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 12,
                    maxHeight: 200,
                    overflowY: 'auto',
                    padding: 8,
                    minWidth: 220,
                    maxWidth: 400,
                  }}>
                    {visibleFolderAttachments.length === 0 ? (
                      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>열린 PDF가 없습니다</span>
                    ) : (
                      visibleFolderAttachments.map((att) => (
                        <div
                          key={att.file_uuid}
                          role="button"
                          tabIndex={0}
                          draggable
                          onDragStart={(e) => handleFolderPdfDragStart(e, att)}
                          onDragEnd={handleFolderPdfDragEnd}
                          onClick={() => handleOpenPdfFromFolder(att)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpenPdfFromFolder(att); } }}
                          style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            width: 'fit-contents', padding: '8px 20px', border: 'none', borderRadius: 999,
                            background: openPdf?.file_uuid === att.file_uuid ? 'var(--bg-black, #0B0B0B)' : 'var(--bg-white, #ffffffe8)',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                            color: openPdf?.file_uuid === att.file_uuid ? 'var(--bg-secondary, #FFF)' : 'var(--text-primary, #333)',
                            outline: 0, fontSize: 14, fontWeight: '600', textAlign: 'left' as const, cursor: 'grab', transition: 'all 0.2s', boxSizing: 'border-box' as const,
                          }}
                        >
                          <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' as const, minWidth: 0}} title={att.file_name}>{att.file_name}</span>
                          <button
                            type="button"
                            onClick={(e) => handleRemoveFromFolder(e, att.file_uuid)}
                            title="목록에서 제거"
                            style={{
                              flexShrink: 0, width: 24, height: 24, border: 'none', color: 'inherit', cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 8,
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              {/*
                                다크모드 지원: prefer-color-scheme 및 커스텀 프로퍼티 변수 사용.
                                CSS에서 --pdf-folder-remove-icon, --pdf-folder-remove-icon-active를 정의해두면
                                다크/라이트 모드에 따라 컬러가 자동 적용됨.
                              */}
                              <path
                                d="M2 2L8 8"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                stroke={
                                  openPdf?.file_uuid === att.file_uuid
                                    ? 'var(--pdf-folder-remove-icon-active)'
                                    : 'var(--pdf-folder-remove-icon)'
                                }
                              />
                              <path
                                d="M8 2L2 8"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                stroke={
                                  openPdf?.file_uuid === att.file_uuid
                                    ? 'var(--pdf-folder-remove-icon-active)'
                                    : 'var(--pdf-folder-remove-icon)'
                                }
                              />
                            </svg>
                          </button>
                        </div>
                      ))
                    )}
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => {
                    if (folderDragJustEndedRef.current) {
                      folderDragJustEndedRef.current = false;
                      setIsFolderOpen(true);
                      return;
                    }
                    setIsFolderOpen((o) => !o);
                  }}
                  onMouseDown={handleFolderMouseDown}
                  onTouchStart={handleFolderTouchStart}
                  title={isFolderOpen ? '폴더 닫기' : '폴더 열기'}
                  style={{
                    width: 60, height: 60, borderRadius: '50%', border: 'none',
                    background: isFolderOpen ? '#2B2B2B' : '#4B4B4B',
                    color: 'white', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: isFolderOpen ? '-2px 2px 4px 0px #00000026' : '1.25px 1.25px 2.5px 3.75px #00000026',
                    transition: 'background 0.2s, box-shadow 0.2s',
                    outline: 'none',
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25" fill="none">
                    <mask id="path-1-outside-1_3090_5645" maskUnits="userSpaceOnUse" x="-0.75" y="-0.75" width="28" height="26" fill="black">
                      <rect fill="white" x="-0.75" y="-0.75" width="28" height="26"/>
                      <path d="M0.250072 17.4013V13.0625C0.250071 12.6939 0.251732 12.3519 0.252676 12.0336L0.250072 12.031V4.85203C0.250131 2.31054 2.28237 0.25004 4.78911 0.25H7.48961C10.7054 0.25 13.7937 2.41325 17.0095 2.41328H18.6224C21.0627 2.41328 22.2833 2.41311 23.256 2.78732C24.773 3.37115 25.9709 4.58584 26.5468 6.12377C26.9161 7.11011 26.9166 8.34797 26.9166 10.8226C26.9166 11.3853 26.9157 11.9081 26.914 12.3953C26.9141 12.6076 26.9166 12.8297 26.9166 13.0625V17.4013C26.9166 19.8559 26.9331 21.1319 26.4643 22.0694C26.052 22.8939 25.4012 23.5555 24.592 23.9757C23.6719 24.4533 22.4165 24.436 20.0078 24.436V23.5347C21.2296 23.5347 22.1035 23.5385 22.7916 23.4863C23.4719 23.4347 23.8798 23.3331 24.1866 23.1739C24.8289 22.8404 25.3444 22.3166 25.6718 21.6619C25.8291 21.3473 25.9291 20.9302 25.98 20.237C26.0313 19.5361 26.0277 18.646 26.0277 17.4013V13.0625C26.0277 12.7766 26.0253 12.6747 26.0251 12.3962V12.3918C26.0268 11.9058 26.0277 11.3842 26.0277 10.8226C26.0277 9.57404 26.0275 8.67905 25.9834 7.97198C25.9398 7.27214 25.8559 6.81673 25.7161 6.44325C25.2303 5.14638 24.22 4.1219 22.9409 3.62958C22.5727 3.48793 22.124 3.40346 21.434 3.35939C20.7366 3.31485 19.8538 3.3145 18.6224 3.3145H17.0095C15.2296 3.31448 13.512 2.7164 11.9644 2.18533C10.3601 1.6348 8.92536 1.15122 7.48961 1.15122H4.78911C2.77332 1.15126 1.13902 2.80824 1.13896 4.85203V11.1324H1.14416L1.13896 13.0625V17.4013C1.13896 18.646 1.13535 19.5361 1.1867 20.237C1.23751 20.9302 1.33758 21.3473 1.49486 21.6619C1.82226 22.3166 2.33778 22.8404 2.98009 23.1739C3.28692 23.3331 3.69472 23.4347 4.37505 23.4863C5.06318 23.5385 5.93698 23.5347 7.15889 23.5347V24.436C4.7502 24.436 3.49474 24.4533 2.57471 23.9757C1.76551 23.5555 1.11468 22.8939 0.702326 22.0694C0.233557 21.1319 0.250072 19.8559 0.250072 17.4013ZM20.0078 23.5347V24.436H7.15889V23.5347H20.0078Z"/>
                      <path d="M22.9167 9.18874C23.1621 9.18874 23.3611 9.39049 23.3611 9.63935C23.3611 9.88822 23.1621 10.09 22.9167 10.09H4.25C4.00454 10.09 3.80556 9.88822 3.80556 9.63935C3.80556 9.39049 4.00454 9.18874 4.25 9.18874H22.9167Z"/>
                    </mask>
                    <path d="M0.250072 17.4013V13.0625C0.250071 12.6939 0.251732 12.3519 0.252676 12.0336L0.250072 12.031V4.85203C0.250131 2.31054 2.28237 0.25004 4.78911 0.25H7.48961C10.7054 0.25 13.7937 2.41325 17.0095 2.41328H18.6224C21.0627 2.41328 22.2833 2.41311 23.256 2.78732C24.773 3.37115 25.9709 4.58584 26.5468 6.12377C26.9161 7.11011 26.9166 8.34797 26.9166 10.8226C26.9166 11.3853 26.9157 11.9081 26.914 12.3953C26.9141 12.6076 26.9166 12.8297 26.9166 13.0625V17.4013C26.9166 19.8559 26.9331 21.1319 26.4643 22.0694C26.052 22.8939 25.4012 23.5555 24.592 23.9757C23.6719 24.4533 22.4165 24.436 20.0078 24.436V23.5347C21.2296 23.5347 22.1035 23.5385 22.7916 23.4863C23.4719 23.4347 23.8798 23.3331 24.1866 23.1739C24.8289 22.8404 25.3444 22.3166 25.6718 21.6619C25.8291 21.3473 25.9291 20.9302 25.98 20.237C26.0313 19.5361 26.0277 18.646 26.0277 17.4013V13.0625C26.0277 12.7766 26.0253 12.6747 26.0251 12.3962V12.3918C26.0268 11.9058 26.0277 11.3842 26.0277 10.8226C26.0277 9.57404 26.0275 8.67905 25.9834 7.97198C25.9398 7.27214 25.8559 6.81673 25.7161 6.44325C25.2303 5.14638 24.22 4.1219 22.9409 3.62958C22.5727 3.48793 22.124 3.40346 21.434 3.35939C20.7366 3.31485 19.8538 3.3145 18.6224 3.3145H17.0095C15.2296 3.31448 13.512 2.7164 11.9644 2.18533C10.3601 1.6348 8.92536 1.15122 7.48961 1.15122H4.78911C2.77332 1.15126 1.13902 2.80824 1.13896 4.85203V11.1324H1.14416L1.13896 13.0625V17.4013C1.13896 18.646 1.13535 19.5361 1.1867 20.237C1.23751 20.9302 1.33758 21.3473 1.49486 21.6619C1.82226 22.3166 2.33778 22.8404 2.98009 23.1739C3.28692 23.3331 3.69472 23.4347 4.37505 23.4863C5.06318 23.5385 5.93698 23.5347 7.15889 23.5347V24.436C4.7502 24.436 3.49474 24.4533 2.57471 23.9757C1.76551 23.5555 1.11468 22.8939 0.702326 22.0694C0.233557 21.1319 0.250072 19.8559 0.250072 17.4013ZM20.0078 23.5347V24.436H7.15889V23.5347H20.0078Z" fill="white"/>
                    <path d="M22.9167 9.18874C23.1621 9.18874 23.3611 9.39049 23.3611 9.63935C23.3611 9.88822 23.1621 10.09 22.9167 10.09H4.25C4.00454 10.09 3.80556 9.88822 3.80556 9.63935C3.80556 9.39049 4.00454 9.18874 4.25 9.18874H22.9167Z" fill="white"/>
                    <path d="M20.0078 24.436H20.1328V23.5347H20.0078H19.8828V24.436H20.0078ZM7.15889 23.5347H7.03389V24.436H7.15889H7.28389V23.5347H7.15889ZM0.250072 13.0625H0.500072V13.0625H0.250072ZM0.252676 12.0336L0.502675 12.0344L0.50298 11.9314L0.430667 11.8581L0.252676 12.0336ZM0.250072 12.031H7.15554e-05V12.1335L0.0720806 12.2065L0.250072 12.031ZM0.250072 4.85203L7.15554e-05 4.85203V4.85203H0.250072ZM4.78911 0.25V0H4.78911L4.78911 0.25ZM7.48961 0.25V0V0V0.25ZM17.0095 2.41328L17.0095 2.66328H17.0095V2.41328ZM18.6224 2.41328V2.16328V2.41328ZM23.256 2.78732L23.3458 2.55401L23.3458 2.55399L23.256 2.78732ZM26.5468 6.12377L26.7809 6.03612L26.7809 6.0361L26.5468 6.12377ZM26.9166 10.8226H26.6666H26.9166ZM26.914 12.3953L26.664 12.3945V12.3955L26.914 12.3953ZM26.9166 13.0625H26.6666V13.0625H26.9166ZM26.4643 22.0694L26.6879 22.1812L26.6879 22.1812L26.4643 22.0694ZM24.592 23.9757L24.7071 24.1976L24.7072 24.1976L24.592 23.9757ZM22.7916 23.4863L22.8105 23.7356H22.8105L22.7916 23.4863ZM24.1866 23.1739L24.3017 23.3958L24.3018 23.3958L24.1866 23.1739ZM25.6718 21.6619L25.8954 21.7737L25.8954 21.7737L25.6718 21.6619ZM25.98 20.237L26.2293 20.2553L26.2293 20.2553L25.98 20.237ZM26.0277 13.0625H25.7777V13.0625H26.0277ZM26.0251 12.3962H25.7751V12.3964L26.0251 12.3962ZM26.0251 12.3918L25.7751 12.391V12.3918H26.0251ZM26.0277 10.8226H25.7777H26.0277ZM25.9834 7.97198L26.233 7.95642V7.95641L25.9834 7.97198ZM25.7161 6.44325L25.9502 6.35559L25.9502 6.35556L25.7161 6.44325ZM22.9409 3.62958L23.0307 3.39626L23.0307 3.39625L22.9409 3.62958ZM21.434 3.35939L21.4499 3.10989L21.4499 3.10989L21.434 3.35939ZM18.6224 3.3145V3.0645V3.3145ZM17.0095 3.3145L17.0095 3.5645H17.0095V3.3145ZM11.9644 2.18533L12.0456 1.94887V1.94887L11.9644 2.18533ZM7.48961 1.15122V0.90122V0.90122V1.15122ZM4.78911 1.15122V0.90122H4.7891L4.78911 1.15122ZM1.13896 4.85203L0.888955 4.85202V4.85203H1.13896ZM1.13896 11.1324H0.888955V11.3824H1.13896V11.1324ZM1.14416 11.1324L1.39416 11.1331L1.39484 10.8824H1.14416V11.1324ZM1.13896 13.0625L0.888955 13.0618V13.0625H1.13896ZM1.1867 20.237L0.937367 20.2553L0.937367 20.2553L1.1867 20.237ZM1.49486 21.6619L1.27124 21.7737L1.27126 21.7737L1.49486 21.6619ZM2.98009 23.1739L2.86489 23.3958L2.86494 23.3958L2.98009 23.1739ZM4.37505 23.4863L4.35614 23.7356H4.35614L4.37505 23.4863ZM7.15889 23.5347V23.2847V23.2847V23.5347ZM7.15889 24.436V24.186V24.186V24.436ZM2.57471 23.9757L2.45951 24.1975L2.45952 24.1976L2.57471 23.9757ZM0.702326 22.0694L0.47872 22.1812L0.478727 22.1812L0.702326 22.0694ZM0.250072 17.4013H0.500072V13.0625H0.250072H7.15554e-05V17.4013H0.250072ZM0.250072 13.0625H0.500072C0.500071 12.6944 0.501729 12.3532 0.502675 12.0344L0.252676 12.0336L0.0026768 12.0329C0.00173476 12.3506 7.13617e-05 12.6934 7.15554e-05 13.0625H0.250072ZM0.252676 12.0336L0.430667 11.8581L0.428063 11.8554L0.250072 12.031L0.0720806 12.2065L0.0746847 12.2092L0.252676 12.0336ZM0.250072 12.031H0.500072V4.85203H0.250072H7.15554e-05V12.031H0.250072ZM0.250072 4.85203L0.500072 4.85204C0.500128 2.44535 2.42368 0.500037 4.78911 0.5L4.78911 0.25L4.78911 0C2.14106 4.17829e-05 0.000134528 2.17573 7.15554e-05 4.85203L0.250072 4.85203ZM4.78911 0.25V0.5H7.48961V0.25V0H4.78911V0.25ZM7.48961 0.25V0.5C9.04846 0.5 10.5843 1.02449 12.1684 1.56809C13.7363 2.10612 15.3526 2.66326 17.0095 2.66328L17.0095 2.41328L17.0095 2.16328C15.4507 2.16326 13.9149 1.63877 12.3307 1.09516C10.7628 0.557138 9.14656 4.47035e-08 7.48961 0V0.25ZM17.0095 2.41328V2.66328H18.6224V2.41328V2.16328H17.0095V2.41328ZM18.6224 2.41328V2.66328C19.8457 2.66328 20.7516 2.66336 21.4736 2.70946C22.1935 2.75544 22.7134 2.84646 23.1663 3.02065L23.256 2.78732L23.3458 2.55399C22.8258 2.35398 22.2491 2.25797 21.5055 2.21048C20.7639 2.16312 19.8393 2.16328 18.6224 2.16328V2.41328ZM23.256 2.78732L23.1662 3.02064C24.6156 3.57848 25.7615 4.73965 26.3127 6.21145L26.5468 6.12377L26.7809 6.0361C26.1802 4.43203 24.9303 3.16382 23.3458 2.55401L23.256 2.78732ZM26.5468 6.12377L26.3127 6.21143C26.485 6.67173 26.5751 7.20009 26.6207 7.93064C26.6664 8.66315 26.6666 9.58221 26.6666 10.8226H26.9166H27.1666C27.1666 9.58837 27.1666 8.65118 27.1197 7.89952C27.0727 7.1459 26.9779 6.56216 26.7809 6.03612L26.5468 6.12377ZM26.9166 10.8226H26.6666C26.6666 11.3851 26.6657 11.9075 26.664 12.3945L26.914 12.3953L27.164 12.3962C27.1657 11.9086 27.1666 11.3856 27.1666 10.8226H26.9166ZM26.914 12.3953L26.664 12.3955C26.6641 12.6259 26.6666 12.8151 26.6666 13.0625H26.9166H27.1666C27.1666 12.8443 27.1641 12.5893 27.164 12.3952L26.914 12.3953ZM26.9166 13.0625H26.6666V17.4013H26.9166H27.1666V13.0625H26.9166ZM26.9166 17.4013H26.6666C26.6666 18.6335 26.6705 19.5545 26.6169 20.286C26.5635 21.0154 26.4539 21.5312 26.2407 21.9576L26.4643 22.0694L26.6879 22.1812C26.9436 21.67 27.0601 21.0791 27.1156 20.3225C27.1709 19.568 27.1666 18.6238 27.1666 17.4013H26.9166ZM26.4643 22.0694L26.2407 21.9576C25.8518 22.7353 25.2388 23.3582 24.4768 23.7538L24.592 23.9757L24.7072 24.1976C25.5636 23.7529 26.2522 23.0526 26.6879 22.1812L26.4643 22.0694ZM24.592 23.9757L24.4768 23.7538C24.0601 23.9701 23.555 24.0813 22.8392 24.1356C22.1212 24.1901 21.2171 24.186 20.0078 24.186V24.436V24.686C21.2071 24.686 22.1352 24.6905 22.877 24.6342C23.6211 24.5778 24.2037 24.4589 24.7071 24.1976L24.592 23.9757ZM20.0078 23.5347V23.7847C21.2245 23.7847 22.1105 23.7887 22.8105 23.7356L22.7916 23.4863L22.7727 23.2371C22.0965 23.2883 21.2348 23.2847 20.0078 23.2847V23.5347ZM22.7916 23.4863L22.8105 23.7356C23.5047 23.683 23.9514 23.5776 24.3017 23.3958L24.1866 23.1739L24.0714 22.952C23.8081 23.0886 23.439 23.1865 22.7727 23.2371L22.7916 23.4863ZM24.1866 23.1739L24.3018 23.3958C24.9913 23.0378 25.5446 22.4753 25.8954 21.7737L25.6718 21.6619L25.4482 21.5501C25.1442 22.1579 24.6665 22.643 24.0714 22.952L24.1866 23.1739ZM25.6718 21.6619L25.8954 21.7737C26.074 21.4166 26.1775 20.9619 26.2293 20.2553L25.98 20.237L25.7306 20.2187C25.6808 20.8986 25.5842 21.278 25.4482 21.5501L25.6718 21.6619ZM25.98 20.237L26.2293 20.2553C26.2815 19.5429 26.2777 18.6411 26.2777 17.4013H26.0277H25.7777C25.7777 18.651 25.7811 19.5294 25.7306 20.2188L25.98 20.237ZM26.0277 17.4013H26.2777V13.0625H26.0277H25.7777V17.4013H26.0277ZM26.0277 13.0625H26.2777C26.2777 12.9187 26.2771 12.8211 26.2765 12.7249C26.2758 12.6289 26.2752 12.5345 26.2751 12.3961L26.0251 12.3962L25.7751 12.3964C25.7752 12.5364 25.7758 12.6322 25.7765 12.7282C25.7771 12.824 25.7777 12.9203 25.7777 13.0625H26.0277ZM26.0251 12.3962H26.2751V12.3918H26.0251H25.7751V12.3962H26.0251ZM26.0251 12.3918L26.2751 12.3927C26.2768 11.9063 26.2777 11.3845 26.2777 10.8226H26.0277H25.7777C25.7777 11.3839 25.7768 11.9052 25.7751 12.391L26.0251 12.3918ZM26.0277 10.8226H26.2777C26.2777 9.57727 26.2777 8.6731 26.233 7.95642L25.9834 7.97198L25.7339 7.98754C25.7774 8.685 25.7777 9.57082 25.7777 10.8226H26.0277ZM25.9834 7.97198L26.233 7.95641C26.1886 7.24509 26.1024 6.76198 25.9502 6.35559L25.7161 6.44325L25.4819 6.5309C25.6095 6.87149 25.691 7.29918 25.7339 7.98754L25.9834 7.97198ZM25.7161 6.44325L25.9502 6.35556C25.4397 4.99257 24.3773 3.91458 23.0307 3.39626L22.9409 3.62958L22.8511 3.86289C24.0627 4.32923 25.021 5.3002 25.482 6.53094L25.7161 6.44325ZM22.9409 3.62958L23.0307 3.39625C22.6288 3.24165 22.1517 3.15472 21.4499 3.10989L21.434 3.35939L21.418 3.60888C22.0964 3.65221 22.5166 3.73421 22.8512 3.8629L22.9409 3.62958ZM21.434 3.35939L21.4499 3.10989C20.7427 3.06473 19.8505 3.0645 18.6224 3.0645V3.3145V3.5645C19.857 3.5645 20.7305 3.56497 21.4181 3.60888L21.434 3.35939ZM18.6224 3.3145V3.0645H17.0095V3.3145V3.5645H18.6224V3.3145ZM17.0095 3.3145L17.0095 3.0645C15.2785 3.06448 13.601 2.48263 12.0456 1.94887L11.9644 2.18533L11.8833 2.4218C13.423 2.95018 15.1806 3.56448 17.0095 3.5645L17.0095 3.3145ZM11.9644 2.18533L12.0456 1.94887C10.4497 1.40125 8.97453 0.90122 7.48961 0.90122V1.15122V1.40122C8.8762 1.40122 10.2705 1.86836 11.8833 2.4218L11.9644 2.18533ZM7.48961 1.15122V0.90122H4.78911V1.15122V1.40122H7.48961V1.15122ZM4.78911 1.15122L4.7891 0.90122C2.63201 0.901262 0.889019 2.67343 0.888955 4.85202L1.13896 4.85203L1.38896 4.85204C1.38901 2.94305 2.91463 1.40126 4.78911 1.40122L4.78911 1.15122ZM1.13896 4.85203H0.888955V11.1324H1.13896H1.38896V4.85203H1.13896ZM1.13896 11.1324V11.3824H1.14416V11.1324V10.8824H1.13896V11.1324ZM1.13896 13.0625H0.888955V17.4013H1.13896H1.38896V13.0625H1.13896ZM1.13896 17.4013H0.888955C0.888955 18.6411 0.885175 19.5429 0.937367 20.2553L1.1867 20.237L1.43603 20.2188C1.38553 19.5294 1.38896 18.6509 1.38896 17.4013H1.13896ZM1.1867 20.237L0.937367 20.2553C0.989159 20.9618 1.0927 21.4166 1.27124 21.7737L1.49486 21.6619L1.71847 21.5501C1.58245 21.278 1.48586 20.8986 1.43603 20.2187L1.1867 20.237ZM1.49486 21.6619L1.27126 21.7737C1.6221 22.4753 2.1754 23.0378 2.86489 23.3958L2.98009 23.1739L3.09529 22.952C2.50017 22.643 2.02242 22.1579 1.71846 21.5501L1.49486 21.6619ZM2.98009 23.1739L2.86494 23.3958C3.21525 23.5776 3.66185 23.683 4.35614 23.7356L4.37505 23.4863L4.39396 23.2371C3.72759 23.1865 3.3586 23.0887 3.09524 22.952L2.98009 23.1739ZM4.37505 23.4863L4.35614 23.7356C5.05621 23.7887 5.94212 23.7847 7.15889 23.7847L7.15889 23.5347V23.2847C5.93184 23.2847 5.07016 23.2883 4.39395 23.2371L4.37505 23.4863ZM7.15889 24.436V24.186C5.94951 24.186 5.0455 24.1901 4.32746 24.1357C3.61166 24.0814 3.10652 23.9701 2.6899 23.7538L2.57471 23.9757L2.45952 24.1976C2.96293 24.4589 3.54554 24.5778 4.28964 24.6342C5.03151 24.6905 5.95958 24.686 7.15889 24.686L7.15889 24.436ZM2.57471 23.9757L2.68991 23.7538C1.92792 23.3582 1.31485 22.7353 0.925925 21.9576L0.702326 22.0694L0.478727 22.1812C0.9145 23.0526 1.6031 23.7529 2.45951 24.1975L2.57471 23.9757ZM0.702326 22.0694L0.925932 21.9576C0.712764 21.5313 0.603216 21.0154 0.549741 20.286C0.496118 19.5545 0.500072 18.6334 0.500072 17.4013H0.250072H7.15554e-05C7.15554e-05 18.6238 -0.00423172 19.568 0.0510795 20.3225C0.10654 21.0791 0.223119 21.67 0.47872 22.1812L0.702326 22.0694ZM20.0078 24.436V24.186H7.15889V24.436V24.686H20.0078V24.436ZM7.15889 23.5347V23.7847H20.0078V23.5347V23.2847H7.15889V23.5347ZM1.14416 11.1324L0.894165 11.1317L0.888956 13.0618L1.13896 13.0625L1.38895 13.0631L1.39416 11.1331L1.14416 11.1324ZM22.9167 9.18874V9.43874C23.0208 9.43874 23.1111 9.5253 23.1111 9.63935H23.3611H23.6111C23.6111 9.25568 23.3034 8.93874 22.9167 8.93874V9.18874ZM23.3611 9.63935H23.1111C23.1111 9.75341 23.0208 9.83996 22.9167 9.83996V10.09V10.34C23.3034 10.34 23.6111 10.023 23.6111 9.63935H23.3611ZM22.9167 10.09V9.83996H4.25V10.09V10.34H22.9167V10.09ZM4.25 10.09V9.83996C4.14585 9.83996 4.05556 9.75341 4.05556 9.63935H3.80556H3.55556C3.55556 10.023 3.86323 10.34 4.25 10.34V10.09ZM3.80556 9.63935H4.05556C4.05556 9.5253 4.14585 9.43874 4.25 9.43874V9.18874V8.93874C3.86323 8.93874 3.55556 9.25568 3.55556 9.63935H3.80556ZM4.25 9.18874V9.43874H22.9167V9.18874V8.93874H4.25V9.18874Z" fill="white" mask="url(#path-1-outside-1_3090_5645)"/>
                  </svg>
                </button>
              </div>
            </div>
          )}
        </ViewerContainer>

        {/* 텍스트 선택 툴바 - Portal로 body에 렌더링하여 overflow: hidden 클리핑 방지 */}
        {toolbarPosition && selectedRange && !clickedAnnotation && !showLearningRecords && createPortal(
          <SelectionToolbar ref={toolbarRef} $x={toolbarPosition.x} $y={toolbarPosition.y} data-toolbar>
            {/* 모달1: 메모, 밑줄, 하이라이트, 텍스트 복사 */}
            <ToolbarRegion>
              <ToolbarButton $variant="note" onClick={handleSaveNote} title="메모">
                <img src="/images/icons/toolbar/memo.svg" alt="메모" />
              </ToolbarButton>
              <ToolbarButton $variant="underline" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const rect = e.currentTarget.getBoundingClientRect();
                setHighlightDropdownPosition({ x: rect.left + rect.width / 2, y: rect.bottom + 8 });
                setShowUnderlineColorPicker(true);
                setShowHighlightColorPicker(false);
                setShowHighlightDropdown(true);
              }} title="밑줄">
                <img src="/images/icons/toolbar/underline.svg" alt="밑줄" />
              </ToolbarButton>
              <ToolbarButton $variant="highlight" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const rect = e.currentTarget.getBoundingClientRect();
                setHighlightDropdownPosition({ x: rect.left + rect.width / 2, y: rect.bottom + 8 });
                setShowHighlightColorPicker(true);
                setShowUnderlineColorPicker(false);
                setShowHighlightDropdown(true);
              }} title="하이라이트">
                <img src="/images/icons/toolbar/highlight.svg" alt="하이라이트" />
              </ToolbarButton>
              <ToolbarButton $variant="copy" onClick={() => {
                const selection = window.getSelection();
                if (selection?.toString().trim()) {
                  navigator.clipboard.writeText(selection.toString().trim());
                  window.getSelection()?.removeAllRanges();
                  closeAllToolbars();
                  setShowCopyToast(true);
                  setTimeout(() => setShowCopyToast(false), 2000);
                }
              }} title="텍스트 복사">
                <img src="/images/icons/toolbar/copy.svg" alt="텍스트 복사" />
              </ToolbarButton>
            </ToolbarRegion>
            {/* 모달2: 뿍챗 */}
            <ToolbarRegion onClick={() => {
                const selection = window.getSelection();
                const selectedText = selection?.toString().trim() || '';
                if (selectedText) {
                  if (selectedText.length > 5000) {
                    setShowTextTooLongModal(true);
                    return;
                  }
                  closeAllToolbars();
                  setAiSelectedText(selectedText);
                  setAiPanelMode('chat');
                  window.getSelection()?.removeAllRanges();
                  setShowAIPanel(true);
                }
              }}>
              <ToolbarButton $variant="chat">
                <img src="/images/icons/toolbar/chat.svg" alt="" />
                뿍챗
              </ToolbarButton>
            </ToolbarRegion>
            {/* 모달3: 퀴즈 */}
            <ToolbarRegion onClick={() => {
                const selection = window.getSelection();
                if (selection?.toString().trim()) {
                  closeAllToolbars();
                  setAiSelectedText(selection.toString().trim());
                  setAiPanelMode('quiz');
                  window.getSelection()?.removeAllRanges();
                  setShowAIPanel(true);
                }
              }} title="퀴즈 생성">
              <ToolbarButton $variant="highlight">
                <img src="/images/icons/toolbar/quiz.svg" alt="" />
                퀴즈
              </ToolbarButton>
            </ToolbarRegion>
          </SelectionToolbar>,
          document.body
        )}

        {/* 하이라이트/밑줄 색상 선택기 팝오버 - Portal로 body에 렌더링 */}
        {showHighlightDropdown && highlightDropdownPosition && (showHighlightColorPicker || showUnderlineColorPicker) && createPortal(
          <>
            <DropdownMenuOverlay onClick={(e) => {
              const target = e.target as HTMLElement;
              if (target.closest('[data-color-picker]')) return;
              setShowHighlightDropdown(false);
              setShowHighlightColorPicker(false);
              setShowUnderlineColorPicker(false);
            }} />
            <DropdownMenuContainer $x={highlightDropdownPosition.x} $y={highlightDropdownPosition.y} onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
              {showHighlightColorPicker && (
                <div
                  data-color-picker="highlight"
                  style={{
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    padding: '8px',
                    display: 'flex',
                    gap: '8px',
                    zIndex: 10003,
                  }}
                >
                  {(Object.entries(STUDENT_MARKER_COLORS) as [StudentMarkerColorType, string][]).map(([colorKey, colorValue]) => (
                    <button
                      key={colorKey}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowHighlightDropdown(false);
                        setShowHighlightColorPicker(false);
                        handleSaveHighlight(e, colorValue);
                      }}
                      style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        backgroundColor: colorValue,
                        border: selectedMarkerColor === colorKey ? '2px solid #333' : '1px solid #ccc',
                        cursor: 'pointer',
                      }}
                      title={colorKey === 'pink' ? '연한 핑크' : colorKey === 'lavender' ? '연한 라벤더' : '연한 민트'}
                    />
                  ))}
                </div>
              )}
              {showUnderlineColorPicker && (
                <div
                  data-color-picker="underline"
                  style={{
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    padding: '8px',
                    display: 'flex',
                    gap: '8px',
                    zIndex: 10003,
                  }}
                >
                  {(Object.entries(STUDENT_MARKER_COLORS) as [StudentMarkerColorType, string][]).map(([colorKey, colorValue]) => (
                    <button
                      key={colorKey}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowHighlightDropdown(false);
                        setShowUnderlineColorPicker(false);
                        handleSaveUnderline(e, colorValue);
                      }}
                      style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        backgroundColor: colorValue,
                        border: selectedMarkerColor === colorKey ? '2px solid #333' : '1px solid #ccc',
                        cursor: 'pointer',
                      }}
                      title={colorKey === 'pink' ? '연한 핑크' : colorKey === 'lavender' ? '연한 라벤더' : '연한 민트'}
                    />
                  ))}
                </div>
              )}
            </DropdownMenuContainer>
          </>,
          document.body
        )}


        {/* 녹음 모달 */}
        <RecordingModalComponent
          isOpen={isRecordingModalOpen}
          micErrorModal={micErrorModal}
          onCloseMicError={closeMicErrorModal}
          isPermissionRequestModalOpen={isPermissionRequestModalOpen}
          onOpenPermissionRequestModal={openPermissionRequestModal}
          onClosePermissionRequestModal={closePermissionRequestModal}
          onConfirmPermissionAndStart={confirmPermissionAndStartRecording}
          isRecording={isRecording}
          isPaused={isPaused}
          recordingTime={recordingTime}
          isUploading={isUploading}
          isPlaying={isPlaying}
          audioChunksLength={audioChunksRef.current.length}
          fileName={fileName}
          setFileName={setFileName}
          baseFileName={baseFileName}
          onStartRecording={startRecordingWithModal}
          onStopRecording={stopRecording}
          onPauseRecording={pauseRecording}
          onResumeRecording={resumeRecording}
          onCancelRecording={cancelRecording}
          onCloseModal={closeRecordingModalOnly}
          onUploadRecording={handleUploadWithOptimistic}
          onResetRecording={resetRecording}
          onPlayPreview={playPreview}
          onStopPreview={stopPreview}
          formatRecordingTime={formatTime}
          progressPercent={getProgressPercent()}
          showTitleInput={true}
          closeOnOutsideClick={true}
        />

        {/* 선택 텍스트 길이 초과 알림 모달 */}
        <Modal
          isOpen={showTextTooLongModal}
          onClose={() => setShowTextTooLongModal(false)}
          title="안내"
        >
          <p>텍스트 길이가 너무 깁니다. 5천자 이내로 선택해 주세요.</p>
        </Modal>

        {/* 클릭된 주석 툴바 - Portal로 body에 렌더링 */}
        {/* 공유 폴더 어노테이션(_isSharedFolder)은 삭제 버튼을 표시하지 않음 */}
        {toolbarPosition && clickedAnnotation && !showAIPanel && openModals.size === 0 && !showTextTooLongModal && !isRecordingModalOpen && !micErrorModal && !isPermissionRequestModalOpen && !hasFolderDetailModalOpen && !(clickedAnnotation as Annotation & { _isSharedFolder?: boolean })._isSharedFolder && createPortal(
          <SelectionToolbar ref={toolbarRef} $x={toolbarPosition.x} $y={toolbarPosition.y} data-toolbar>
            <ToolbarButton $variant="remove" onClick={() => handleRemoveAnnotation(clickedAnnotation.id)}>삭제</ToolbarButton>
          </SelectionToolbar>,
          document.body
        )}

        {/* 새 메모 생성 모달은 openModals에서 렌더링 (수정 모달과 동일한 스타일) */}
        {/* 여러 메모 모달 렌더링 - 페이지 로딩 완료 후에만 표시 */}
        {isContentReady && (!showGoBackButton || highlightMarkerPosition) && Array.from(openModals.entries()).map(([annotationId, modalData]) => {
          const { noteTitle: modalNoteTitle, noteText: modalNoteText, noteColor: modalNoteColor, showNoteMenu: modalShowNoteMenu, showColorPicker: modalShowColorPicker, isNoteEditMode: modalIsNoteEditMode, editingAnnotation: modalEditingAnnotation, position: modalPosition, originalNoteTitle, originalNoteText, canEdit: modalCanEdit } = modalData;
          const canEditMemo = modalCanEdit !== false;
          
          // 변경사항 확인 함수
          const hasChanges = () => {
            if (!modalEditingAnnotation) return true; // 새 메모는 항상 저장
            const currentContent = `${modalNoteTitle}\n${modalNoteText}`.trim();
            const originalContent = `${originalNoteTitle || ''}\n${originalNoteText || ''}`.trim();
            return currentContent !== originalContent;
          };
          
          // 모달 닫기 핸들러 (변경사항이 있으면 자동 저장)
          const handleCloseModal = async (e?: React.MouseEvent) => {
            e?.stopPropagation();
            
            // 수정 모드이고 변경사항이 있으면 자동 저장
            if (modalIsNoteEditMode && hasChanges()) {
              if (modalEditingAnnotation) {
                // 수정 모달인 경우
                await handleConfirmNoteForModal(annotationId);
              } else {
                // 새 메모 생성인 경우
                await handleConfirmNoteForNewModal(annotationId);
              }
            } else {
              // 변경사항이 없으면 그냥 닫기
              setOpenModals(prev => {
                const newMap = new Map(prev);
                newMap.delete(annotationId);
                return newMap;
              });
              if (annotationId === newNoteModalId) {
                setNewNoteModalId(null);
                setIsModalOpen(false);
              }
            }
          };
          
          return (
            <StickyNoteModal 
              key={annotationId}
              $color={modalNoteColor} 
              $position={modalPosition}
              data-sticky-note-modal={annotationId}
              onClick={(e) => { 
                e.stopPropagation(); 
                setCurrentModalData(annotationId, { showNoteMenu: false, showColorPicker: false });
              }}
            >
                <NoteModalHeader style={{ borderColor: modalNoteColor === 'green' ? '#C1DC9B' : modalNoteColor === 'blue' ? '#C2D2E1' : '#E3E4A7', opacity: 1 }}>
                  <NoteModalTitle 
                    placeholder="제목을 입력하세요" 
                    value={modalNoteTitle} 
                    onChange={(e) => setCurrentModalData(annotationId, { noteTitle: e.target.value })} 
                    disabled={!modalIsNoteEditMode} 
                    autoFocus={modalIsNoteEditMode} 
                  />
                  <NoteModalHeaderActions>
                    {canEditMemo && (
                    <div style={{ position: 'relative' }}>
                      <NoteModalIconButton onClick={(e) => { 
                        e.stopPropagation(); 
                        setCurrentModalData(annotationId, { showNoteMenu: !modalShowNoteMenu, showColorPicker: false });
                      }} title="더보기">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <circle cx="7.00027" cy="7.00027" r="0.72" fill="#6B6B6B"/>
                          <circle cx="11.0403" cy="7.00027" r="0.72" fill="#6B6B6B"/>
                          <circle cx="2.96023" cy="7.00027" r="0.72" fill="#6B6B6B"/>
                        </svg>
                      </NoteModalIconButton>
                      {modalShowNoteMenu && (
                        <NoteMenuDropdown onClick={(e) => e.stopPropagation()}>
                          <NoteMenuItem onClick={() => { 
                            setCurrentModalData(annotationId, { isNoteEditMode: true, showNoteMenu: false });
                          }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                            수정
                          </NoteMenuItem>
                          {/* 색상 선택 메뉴 주석처리 (향후 복구 예정) */}
                          {/* <NoteMenuItem onClick={() => { 
                            setCurrentModalData(annotationId, { showColorPicker: !modalShowColorPicker, showNoteMenu: false });
                          }}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 2a10 10 0 0 1 0 20" fill="currentColor" /></svg>
                            색상
                          </NoteMenuItem> */}
                          {/* 공유 폴더 어노테이션은 삭제 메뉴를 표시하지 않음 */}
                          {!(modalEditingAnnotation as Annotation & { _isSharedFolder?: boolean })?._isSharedFolder && (
                            <NoteMenuItem onClick={() => {
                              if (modalEditingAnnotation) {
                                if (window.confirm('이 메모를 삭제하시겠습니까?')) {
                                  handleRemoveAnnotation(modalEditingAnnotation.id);
                                  // handleRemoveAnnotation 내부에서 모달 제거 처리됨
                                  return;
                                }
                              }
                              // 삭제 취소 시에만 메뉴 닫기
                              setCurrentModalData(annotationId, { showNoteMenu: false });
                            }}>
                              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                              </svg>
                              삭제
                            </NoteMenuItem>
                          )}
                        </NoteMenuDropdown>
                      )}
                    </div>
                    )}
                    <NoteModalIconButton onClick={handleCloseModal} title="닫기">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M3.5 3.5L10.5 10.5" stroke="#6B6B6B" strokeWidth="0.875" strokeLinecap="round"/>
                        <path d="M10.5 3.5L3.5 10.5" stroke="#6B6B6B" strokeWidth="0.875" strokeLinecap="round"/>
                      </svg>
                    </NoteModalIconButton>
                  </NoteModalHeaderActions>
                </NoteModalHeader>
                <NoteModalContent>
                  {modalIsNoteEditMode ? (
                    <NoteModalTextarea 
                      placeholder="(텍스트) 메모 내용을 입력하세요...&#10;(오토링크) www.링크.com" 
                      value={modalNoteText} 
                      onChange={(e) => setCurrentModalData(annotationId, { noteText: e.target.value })} 
                    />
                  ) : (
                    <NoteModalText>
                      {modalNoteText ? parseTextWithLinks(modalNoteText).map((part, index) => {
                        // React 요소인 경우 그대로 반환
                        if (React.isValidElement(part)) {
                          return part;
                        }
                        // 문자열인 경우 그대로 반환
                        return <React.Fragment key={`modal-part-${index}`}>{part}</React.Fragment>;
                      }) : '내용이 없습니다.'}
                    </NoteModalText>
                  )}
                </NoteModalContent>
                {/* 첨부파일 영역 주석처리 (향후 복구 예정) */}
                {/* <NoteModalAttachments style={{ borderColor: modalNoteColor === 'green' ? '#C1DC9B' : modalNoteColor === 'blue' ? '#C2D2E1' : '#E3E4A7', opacity: 1 }}>
                  <AttachmentList>
                    {modalData.noteAttachments.map((attachment) => (
                      <AttachmentItem key={attachment.id}>
                        <AttachmentName>{attachment.name}</AttachmentName>
                        <AttachmentDeleteButton onClick={() => {
                          setCurrentModalData(annotationId, {
                            noteAttachments: modalData.noteAttachments.filter(att => att.id !== attachment.id)
                          });
                        }}>삭제</AttachmentDeleteButton>
                      </AttachmentItem>
                    ))}
                  </AttachmentList>
                  <input type="file" ref={noteFileInputRef} style={{ display: 'none' }} onChange={handleAddNoteAttachment} multiple accept=".jpg,.jpeg,.png,.gif,.pdf,.zip,.doc,.docx" />
                  <AddAttachmentButton onClick={() => noteFileInputRef.current?.click()} title="파일 첨부">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                  </AddAttachmentButton>
                </NoteModalAttachments> */}
                {/* 취소/저장 버튼 제거 - 닫기 버튼 클릭 시 자동 저장 */}
                {/* <NoteModalFooter>
                  <Button onClick={(e) => {
                    e.stopPropagation();
                    setOpenModals(prev => {
                      const newMap = new Map(prev);
                      newMap.delete(annotationId);
                      return newMap;
                    });
                    if (annotationId === newNoteModalId) {
                      setNewNoteModalId(null);
                      setIsModalOpen(false);
                    }
                  }}>{modalIsNoteEditMode ? '취소' : '닫기'}</Button>
                  {modalIsNoteEditMode && (
                    <Button $variant="primary" onClick={(e) => {
                      e.stopPropagation();
                      if (modalEditingAnnotation) {
                        // 수정 모달인 경우
                        handleConfirmNoteForModal(annotationId);
                      } else {
                        // 새 메모 생성인 경우 - annotationId를 전달하여 처리
                        handleConfirmNoteForNewModal(annotationId);
                      }
                    }}>저장</Button>
                  )}
                </NoteModalFooter> */}
              </StickyNoteModal>
            );
          })}

        {/* 학습 기록 패널 - 왼쪽 끝에 고정 (단독/둘 다 열림 동일 구조로 데이터 유지) */}
          {showLearningRecords && (isStudent || isProfessor) && (
            <>
              <ResizeHandleHorizontal
                style={{ position: 'fixed', bottom: panelBottom + panelHeight, left: learningRecordsLeft, width: learningRecordsWidth, zIndex: 101 }}
                onMouseDown={handleTopResizeStart}
                onTouchStart={handleTopResizeStart}
              />
              <ResizeHandleHorizontal
                style={{ position: 'fixed', bottom: panelBottom - 4, left: learningRecordsLeft, width: learningRecordsWidth, height: 8, zIndex: 101 }}
                onMouseDown={handleBottomResizeStart}
                onTouchStart={handleBottomResizeStart}
              />
              <FixedLearningRecordsContainer $hasAIPanel={false} $standalone $width={learningRecordsWidth} $left={learningRecordsLeft} $bottom={panelBottom} data-learning-panel="true">
                <ResizeHandleVertical
                  style={{ position: 'absolute', left: 0, top: 0, bottom: 0, marginLeft: -4 }}
                  onMouseDown={handleLearningRecordsLeftResizeStart}
                  onTouchStart={handleLearningRecordsLeftResizeStart}
                />
                <PanelWrapper $height={panelHeight}>
                  <LearningRecordsPanel
                    onToggle={() => {
                      setLearningRecordsScrollTopSnapshot(learningRecordsScrollTopRef.current);
                      setShowLearningRecords(false);
                    }}
                    bookUuid={bookUid}
                    onRecordClick={handleLearningRecordClick}
                    onPageClick={handleLearningRecordPageClick}
                    pendingRecordingCard={pendingRecordingCard}
                    onPendingRecordingCardClear={handleClearPendingCard}
                    onScrollTopChange={(top) => { learningRecordsScrollTopRef.current = top; }}
                    scrollTopRestore={learningRecordsScrollTopSnapshot}
                    restoreFolderUuid={restoreFolderUuid}
                    onRestoreFolderConsumed={() => setRestoreFolderUuid(null)}
                  />
                </PanelWrapper>
                <ResizeHandleVertical
                  style={{ position: 'absolute', right: 0, top: 0, bottom: 0, marginRight: -4 }}
                  onMouseDown={handleLearningRecordsRightResizeStart}
                  onTouchStart={handleLearningRecordsRightResizeStart}
                />
              </FixedLearningRecordsContainer>
            </>
          )}
        {/* AI 패널 - 오른쪽 끝에 고정 (단독/둘 다 열림 동일 구조) */}
          {showAIPanel && (isStudent || isProfessor) && (
            <>
              <ResizeHandleHorizontal
                style={{ position: 'fixed', bottom: panelBottom + panelHeight, right: aiPanelRight, width: aiPanelWidth, zIndex: 101 }}
                onMouseDown={handleTopResizeStart}
                onTouchStart={handleTopResizeStart}
              />
              <ResizeHandleHorizontal
                style={{ position: 'fixed', bottom: panelBottom - 4, right: aiPanelRight, width: aiPanelWidth, height: 8, zIndex: 101 }}
                onMouseDown={handleBottomResizeStart}
                onTouchStart={handleBottomResizeStart}
              />
              <ResizeHandleVertical
                style={{ position: 'fixed', bottom: panelBottom, right: aiPanelRight + aiPanelWidth, height: panelHeight, zIndex: 102 }}
                onMouseDown={handleAIPanelLeftResizeStart}
                onTouchStart={handleAIPanelLeftResizeStart}
              />
              <ResizeHandleVertical
                style={{ position: 'fixed', bottom: panelBottom, right: aiPanelRight - 4, height: panelHeight, zIndex: 102 }}
                onMouseDown={handleAIPanelRightResizeStart}
                onTouchStart={handleAIPanelRightResizeStart}
              />
              <FixedAIPanelContainer $hasLearningRecords={false} $standalone $width={aiPanelWidth} $right={aiPanelRight} $bottom={panelBottom} data-ai-panel="true">
                <PanelWrapper $height={panelHeight}>
                  <AILearningPanel
                  onToggle={() => {
                    if (aiPanelMode === 'chat') {
                      setChatMessages([]);
                      setChatTitle(null);
                      setChatDialogNo(0);
                      setChatDialogUuid(null);
                      setChatNextCursor(null);
                      setChatHasMore(false);
                    } else {
                      setQuizMessages([]);
                      setQuizDialogNo(0);
                    }
                    setShowAIPanel(false);
                  }}
                  selectedText={aiSelectedText}
                  onClearSelectedText={() => setAiSelectedText('')}
                  bookUid={bookUid}
                  messages={aiPanelMode === 'chat' ? chatMessages : quizMessages}
                  onMessagesChange={aiPanelMode === 'chat' ? setChatMessages : setQuizMessages}
                  dialogNo={aiPanelMode === 'chat' ? chatDialogNo : quizDialogNo}
                  onDialogNoChange={aiPanelMode === 'chat' ? setChatDialogNo : setQuizDialogNo}
                  mode={aiPanelMode}
                  dialogUuid={aiPanelMode === 'chat' ? chatDialogUuid || undefined : undefined}
                  hasMoreChats={aiPanelMode === 'chat' ? chatHasMore : false}
                  onLoadMoreChats={aiPanelMode === 'chat' && chatDialogUuid ? handleLoadMoreChats : undefined}
                  pageNumber={currentPageNumber}
                  chatTitle={aiPanelMode === 'chat' ? (chatTitle ?? undefined) : undefined}
                  isProfessor={isProfessor}
                  onNewChat={() => {
                    if (aiPanelMode === 'chat') {
                      setChatMessages([]);
                      setChatTitle(null);
                      setChatDialogNo(0);
                      setChatDialogUuid(null);
                      setChatNextCursor(null);
                      setChatHasMore(false);
                    } else {
                      setQuizMessages([]);
                      setQuizDialogNo(0);
                    }
                  }}
                />
              </PanelWrapper>
            </FixedAIPanelContainer>
            </>
          )}

        {/* {!showLearningRecords && (isStudent || isProfessor) && (
          <CollapsedButton $position={learningRecordsPosition} onClick={() => {
            closeAllToolbars();
            setShowLearningRecords(true);
          }} aria-label="학습 기록 열기">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 4.16675L9.16667 6.11091M7.5 15.8334L12.5 10.0001L11.25 8.54175" stroke="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </CollapsedButton>
        )} */}

        {!showAIPanel && (isStudent || isProfessor) && (
          <>
            {/* <CollapsedButton $position={aiPanelPosition} $elevated onClick={() => {
              closeAllToolbars();
              setAiPanelMode('chat');
              setShowAIPanel(true);
            }} aria-label="AI 학습 패널 열기">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.5 15.8334L7.5 10.0001L8.75 8.54175M12.5 4.16675L10.8333 6.11091" stroke="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </CollapsedButton> */}
            {/* 학생 동기화 위치 버튼: 나중에를 눌렀을 때만 표시 */}
            {isStudent && showSyncLocationButton && syncPendingPageNo !== null && (
              <SyncLocationButton
                $position={aiPanelPosition}
                $isExpanded={isSyncLocationExpanded}
                onClick={() => {
                  if (isSyncLocationExpanded) {
                    if (syncPendingPageNo !== null) {
                      handleNavigateToPage(syncPendingPageNo);
                      setIsSyncLocationExpanded(false);
                      setShowSyncLocationButton(false);
                      setSyncPendingPageNo(null);
                    }
                  } else {
                    setIsSyncLocationExpanded(true);
                  }
                }}
                aria-label="최근 동기화위치로 이동"
                data-sync-location-button
              >
                <SyncLocationContent $isExpanded={isSyncLocationExpanded}>
                  <SyncLocationIcon>
                    <img src="/images/icons/user/book/sync_later.svg" alt="최근 동기화위치로 이동" />
                  </SyncLocationIcon>
                  {isSyncLocationExpanded && (
                    <SyncLocationText>최근 동기화위치로 이동</SyncLocationText>
                  )}
                </SyncLocationContent>
              </SyncLocationButton>
            )}
          </>
        )}

        {/* 학생 동기화 위치 버튼: AI 패널이 열려있을 때도 표시 */}
        {showAIPanel && isStudent && showSyncLocationButton && syncPendingPageNo !== null && (
          <SyncLocationButton
            $position={aiPanelPosition}
            $isExpanded={isSyncLocationExpanded}
            onClick={() => {
              if (isSyncLocationExpanded) {
                if (syncPendingPageNo !== null) {
                  handleNavigateToPage(syncPendingPageNo);
                  setIsSyncLocationExpanded(false);
                  setShowSyncLocationButton(false);
                  setSyncPendingPageNo(null);
                }
              } else {
                setIsSyncLocationExpanded(true);
              }
            }}
            aria-label="최근 동기화위치로 이동"
            data-sync-location-button
          >
            <SyncLocationContent $isExpanded={isSyncLocationExpanded}>
              <SyncLocationIcon>
                <img src="/images/icons/user/book/sync_later.svg" alt="최근 동기화위치로 이동" />
              </SyncLocationIcon>
              {isSyncLocationExpanded && (
                <SyncLocationText>최근 동기화위치로 이동</SyncLocationText>
              )}
            </SyncLocationContent>
          </SyncLocationButton>
        )}

        {/* 학습 기록 카드 클릭 후 되돌아가기 버튼 - 강조 표시 마커 중앙 위에 배치 */}
        {showGoBackButton && goBackPageNo !== null && isContentReady && highlightMarkerPosition && (
          <GoBackButtonWrapper
            $markerTop={highlightMarkerPosition.top}
            $markerLeft={highlightMarkerPosition.left}
          >
            <GoBackAction
              onClick={() => {
                const targetPage = goBackPageNo;
                const folderUuid = goBackFolderUuid;

                // 먼저 되돌아가기 관련 상태 모두 정리
                setShowGoBackButton(false);
                setGoBackPageNo(null);
                setGoBackFolderUuid(null);
                setHighlightedAnnotationId(null);
                setHighlightMarkerPosition(null);
                if (highlightTimerRef.current) {
                  clearTimeout(highlightTimerRef.current);
                  highlightTimerRef.current = null;
                }
                // 열린 메모 모달 닫기
                setOpenModals(new Map());
                setNewNoteModalId(null);

                // 학습기록 패널 다시 열기 + 공유폴더 모달 복원
                setRestoreFolderUuid(folderUuid);
                setShowLearningRecords(true);

                // 페이지 이동 (같은 페이지여도 동작)
                if (targetPage !== null) {
                  handleNavigateToPage(targetPage);
                }
              }}
              aria-label="되돌아 가기"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 5.25H11.25C12.2446 5.25 13.1984 5.64509 13.9017 6.34835C14.6049 7.05161 15 8.00544 15 9C15 9.99456 14.6049 10.9484 13.9017 11.6517C13.1984 12.3549 12.2446 12.75 11.25 12.75M3 5.25L5.25 3M3 5.25L5.25 7.5M6 12.75H8.25" stroke="white" strokeWidth="1.03846" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              되돌아 가기
              <GoBackClose
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShowGoBackButton(false);
                  setGoBackPageNo(null);
                }}
                aria-label="되돌아가기 버튼 닫기"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M6.5 0C5.21442 0 3.95772 0.381218 2.8888 1.09545C1.81988 1.80968 0.986756 2.82484 0.494786 4.01256C0.00281635 5.20028 -0.125905 6.50721 0.124899 7.76809C0.375703 9.02896 0.994767 10.1872 1.90381 11.0962C2.81285 12.0052 3.97104 12.6243 5.23192 12.8751C6.49279 13.1259 7.79973 12.9972 8.98744 12.5052C10.1752 12.0132 11.1903 11.1801 11.9046 10.1112C12.6188 9.04229 13 7.78558 13 6.5C12.9982 4.77665 12.3128 3.12441 11.0942 1.90582C9.8756 0.687224 8.22335 0.00181989 6.5 0ZM8.85375 8.14625C8.90021 8.19271 8.93706 8.24786 8.9622 8.30855C8.98734 8.36925 9.00028 8.4343 9.00028 8.5C9.00028 8.5657 8.98734 8.63075 8.9622 8.69145C8.93706 8.75214 8.90021 8.80729 8.85375 8.85375C8.8073 8.90021 8.75215 8.93705 8.69145 8.9622C8.63075 8.98734 8.5657 9.00028 8.5 9.00028C8.43431 9.00028 8.36925 8.98734 8.30855 8.9622C8.24786 8.93705 8.19271 8.90021 8.14625 8.85375L6.5 7.20687L4.85375 8.85375C4.8073 8.90021 4.75215 8.93705 4.69145 8.9622C4.63075 8.98734 4.5657 9.00028 4.5 9.00028C4.43431 9.00028 4.36925 8.98734 4.30855 8.9622C4.24786 8.93705 4.19271 8.90021 4.14625 8.85375C4.0998 8.80729 4.06295 8.75214 4.03781 8.69145C4.01266 8.63075 3.99972 8.5657 3.99972 8.5C3.99972 8.4343 4.01266 8.36925 4.03781 8.30855C4.06295 8.24786 4.0998 8.19271 4.14625 8.14625L5.79313 6.5L4.14625 4.85375C4.05243 4.75993 3.99972 4.63268 3.99972 4.5C3.99972 4.36732 4.05243 4.24007 4.14625 4.14625C4.24007 4.05243 4.36732 3.99972 4.5 3.99972C4.63268 3.99972 4.75993 4.05243 4.85375 4.14625L6.5 5.79313L8.14625 4.14625C8.19271 4.09979 8.24786 4.06294 8.30855 4.0378C8.36925 4.01266 8.43431 3.99972 8.5 3.99972C8.5657 3.99972 8.63075 4.01266 8.69145 4.0378C8.75215 4.06294 8.8073 4.09979 8.85375 4.14625C8.90021 4.1927 8.93706 4.24786 8.9622 4.30855C8.98734 4.36925 9.00028 4.4343 9.00028 4.5C9.00028 4.5657 8.98734 4.63075 8.9622 4.69145C8.93706 4.75214 8.90021 4.8073 8.85375 4.85375L7.20688 6.5L8.85375 8.14625Z" fill="#DBDBDB"/>
                </svg>
              </GoBackClose>
            </GoBackAction>
          </GoBackButtonWrapper>
        )}

        {/* 텍스트 복사 토스트 */}
        <CopyToast $isVisible={showCopyToast}>
          텍스트가 복사되었습니다
        </CopyToast>
      </Container>
    </Layout>
  );
};

export default BookViewer;
